(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sai-configuration", [], factory);
	else if(typeof exports === 'object')
		exports["sai-configuration"] = factory();
	else
		root["sai-configuration"] = factory();
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationUtils_1 = __webpack_require__(8);
var _Symbol = __webpack_require__(1);
var ConfigurationElement = /*#__PURE__*/function () {
  function ConfigurationElement(config, _context) {
    _classCallCheck(this, ConfigurationElement);
    this.config = config;
    this.context = _context;
    this.internalId = ConfigurationUtils_1["default"].guid();
  }
  _createClass(ConfigurationElement, [{
    key: "initialize",
    value: function initialize(lang) {
      return new Promise(function (accept) {
        accept(undefined);
      });
    }
  }, {
    key: "removeFromAsyncRequirement",
    value: function removeFromAsyncRequirement(prop) {
      var index = this.remainingAsyncProps.indexOf(prop);
      if (index > -1) {
        this.remainingAsyncProps.splice(index, 1);
      }
    }
  }, {
    key: "hasAsyncRequirements",
    value: function hasAsyncRequirements() {
      return this.remainingAsyncProps.length > 0;
    }
  }, {
    key: "getInternal",
    value: function getInternal() {
      return this.internalId;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.config.id;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return ConfigurationUtils_1["default"].getMultilangTextValue(this.config.label !== undefined ? this.config.label : this.getId());
    }
  }, {
    key: "setLabel",
    value: function setLabel(newValue) {
      this.config.label = newValue;
    }
  }, {
    key: "getValueOrDefault",
    value: function getValueOrDefault(id, defaultValue) {
      return this.config[id] !== undefined ? this.config[id] : defaultValue;
    }
  }, {
    key: "getNumberValueOrDefault",
    value: function getNumberValueOrDefault(id, defaultValue) {
      return this.config[id] !== undefined ? this.config[id] : defaultValue;
    }
  }, {
    key: "getBooleanValueOrDefault",
    value: function getBooleanValueOrDefault(id, defaultValue) {
      return this.config[id] !== undefined ? this.config[id] === 'true' || this.config[id] : defaultValue;
    }
  }, {
    key: "getClonedConfig",
    value: function getClonedConfig() {
      return JSON.parse(JSON.stringify(this.config));
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "setContext",
    value: function setContext(context) {
      this.context = context;
    }
  }, {
    key: "setDatefieldId",
    value: function setDatefieldId(id) {
      this.config.id = id;
    }
  }, {
    key: "setHelp",
    value: function setHelp(help) {
      this.config['help'] = help;
    }
  }, {
    key: "getHelpId",
    value: function getHelpId() {
      return undefined;
    }
  }], [{
    key: "getObjectType",
    value: function getObjectType(type) {
      return type.replace('Screen', '').replace('Object', '').replace('CoupleField', 'Couple').replace('SingleField', 'Field').replace('CheckboxField', 'Checkbox').toLowerCase();
    }
  }]);
  return ConfigurationElement;
}();
exports.ConfigurationElement = ConfigurationElement;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("es6-symbol");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var Group_1 = __webpack_require__(5);
var Level_1 = __webpack_require__(9);
var _Symbol = __webpack_require__(1);
var BasePanel = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(BasePanel, _ConfigurationElement);
  var _super = _createSuper(BasePanel);
  function BasePanel(config, parentTask, context) {
    var _this;
    _classCallCheck(this, BasePanel);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [BasePanel.ASYNC_PROP_LABEL];
    _this.groups = {};
    _this.groupsArr = [];
    _this.children = [];
    _this.parentTask = parentTask;
    for (var key in config.children) {
      var childConf = config.children[key];
      var cType = BasePanel.getObjectType(childConf.objectType);
      if (cType === BasePanel.CHILD_TYPE_LEVEL) {
        var newChild = new Level_1.Level(childConf, _assertThisInitialized(_this), undefined, undefined, context);
        _this.children.push(newChild);
      } else if (cType === BasePanel.CHILD_TYPE_GROUP) {
        var _newChild = new Group_1.Group(childConf, _assertThisInitialized(_this), undefined, context);
        _this.children.push(_newChild);
      } else {
        console.warn('Invalid child type in panel/page/subpanel : ' + cType);
      }
    }
    return _this;
  }
  _createClass(BasePanel, [{
    key: "getFields",
    value: function getFields() {
      var base = {};
      for (var grpId in this.groups) {
        Object.assign(base, this.groups[grpId].getI18NFields());
      }
      return base;
    }
  }, {
    key: "getParentTask",
    value: function getParentTask() {
      return this.parentTask;
    }
  }, {
    key: "getGroup",
    value: function getGroup(grpId) {
      return this.groups[grpId];
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      return this.groupsArr;
    }
  }, {
    key: "registerGroup",
    value: function registerGroup(newChild) {
      this.groupsArr.push(newChild);
      this.groups[newChild.getId()] = newChild;
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
      for (var grpId in this.groups) {
        this.groups[grpId].retrieveAsyncEntities(allEntities);
      }
    }
  }, {
    key: "getHelpId",
    value: function getHelpId() {
      return this.parentTask.getId() + '.Panel' + this.getId();
    }
  }], [{
    key: "setReadOnly",
    value: function setReadOnly(descriptor) {
      var setGroupReadOnly = function setGroupReadOnly(descriptor) {
        for (var child in descriptor.children) {
          var childElement = descriptor.children[child];
          var type = BasePanel.getObjectType(childElement.objectType);
          if (type === BasePanel.CHILD_TYPE_GROUP) {
            Group_1.Group.setReadOnly(childElement);
          } else if (type === BasePanel.CHILD_TYPE_LEVEL) {
            setGroupReadOnly(childElement);
          }
        }
      };
      setGroupReadOnly(descriptor);
    }
  }]);
  return BasePanel;
}(ConfigurationElement_1.ConfigurationElement);
BasePanel.CHILD_TYPE_LEVEL = 'level';
BasePanel.CHILD_TYPE_GROUP = 'group';
BasePanel.ASYNC_PROP_LABEL = _Symbol();
exports.BasePanel = BasePanel;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var _Symbol = __webpack_require__(1);
var Field = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Field, _ConfigurationElement);
  var _super = _createSuper(Field);
  function Field(config, parentTask, parentGroup, parentLevel, context) {
    var _this;
    _classCallCheck(this, Field);
    _this = _super.call(this, config, context);
    _this.parentGroup = parentGroup;
    _this.parentTask = parentTask;
    _this.parentLevel = parentLevel;
    if (_this.parentGroup) {
      _this.parentGroup.registerField(_assertThisInitialized(_this));
    }
    _this.remainingAsyncProps = [Field.ASYNC_PROP_LABEL, Field.ASYNC_PROP_COMBO];
    return _this;
  }
  _createClass(Field, [{
    key: "getGroup",
    value: function getGroup() {
      return this.parentGroup;
    }
  }, {
    key: "getTask",
    value: function getTask() {
      return this.parentTask;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.parentLevel;
    }
  }, {
    key: "getLinkedDataField",
    value: function getLinkedDataField() {
      return this.linkedDataField;
    }
  }, {
    key: "setLinkedDataField",
    value: function setLinkedDataField(df) {
      this.linkedDataField = df;
    }
  }, {
    key: "getLinkedCombo",
    value: function getLinkedCombo() {
      return this.linkedCombo;
    }
  }, {
    key: "setLinkedCombo",
    value: function setLinkedCombo(combo) {
      this.linkedCombo = combo;
    }
  }, {
    key: "setLinkedCouple",
    value: function setLinkedCouple(couple) {
      this.linkedCouple = couple;
    }
  }, {
    key: "getLinkedCouple",
    value: function getLinkedCouple() {
      return this.linkedCouple;
    }
  }, {
    key: "isCouple",
    value: function isCouple() {
      return this.linkedCouple !== undefined;
    }
  }, {
    key: "isAutoAddedSystemField",
    value: function isAutoAddedSystemField() {
      return this.getBooleanValueOrDefault('autoAddedSystemField', false);
    }
  }, {
    key: "getDatafieldId",
    value: function getDatafieldId() {
      return this.getValueOrDefault('datafieldId');
    }
  }, {
    key: "getPresentation",
    value: function getPresentation() {
      return this.getValueOrDefault('presentation', this.linkedDataField.getPresentation());
    }
  }, {
    key: "setPresentation",
    value: function setPresentation(newPres) {
      this.config.presentation = newPres;
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
    }
  }, {
    key: "copyLinksFrom",
    value: function copyLinksFrom(field) {
      this.setLinkedDataField(field.getLinkedDataField());
      this.setLinkedCombo(field.getLinkedCombo());
    }
  }, {
    key: "getPosition",
    value: function getPosition(format) {
      var currentPosition = Object.assign({}, this.config.position['*']);
      if (this.config.position[format]) {
        Object.assign(currentPosition, this.config.position[format]);
      }
      if (currentPosition.enabled === undefined) {
        currentPosition.enabled = true;
      }
      if (currentPosition.readOnly === undefined) {
        currentPosition.readOnly = 'false';
      }
      if (currentPosition.visible === undefined) {
        currentPosition.visible = true;
      }
      if (currentPosition.height === undefined) {
        currentPosition.height = 1;
      }
      return currentPosition;
    }
  }, {
    key: "getPositionProperty",
    value: function getPositionProperty(property, format, defaultValue) {
      if (this.config.position[format] && this.config.position[format][property] !== undefined) {
        return this.config.position[format][property];
      } else if (this.config.position['*'] && this.config.position['*'][property] !== undefined) {
        return this.config.position['*'][property];
      } else {
        return defaultValue;
      }
    }
  }, {
    key: "getImagePadding",
    value: function getImagePadding() {
      return {
        x: this.getNumberValueOrDefault('decX', 0),
        y: this.getNumberValueOrDefault('decY', 0)
      };
    }
  }, {
    key: "canHaveNoReactionOnChange",
    value: function canHaveNoReactionOnChange() {
      return this.getBooleanValueOrDefault('noReactionOnChange', false);
    }
  }, {
    key: "canModifyColorOnChange",
    value: function canModifyColorOnChange() {
      return this.getBooleanValueOrDefault('modifyColorOnChange', true);
    }
  }, {
    key: "canBeIgnoredOnCopy",
    value: function canBeIgnoredOnCopy() {
      return this.getBooleanValueOrDefault('copyIgnore', false);
    }
  }, {
    key: "canModifyEnum",
    value: function canModifyEnum() {
      return this.getBooleanValueOrDefault('canModifyEnum', false);
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.config.readOnly === 'true';
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.config.enabled !== 'false';
    }
  }, {
    key: "isLabelVisible",
    value: function isLabelVisible(format) {
      return this.getPositionProperty('labelVisible', format, true);
    }
  }, {
    key: "isVisible",
    value: function isVisible(format) {
      if (this.getPositionProperty('row', format, 1) < 0) {
        return false;
      }
      return this.getPositionProperty('visible', format, true);
    }
  }, {
    key: "getImportance",
    value: function getImportance() {
      return this.getValueOrDefault('importance');
    }
  }, {
    key: "getPopupMenuID",
    value: function getPopupMenuID() {
      return this.getValueOrDefault('popupMenuId');
    }
  }, {
    key: "getPlaceHolder",
    value: function getPlaceHolder() {
      return this.getValueOrDefault('placeHolder');
    }
  }, {
    key: "getContentConversion",
    value: function getContentConversion() {
      return this.getValueOrDefault('contentConversion', Field.CONTENT_CONVERSION_NO_CONVERTION);
    }
  }, {
    key: "canShowInnerIcon",
    value: function canShowInnerIcon() {
      return this.getBooleanValueOrDefault('showInnerIcon', false);
    }
  }, {
    key: "canCalendarAutoPopup",
    value: function canCalendarAutoPopup() {
      return this.getBooleanValueOrDefault('calendarAutoPopup', false);
    }
  }, {
    key: "canAutoGeneratedContent",
    value: function canAutoGeneratedContent() {
      return this.getBooleanValueOrDefault('autoGeneratedContent', false);
    }
  }, {
    key: "getExistenceConditions",
    value: function getExistenceConditions() {
      return this.getValueOrDefault('existence');
    }
  }, {
    key: "getSilo",
    value: function getSilo() {
      return this.getValueOrDefault('silo');
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return this.getValueOrDefault('defaultValue');
    }
  }, {
    key: "getPermanentValue",
    value: function getPermanentValue() {
      return this.getValueOrDefault('permanentValue');
    }
  }, {
    key: "getKeepInSessionVar",
    value: function getKeepInSessionVar() {
      return this.getValueOrDefault('keepInSessionVar');
    }
  }, {
    key: "getDisplayColumnId",
    value: function getDisplayColumnId() {
      return this.getValueOrDefault('displayColumn');
    }
  }, {
    key: "getGridView",
    value: function getGridView() {
      return this.getValueOrDefault('gridView');
    }
  }, {
    key: "canCallOnValidate",
    value: function canCallOnValidate() {
      return this.getBooleanValueOrDefault('callOnValidate', false);
    }
  }, {
    key: "canCallOnClick",
    value: function canCallOnClick() {
      return this.getBooleanValueOrDefault('callOnClick', false);
    }
  }, {
    key: "canSendAllPanels",
    value: function canSendAllPanels() {
      return this.getBooleanValueOrDefault('sendAllPanels', false);
    }
  }, {
    key: "getScriptOnClick",
    value: function getScriptOnClick() {
      return this.getValueOrDefault('scriptOnClick');
    }
  }, {
    key: "getScriptOnEnter",
    value: function getScriptOnEnter() {
      return this.getValueOrDefault('scriptOnEnter');
    }
  }, {
    key: "getScriptOnValidate",
    value: function getScriptOnValidate() {
      return this.getValueOrDefault('scriptOnValidate');
    }
  }, {
    key: "getScriptOnNoteValidate",
    value: function getScriptOnNoteValidate() {
      return this.getValueOrDefault('scriptOnNoteValidate');
    }
  }, {
    key: "getCoupleGrid",
    value: function getCoupleGrid() {
      return this.linkedCouple.getGrid();
    }
  }, {
    key: "getCoupleKey",
    value: function getCoupleKey() {
      return this.linkedCouple.getForeignKey();
    }
  }, {
    key: "getCoupleValue",
    value: function getCoupleValue() {
      return this.linkedCouple.getLabel();
    }
  }, {
    key: "getCoupleFilter",
    value: function getCoupleFilter() {
      return this.linkedCouple.getFilter();
    }
  }, {
    key: "isCoupleKey",
    value: function isCoupleKey() {
      return this.getCoupleKey() === this.getDatafieldId();
    }
  }, {
    key: "isCoupleLabel",
    value: function isCoupleLabel() {
      return !this.isCoupleKey;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.getValueOrDefault('value');
      return value !== undefined ? value : '';
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this.getLinkedDataField().getFormat();
    }
  }, {
    key: "getObjectTypeFromFormatPresentation",
    value: function getObjectTypeFromFormatPresentation() {
      if (this.isCouple()) {
        return 'Couple';
      }
      var format = this.getFormat();
      var presentation = this.getPresentation();
      var type = 'Text';
      if (format === 'ByForeignKey') {
        format = 'String';
      }
      if (format === 'String' && presentation === 'CheckBoxes' || format === 'Boolean') {
        type = 'Checkbox';
      } else if (format === 'String') {
        if (presentation === 'Link' || presentation === 'RadioButtons' || presentation === 'Button' || presentation === 'Password' || presentation === 'Phone') {
          type = presentation;
        } else if (presentation === 'Email') {
          type = 'Email';
        } else {
          type = 'Text';
        }
      } else if (format === 'List') {
        if (this.getLinkedDataField().getTableName() !== undefined) {
          type = 'ListCouple';
        } else {
          type = 'ListEnum';
          if (presentation === 'Icon') {
            type = 'EnumIcon';
          }
        }
      } else if (format === 'Enum') {
        if (presentation === 'Icon') {
          type = 'EnumIcon';
        } else {
          type = 'Enum';
        }
      } else {
        type = format;
      }
      return type;
    }
  }, {
    key: "isRequired",
    value: function isRequired(format) {
      var fieldImportance = this.getImportance();
      if (fieldImportance) {
        return fieldImportance === '1' && this.isVisible(format) && this.isEnabled();
      }
      if (this.linkedDataField) {
        var dFieldImportance = this.linkedDataField.getImportance();
        if (dFieldImportance) {
          return dFieldImportance === '1' && this.isVisible(format) && this.isEnabled();
        }
      }
      return false;
    }
  }, {
    key: "getHelpId",
    value: function getHelpId() {
      return this.parentTask.getId() + (this.parentTask.getReadableType() === 'Dossier' ? '.' : '.Panel') + this.parentGroup.getPanel().getId() + '.' + this.getId();
    }
  }], [{
    key: "setReadOnly",
    value: function setReadOnly(descriptor) {
      descriptor.readOnly = 'true';
    }
  }]);
  return Field;
}(ConfigurationElement_1.ConfigurationElement);
Field.CONTENT_CONVERSION_NO_CONVERTION = '0';
Field.ASYNC_PROP_LABEL = _Symbol();
Field.ASYNC_PROP_COMBO = _Symbol();
exports.Field = Field;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var _Symbol = __webpack_require__(1);
var DataField = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(DataField, _ConfigurationElement);
  var _super = _createSuper(DataField);
  function DataField(config, parentDataPage, parentTable, parentTask, context) {
    var _this;
    _classCallCheck(this, DataField);
    _this = _super.call(this, config, context);
    _this.parentDataPage = parentDataPage;
    _this.parentTable = parentTable;
    _this.parentTask = parentTask;
    _this.remainingAsyncProps = [DataField.ASYNC_PROP_LABEL, DataField.ASYNC_PROP_PLACEHOLDER];
    return _this;
  }
  _createClass(DataField, [{
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
    }
  }, {
    key: "isDataPageDataField",
    value: function isDataPageDataField() {
      return this.parentDataPage !== undefined;
    }
  }, {
    key: "getDataPage",
    value: function getDataPage() {
      return this.parentDataPage;
    }
  }, {
    key: "isTableDataField",
    value: function isTableDataField() {
      return this.parentTable !== undefined;
    }
  }, {
    key: "getTable",
    value: function getTable() {
      if (this.parentTable === undefined && this.parentDataPage !== undefined) {
        return this.parentDataPage.getTable();
      } else {
        return this.parentTable;
      }
    }
  }, {
    key: "isTaskDataField",
    value: function isTaskDataField() {
      return this.parentTask !== undefined;
    }
  }, {
    key: "getTask",
    value: function getTask() {
      return this.parentTask;
    }
  }, {
    key: "getSource",
    value: function getSource() {
      return this.getValueOrDefault('source', 'TaskOnly');
    }
  }, {
    key: "setSourcePageId",
    value: function setSourcePageId(pageId) {
      this.config.sourcePageId = pageId;
    }
  }, {
    key: "getSourcePageId",
    value: function getSourcePageId() {
      return this.config.sourcePageId;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this.getValueOrDefault('format', 'String');
    }
  }, {
    key: "getPresentation",
    value: function getPresentation() {
      return this.getValueOrDefault('presentation');
    }
  }, {
    key: "getEnumName",
    value: function getEnumName() {
      return this.getValueOrDefault('enumName');
    }
  }, {
    key: "getTableName",
    value: function getTableName() {
      return this.getValueOrDefault('tableName');
    }
  }, {
    key: "getDecimalsNumber",
    value: function getDecimalsNumber() {
      return this.getNumberValueOrDefault('decimalsNumber', 2);
    }
  }, {
    key: "isTitle",
    value: function isTitle() {
      return this.getBooleanValueOrDefault('isTitle', false);
    }
  }, {
    key: "isHeader",
    value: function isHeader() {
      return this.getBooleanValueOrDefault('isHeader', false);
    }
  }, {
    key: "isSingleOnAllRecords",
    value: function isSingleOnAllRecords() {
      return this.getBooleanValueOrDefault('singleOnAllRecords', false);
    }
  }, {
    key: "allowsMultipleLanguages",
    value: function allowsMultipleLanguages() {
      return this.getBooleanValueOrDefault('allowMultipleLanguages', false);
    }
  }, {
    key: "getGridView",
    value: function getGridView() {
      return this.getValueOrDefault('gridView');
    }
  }, {
    key: "getForeignKeyField",
    value: function getForeignKeyField() {
      return this.getValueOrDefault('foreignKeyField');
    }
  }, {
    key: "getFilterName",
    value: function getFilterName() {
      return this.getValueOrDefault('filterName', 'DEFAULT_FILTER');
    }
  }, {
    key: "isSupremum",
    value: function isSupremum() {
      return this.getBooleanValueOrDefault('supremum', false);
    }
  }, {
    key: "getInputLimits",
    value: function getInputLimits() {
      return this.getValueOrDefault('inputLimits');
    }
  }, {
    key: "getProgressLimits",
    value: function getProgressLimits() {
      return this.getValueOrDefault('progressLimits');
    }
  }, {
    key: "getMaxLength",
    value: function getMaxLength() {
      return this.getNumberValueOrDefault('maxLength', 0);
    }
  }, {
    key: "getSpecialMask",
    value: function getSpecialMask() {
      return this.getValueOrDefault('specialMask');
    }
  }, {
    key: "getFileType",
    value: function getFileType() {
      return this.getValueOrDefault('fileType');
    }
  }, {
    key: "isProtected",
    value: function isProtected() {
      return this.getBooleanValueOrDefault('protected', false);
    }
  }, {
    key: "getExistenceConditions",
    value: function getExistenceConditions() {
      return this.getValueOrDefault('existence');
    }
  }, {
    key: "getImportance",
    value: function getImportance() {
      return this.getValueOrDefault('importance');
    }
  }, {
    key: "getSortIndex",
    value: function getSortIndex() {
      return this.getValueOrDefault('sortIndex');
    }
  }, {
    key: "isGeneric",
    value: function isGeneric() {
      return this.getBooleanValueOrDefault('generic', false);
    }
  }, {
    key: "hasToShowSeconds",
    value: function hasToShowSeconds() {
      return this.getBooleanValueOrDefault('showSeconds', false);
    }
  }, {
    key: "hasToShowDays",
    value: function hasToShowDays() {
      return this.getBooleanValueOrDefault('showDays', true);
    }
  }, {
    key: "getSilo",
    value: function getSilo() {
      return this.getValueOrDefault('silo');
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return this.getValueOrDefault('defaultValue');
    }
  }, {
    key: "getPermanentValue",
    value: function getPermanentValue() {
      return this.getValueOrDefault('permanentValue');
    }
  }, {
    key: "canEnableRichText",
    value: function canEnableRichText() {
      return false;
    }
  }, {
    key: "getPlaceHolder",
    value: function getPlaceHolder() {
      return this.getValueOrDefault('placeHolder');
    }
  }, {
    key: "getDisplayCode",
    value: function getDisplayCode() {
      return this.getValueOrDefault('displayCode', 'TextAndCode');
    }
  }, {
    key: "getKeyPattern",
    value: function getKeyPattern() {
      return this.getValueOrDefault('keyPattern');
    }
  }, {
    key: "getScriptLanguage",
    value: function getScriptLanguage() {
      return this.getValueOrDefault('scriptLanguage');
    }
  }, {
    key: "getImageSource",
    value: function getImageSource() {
      return this.getValueOrDefault('imageSource');
    }
  }, {
    key: "getImageInteraction",
    value: function getImageInteraction() {
      return this.getValueOrDefault('imageInteraction');
    }
  }, {
    key: "getScriptOnClick",
    value: function getScriptOnClick() {
      return this.getValueOrDefault('scriptOnClick');
    }
  }, {
    key: "getNotificationOnClick",
    value: function getNotificationOnClick() {
      return this.getValueOrDefault('notificationOnClick');
    }
  }, {
    key: "getNotificationType",
    value: function getNotificationType() {
      return this.getValueOrDefault('notificationType');
    }
  }, {
    key: "getRemoteTask",
    value: function getRemoteTask() {
      return this.getValueOrDefault('remoteTask');
    }
  }, {
    key: "getRemoteArguments",
    value: function getRemoteArguments() {
      return this.getValueOrDefault('remoteArguments');
    }
  }, {
    key: "isAutoAddedSystemDF",
    value: function isAutoAddedSystemDF() {
      return this.getBooleanValueOrDefault('autoAddedSystemDF', false);
    }
  }, {
    key: "getDatabaseTable",
    value: function getDatabaseTable() {
      return this.getValueOrDefault('databaseTable');
    }
  }, {
    key: "getDatabaseColumn",
    value: function getDatabaseColumn() {
      return this.getValueOrDefault('databaseColumn');
    }
  }, {
    key: "getDatapageID",
    value: function getDatapageID() {
      return this.getValueOrDefault('datapageId');
    }
  }, {
    key: "isShownAsFilterOnNavigator",
    value: function isShownAsFilterOnNavigator() {
      return this.getBooleanValueOrDefault('showAsFilterOnNavigator', false);
    }
  }, {
    key: "getPresentInFilterCondition",
    value: function getPresentInFilterCondition() {
      return this.getValueOrDefault('PresentIfTrue');
    }
  }, {
    key: "canBeUsedForFilter",
    value: function canBeUsedForFilter() {
      return this.getBooleanValueOrDefault('canBeUsedForFilter', true);
    }
  }, {
    key: "canBeUsedForSelection",
    value: function canBeUsedForSelection() {
      return this.getBooleanValueOrDefault('canBeUsedForSelection', true);
    }
  }, {
    key: "canBeUsedForOperations",
    value: function canBeUsedForOperations() {
      return this.getBooleanValueOrDefault('canBeUsedForOperations', true);
    }
  }, {
    key: "canAutoSaveDocument",
    value: function canAutoSaveDocument() {
      return this.getBooleanValueOrDefault('autoSaveDocument', true);
    }
  }, {
    key: "canShowDocumentSaveBtn",
    value: function canShowDocumentSaveBtn() {
      return this.getBooleanValueOrDefault('canShowDocumentSaveBtn', true);
    }
  }, {
    key: "canKeepDocumentVersions",
    value: function canKeepDocumentVersions() {
      return this.getBooleanValueOrDefault('canKeepDocumentVersions', false);
    }
  }, {
    key: "getDocumentTemplate",
    value: function getDocumentTemplate() {
      return this.getValueOrDefault('documentTemplate');
    }
  }, {
    key: "getDocumentApplication",
    value: function getDocumentApplication() {
      return this.getValueOrDefault('documentApplication');
    }
  }, {
    key: "getDocumentPrintLanguage",
    value: function getDocumentPrintLanguage() {
      return this.getValueOrDefault('documentPrintLanguage');
    }
  }, {
    key: "isKey",
    value: function isKey() {
      return this.getId().endsWith('_PK');
    }
  }, {
    key: "getDatafieldId",
    value: function getDatafieldId() {
      return this.getValueOrDefault('datafieldId');
    }
  }, {
    key: "setPlaceHolder",
    value: function setPlaceHolder(newValue) {
      this.config['placeHolder'] = newValue;
    }
  }, {
    key: "setAsAutoAddedSystemDF",
    value: function setAsAutoAddedSystemDF(isAuto) {
      this.config['autoAddedSystemDF'] = isAuto;
    }
  }, {
    key: "setFormat",
    value: function setFormat(format) {
      this.config.format = format;
    }
  }, {
    key: "setEnumName",
    value: function setEnumName(enumName) {
      this.config.enumName = enumName;
    }
  }]);
  return DataField;
}(ConfigurationElement_1.ConfigurationElement);
DataField.ASYNC_PROP_LABEL = _Symbol();
DataField.ASYNC_PROP_PLACEHOLDER = _Symbol();
exports.DataField = DataField;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var BasePanel_1 = __webpack_require__(2);
var Field_1 = __webpack_require__(3);
var Level_1 = __webpack_require__(9);
var Couple_1 = __webpack_require__(10);
var _Symbol = __webpack_require__(1);
var Group = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Group, _ConfigurationElement);
  var _super = _createSuper(Group);
  function Group(config, parentPanel, parentLevel, context) {
    var _this;
    _classCallCheck(this, Group);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [Group.ASYNC_PROP_LABEL];
    _this.parentPanel = parentPanel;
    _this.parentPanel.registerGroup(_assertThisInitialized(_this));
    _this.parentLevel = parentLevel;
    _this.fields = {};
    _this.fieldsArr = [];
    _this.children = [];
    for (var key in config.children) {
      var childConf = config.children[key];
      var cType = Group.getObjectType(childConf.objectType);
      if (cType === BasePanel_1.BasePanel.CHILD_TYPE_LEVEL) {
        var newChild = new Level_1.Level(childConf, parentPanel, _this.parentLevel, _assertThisInitialized(_this), context);
        _this.children.push(newChild);
      } else if (cType === Group.CHILD_TYPE_FIELD || cType === Group.CHILD_TYPE_CHECKBOX_FIELD) {
        var _newChild = new Field_1.Field(childConf, _this.parentPanel.getParentTask(), _assertThisInitialized(_this), _this.parentLevel, context);
        _this.children.push(_newChild);
      } else if (cType === Group.CHILD_TYPE_COUPLE_FIELD) {
        var _newChild2 = new Couple_1.Couple(childConf, _this.parentPanel.getParentTask(), _assertThisInitialized(_this), _this.parentLevel, context);
        _this.children = _this.children.concat(_newChild2.getFields());
      } else {
        console.warn('Invalid child type in group : ' + cType);
      }
    }
    return _this;
  }
  _createClass(Group, [{
    key: "getPanel",
    value: function getPanel() {
      return this.parentPanel;
    }
  }, {
    key: "getField",
    value: function getField(fieldId) {
      return this.fields[fieldId];
    }
  }, {
    key: "getFields",
    value: function getFields() {
      return this.fieldsArr;
    }
  }, {
    key: "hasField",
    value: function hasField(fieldId) {
      return this.fields[fieldId] !== undefined;
    }
  }, {
    key: "getI18NFields",
    value: function getI18NFields() {
      var mappedFields = {};
      for (var field in this.fields) {
        var curField = this.fields[field];
        mappedFields[this.parentPanel.getFieldI18N(curField.getId())] = curField;
      }
      return mappedFields;
    }
  }, {
    key: "addField",
    value: function addField(newField) {
      this.fields[newField.getId()] = newField;
      this.fieldsArr.push(newField);
    }
  }, {
    key: "registerField",
    value: function registerField(newChild) {
      this.fieldsArr.push(newChild);
      this.fields[newChild.getId()] = newChild;
    }
  }, {
    key: "getPosition",
    value: function getPosition(format) {
      var currentPosition = Object.assign({}, this.config.position['*']);
      if (this.config.position[format]) {
        Object.assign(currentPosition, this.config.position[format]);
      }
      return currentPosition;
    }
  }, {
    key: "getExistenceConditions",
    value: function getExistenceConditions() {
      return this.getValueOrDefault('existence');
    }
  }, {
    key: "getIconLocation",
    value: function getIconLocation() {
      return this.getValueOrDefault('iconLocation', Group.ICON_LOCATION_RIGHT);
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
      for (var fId in this.fields) {
        this.fields[fId].retrieveAsyncEntities(allEntities);
      }
    }
  }, {
    key: "getHelpId",
    value: function getHelpId() {
      var parentTask = this.parentPanel.getParentTask();
      var isDossier = parentTask.getReadableType() === 'Dossier';
      return parentTask.getId() + (isDossier ? '.' : '.Panel') + this.parentPanel.getId() + (isDossier ? '.Group' : '.') + this.getId();
    }
  }], [{
    key: "setReadOnly",
    value: function setReadOnly(descriptor) {
      var setFieldReadOnly = function setFieldReadOnly(descriptor) {
        for (var key in descriptor.children) {
          var childConf = descriptor.children[key];
          var cType = Group.getObjectType(childConf.objectType);
          if (cType === BasePanel_1.BasePanel.CHILD_TYPE_LEVEL || cType === Group.CHILD_TYPE_COUPLE_FIELD) {
            setFieldReadOnly(childConf);
          } else if (cType === Group.CHILD_TYPE_FIELD || cType === Group.CHILD_TYPE_CHECKBOX_FIELD) {
            Field_1.Field.setReadOnly(childConf);
          }
        }
      };
      setFieldReadOnly(descriptor);
    }
  }]);
  return Group;
}(ConfigurationElement_1.ConfigurationElement);
Group.ICON_LOCATION_RIGHT = 'Right';
Group.CHILD_TYPE_FIELD = 'field';
Group.CHILD_TYPE_COUPLE_FIELD = 'couple';
Group.CHILD_TYPE_CHECKBOX_FIELD = 'checkbox';
Group.ASYNC_PROP_LABEL = _Symbol();
exports.Group = Group;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BasePanel_1 = __webpack_require__(2);
var _ = __webpack_require__(6);
var Field_1 = __webpack_require__(3);
var DataField_1 = __webpack_require__(4);
var Page = /*#__PURE__*/function (_BasePanel_1$BasePane) {
  _inherits(Page, _BasePanel_1$BasePane);
  var _super = _createSuper(Page);
  function Page(config, parentTask, context) {
    var _this;
    _classCallCheck(this, Page);
    _this = _super.call(this, config, parentTask, context);
    var mandatoryFields = ['FM_PAGE_CREATION_DATE', 'FM_PAGE_MODIFICATION_DATE', 'FM_PAGE_VERSION'];
    for (var grpId in _this.groups) {
      var curGrp = _this.groups[grpId];
      var foundFields = [];
      for (var toLookId in mandatoryFields) {
        var toLook = mandatoryFields[toLookId];
        if (curGrp.hasField(toLook)) {
          foundFields.push(toLook);
        }
      }
      mandatoryFields = _.difference(mandatoryFields, foundFields);
    }
    if (_this.groupsArr.length > 0) {
      for (var remId in mandatoryFields) {
        _this.createMissingField(mandatoryFields[remId]);
      }
    } else {
      console.warn('The page ' + _this.getId() + ' has no group');
    }
    for (var key in config.datafields) {
      var newDf = new DataField_1.DataField(config.datafields[key], null, null, parentTask, context);
      newDf.setSourcePageId(config.id);
      _this.parentTask.addDataField(newDf);
    }
    return _this;
  }
  _createClass(Page, [{
    key: "createMissingField",
    value: function createMissingField(fieldId) {
      var newField = new Field_1.Field({
        id: fieldId,
        datafieldId: this.parentTask.getTableID().substring(0, 6) + '.' + this.getId() + '.' + fieldId,
        position: {
          tablet: {
            fieldColumn: 1,
            fieldWidth: 0,
            row: -99,
            height: 1,
            visible: false,
            enabled: false,
            labelVisible: false
          },
          phone: {
            fieldColumn: 1,
            fieldWidth: 0,
            row: -99,
            height: 1,
            visible: false,
            enabled: false,
            labelVisible: false
          },
          desktop: {
            fieldColumn: 1,
            fieldWidth: 0,
            row: -99,
            height: 1,
            visible: false,
            enabled: false,
            labelVisible: false
          }
        },
        autoAddedSystemField: true
      }, this.getParentTask(), this.groupsArr[0], undefined, this.getContext());
      this.groupsArr[0].addField(newField);
    }
  }, {
    key: "getFieldI18N",
    value: function getFieldI18N(fieldId) {
      return this.getParentTask().getId() + '.' + this.getId() + '.' + fieldId;
    }
  }, {
    key: "getI18NID",
    value: function getI18NID() {
      return this.parentTask.getId() + '.' + this.getId();
    }
  }]);
  return Page;
}(BasePanel_1.BasePanel);
exports.Page = Page;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var sai_configuration_1 = __webpack_require__(13);
var ConfigurationUtils = /*#__PURE__*/function () {
  function ConfigurationUtils() {
    _classCallCheck(this, ConfigurationUtils);
  }
  _createClass(ConfigurationUtils, null, [{
    key: "guid",
    value: function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }, {
    key: "getBasename",
    value: function getBasename(someString) {
      if (someString === undefined) {
        return someString;
      } else {
        var base = someString.substring(someString.lastIndexOf('/') + 1);
        if (base.lastIndexOf('.') != -1) {
          base = base.substring(0, base.lastIndexOf('.'));
        }
        return base;
      }
    }
  }, {
    key: "getMultilangTextValue",
    value: function getMultilangTextValue(multilangText) {
      var re = /([A-Z]{2})=\{(.+?)\}/g;
      var defaultLanguage = "FR";
      var targetLanguage = sai_configuration_1.CClientConfiguration.getLocale();
      var defaultLanguageMessage = undefined;
      var targetLanguageMessage = undefined;
      var match;
      while (match = re.exec(multilangText)) {
        if (match[1] === defaultLanguage) {
          defaultLanguageMessage = match[2];
        }
        if (match[1] === targetLanguage) {
          targetLanguageMessage = match[2];
        }
      }
      if (targetLanguageMessage) {
        return targetLanguageMessage;
      }
      if (defaultLanguageMessage) {
        return defaultLanguageMessage;
      }
      return multilangText;
    }
  }]);
  return ConfigurationUtils;
}();
exports["default"] = ConfigurationUtils;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Key_1 = __webpack_require__(16);
var BasePanel_1 = __webpack_require__(2);
var ConfigurationElement_1 = __webpack_require__(0);
var Group_1 = __webpack_require__(5);
var Field_1 = __webpack_require__(3);
var Couple_1 = __webpack_require__(10);
var Level = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Level, _ConfigurationElement);
  var _super = _createSuper(Level);
  function Level(config, parentPanel, parentLevel, parentGroup, context) {
    var _this;
    _classCallCheck(this, Level);
    _this = _super.call(this, config, context);
    _this.parentLevel = parentLevel;
    _this.parentPanel = parentPanel;
    _this.parentGroup = parentGroup;
    _this.children = [];
    for (var key in config.children) {
      var childConf = config.children[key];
      var cType = Level.getObjectType(childConf.objectType);
      if (cType === BasePanel_1.BasePanel.CHILD_TYPE_LEVEL) {
        var newChild = new Level(childConf, parentPanel, _assertThisInitialized(_this), _this.parentGroup, context);
        _this.children.push(newChild);
      } else if (cType === BasePanel_1.BasePanel.CHILD_TYPE_GROUP) {
        var _newChild = new Group_1.Group(childConf, parentPanel, _assertThisInitialized(_this), context);
        _this.children.push(_newChild);
      } else if (cType === Level.CHILD_TYPE_KEY) {
        _this.key = new Key_1.Key(childConf, context);
      } else if (cType === Group_1.Group.CHILD_TYPE_FIELD || cType === Group_1.Group.CHILD_TYPE_CHECKBOX_FIELD) {
        var _newChild2 = new Field_1.Field(childConf, _this.parentPanel.getParentTask(), _this.parentGroup, _assertThisInitialized(_this), context);
        _this.children.push(_newChild2);
      } else if (cType === Group_1.Group.CHILD_TYPE_COUPLE_FIELD) {
        var _newChild3 = new Couple_1.Couple(childConf, _this.parentPanel.getParentTask(), _this.parentGroup, _assertThisInitialized(_this), context);
        _this.children = _this.children.concat(_newChild3.getFields());
      } else {
        console.warn('Invalid child type in level : ' + cType);
      }
    }
    return _this;
  }
  _createClass(Level, [{
    key: "getKey",
    value: function getKey() {
      return this.key;
    }
  }, {
    key: "getParentLevel",
    value: function getParentLevel() {
      return this.parentLevel;
    }
  }, {
    key: "getParentPanel",
    value: function getParentPanel() {
      return this.parentPanel;
    }
  }]);
  return Level;
}(ConfigurationElement_1.ConfigurationElement);
Level.CHILD_TYPE_KEY = 'key';
exports.Level = Level;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var Group_1 = __webpack_require__(5);
var Field_1 = __webpack_require__(3);
'use strict';
var Couple = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Couple, _ConfigurationElement);
  var _super = _createSuper(Couple);
  function Couple(config, parentTask, parentGroup, parentLevel, context) {
    var _this;
    _classCallCheck(this, Couple);
    _this = _super.call(this, config, context);
    _this.parentGroup = parentGroup;
    _this.parentTask = parentTask;
    _this.parentLevel = parentLevel;
    _this.children = [];
    for (var key in config.children) {
      var childConf = config.children[key];
      var cType = Couple.getObjectType(childConf.objectType);
      if (cType === Group_1.Group.CHILD_TYPE_FIELD) {
        var newChild = new Field_1.Field(childConf, parentTask, parentGroup, parentLevel, context);
        _this.children.push(newChild);
        newChild.setLinkedCouple(_assertThisInitialized(_this));
      } else {
        console.warn('Invalid child type in couple : ' + cType);
      }
    }
    return _this;
  }
  _createClass(Couple, [{
    key: "getFields",
    value: function getFields() {
      return this.children;
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      return this.getValueOrDefault('filter', 'DEFAULT_FILTER');
    }
  }, {
    key: "getGrid",
    value: function getGrid() {
      return this.getValueOrDefault('gridView');
    }
  }, {
    key: "getForeignKey",
    value: function getForeignKey() {
      return this.getValueOrDefault('key');
    }
  }, {
    key: "getLocalKey",
    value: function getLocalKey() {
      return this.getValueOrDefault('keyVar');
    }
  }, {
    key: "getOpenWithTask",
    value: function getOpenWithTask() {
      return this.getValueOrDefault('openWith');
    }
  }, {
    key: "isFusion",
    value: function isFusion() {
      return this.getBooleanValueOrDefault('fusion');
    }
  }, {
    key: "isSwitched",
    value: function isSwitched() {
      return this.getBooleanValueOrDefault('switch');
    }
  }, {
    key: "getKeyField",
    value: function getKeyField() {
      for (var key in this.children) {
        var curField = this.children[key];
        if (curField.getDatafieldId() === this.getForeignKey()) {
          return curField;
        }
      }
      throw new Error('Unable to locate key field in couple');
    }
  }, {
    key: "getLabelField",
    value: function getLabelField() {
      for (var key in this.children) {
        var curField = this.children[key];
        if (curField.getDatafieldId() !== this.getForeignKey()) {
          return curField;
        }
      }
      throw new Error('Unable to locate label field in couple');
    }
  }]);
  return Couple;
}(ConfigurationElement_1.ConfigurationElement);
exports.Couple = Couple;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DataField_1 = __webpack_require__(4);
var ConfigurationElement_1 = __webpack_require__(0);
var _Symbol = __webpack_require__(1);
var DataPage = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(DataPage, _ConfigurationElement);
  var _super = _createSuper(DataPage);
  function DataPage(config, parentTable, context) {
    var _this;
    _classCallCheck(this, DataPage);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [DataPage.ASYNC_PROP_LABEL];
    _this.parentTable = parentTable;
    _this.datafields = {};
    _this.datafieldsArr = [];
    for (var key in config.datafields) {
      var newDf = new DataField_1.DataField(config.datafields[key], _assertThisInitialized(_this), null, null, context);
      _this.datafields[newDf.getId()] = newDf;
      _this.datafieldsArr.push(newDf);
    }
    var parentId = parentTable.getId();
    var currentId = _this.getId();
    var dPagePrefix = parentId.substring(0, 6) + '.' + currentId;
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_CREATION_DATE', 'DateTime');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_CREATION_BY', 'String');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_MODIFICATION_DATE', 'DateTime');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_MODIFICATION_BY', 'String');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_VERSION', 'Integer');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_NUMBER', 'Integer');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_START_DATE', 'DateTime');
    _this.createBaseDataField(dPagePrefix, 'FM_PAGE_END_DATE', 'DateTime');
    return _this;
  }
  _createClass(DataPage, [{
    key: "getTable",
    value: function getTable() {
      return this.parentTable;
    }
  }, {
    key: "getThemeID",
    value: function getThemeID() {
      return this.getValueOrDefault('themeId');
    }
  }, {
    key: "isSingle",
    value: function isSingle() {
      return this.getBooleanValueOrDefault('isSingle', true);
    }
  }, {
    key: "isShared",
    value: function isShared() {
      return this.getBooleanValueOrDefault('isShared', false);
    }
  }, {
    key: "getExistenceConditions",
    value: function getExistenceConditions() {
      return this.getValueOrDefault('existence');
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
      for (var dfId in this.datafields) {
        this.datafields[dfId].retrieveAsyncEntities(allEntities);
      }
    }
  }, {
    key: "canCallOnPrepareNewPage",
    value: function canCallOnPrepareNewPage() {
      return this.getBooleanValueOrDefault('callOnPrepareNewPage', false);
    }
  }, {
    key: "getDataField",
    value: function getDataField(dfId) {
      return this.datafields[dfId];
    }
  }, {
    key: "getDataFields",
    value: function getDataFields() {
      return this.datafieldsArr;
    }
  }, {
    key: "createBaseDataField",
    value: function createBaseDataField(prefix, datafieldId, format) {
      var dfId = prefix + '.' + datafieldId;
      var existingDf = this.getDataField(dfId);
      if (existingDf === undefined) {
        existingDf = new DataField_1.DataField({
          id: dfId,
          label: dfId,
          source: 'DataBaseDossier',
          autoAddedSystemDF: true,
          format: format,
          showSeconds: format === 'DateTime' || format === 'Time'
        }, this, null, null, this.getContext());
        this.datafields[existingDf.getId()] = existingDf;
        this.datafieldsArr.push(existingDf);
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return this.getValueOrDefault('icon', 'page');
    }
  }]);
  return DataPage;
}(ConfigurationElement_1.ConfigurationElement);
DataPage.ASYNC_PROP_LABEL = _Symbol();
exports.DataPage = DataPage;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
if (global.window === undefined) {
  global.window = {};
}
var Protocol_1 = __webpack_require__(21);
var dashboard_1 = __webpack_require__(36);
var ThemeManager_1 = __webpack_require__(22);
var Combo_1 = __webpack_require__(18);
var Filter_1 = __webpack_require__(19);
var GridView_1 = __webpack_require__(20);
var PopupMenu_1 = __webpack_require__(23);
var Task_1 = __webpack_require__(24);
var Table_1 = __webpack_require__(27);
var DataField_1 = __webpack_require__(4);
var DataPage_1 = __webpack_require__(11);
var Page_1 = __webpack_require__(7);
var Field_1 = __webpack_require__(3);
var Group_1 = __webpack_require__(5);
var Theme_1 = __webpack_require__(28);
var BasePanel_1 = __webpack_require__(2);
var Logger_1 = __webpack_require__(37);
var CClientConfiguration = /*#__PURE__*/function () {
  function CClientConfiguration() {
    _classCallCheck(this, CClientConfiguration);
    this.APP_LOGO = 'app/login/weblogo.png';
    this.APP_LOGO_WHITE = 'app/login/weblogo_white.png';
    this.APP_LOGO_BLACK = 'app/login/weblogo_black.png';
  }
  _createClass(CClientConfiguration, [{
    key: "initialize",
    value: function initialize(server, locale, resolvers, debug) {
      this.locale = (locale || 'FR').toLocaleUpperCase();
      this.i18nresolver = resolvers.i18nResolver;
      this.scriptResolver = resolvers.scriptResolver;
      this.textResolver = resolvers.textResolver;
      this.server = server;
      this.cacheList = [];
      Logger_1["default"].setLevel(debug || Logger_1["default"].WARNING);
    }
  }, {
    key: "setServer",
    value: function setServer(server) {
      this.server = server;
    }
  }, {
    key: "getServer",
    value: function getServer() {
      return this.server;
    }
  }, {
    key: "setLocale",
    value: function setLocale(newLocale) {
      this.locale = newLocale;
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: "getTask",
    value: function getTask(taskId, context, lang) {
      return this.getCachedConfiguration('tasks', taskId, context, Protocol_1.Configuration.TaskRequest, lang);
    }
  }, {
    key: "getPage",
    value: function getPage(taskId, pageId, context, lang) {
      var _this = this;
      return new Promise(function (accept, reject) {
        _this.getTask(taskId, context, lang).then(function (task) {
          accept(task.getPage(pageId));
        })["catch"](reject);
      });
    }
  }, {
    key: "getFilter",
    value: function getFilter(id, context, lang) {
      return this.getCachedConfiguration('filters', id, context, Protocol_1.Configuration.FilterRequest, lang, Filter_1.Filter);
    }
  }, {
    key: "getCombo",
    value: function getCombo(id, context, taskId, lang) {
      if (id.indexOf(' :: ') > 0) {
        id = this.scriptResolver(id, {
          'CURRENT_CHAIN_ID': taskId.substring(0, 3)
        });
      }
      return this.getCachedConfiguration('combos', lang + '/' + id, context, Protocol_1.Configuration.ComboRequest, lang, Combo_1.Combo);
    }
  }, {
    key: "getComboByDataField",
    value: function getComboByDataField(datafield, lang, context, taskId) {
      var enumName = datafield.getEnumName();
      if (!enumName) {
        throw 'The requested DataField is not of type enum ' + datafield.getId();
      } else if (enumName.indexOf(' :: ') > 0) {
        enumName = this.textResolver(enumName, {
          'CURRENT_CHAIN_ID': taskId.substring(0, 3)
        });
      } else if (enumName === 'ByDataFieldName') {
        enumName = datafield.getId();
      } else if (enumName.indexOf('DOSSIER.') > 0) {
        var regExp = /(.*)DOSSIER(\..*)/;
        var match = regExp.exec(enumName);
        if (match) {
          enumName = match[1] + match[2];
        }
      }
      return this.getCombo(enumName, context, taskId, lang);
    }
  }, {
    key: "getRemoteNotification",
    value: function getRemoteNotification(domain, id, remoteTask, remoteArgs, keyContext, lang) {
      var _this2 = this;
      if (lang === undefined) {
        lang = this.locale;
      }
      return new Promise(function (resolve, reject) {
        if (!id || id === null) {
          var rejectMessage = _this2.i18nresolver('NOTIFICATION_REMOTE_MISSING_ID', lang, {});
          reject(rejectMessage);
          return;
        }
        if (!remoteTask || remoteTask === null) {
          var _rejectMessage = _this2.i18nresolver('NOTIFICATION_REMOTE_MISSING_TASK', lang, {});
          reject(_rejectMessage);
          return;
        }
        remoteArgs = remoteArgs || {};
        var remoteRequest = new Protocol_1.Configuration.GetNotificationRequest(Protocol_1.DomainManager.getCurrentContext(domain), remoteTask, id);
        for (var argEntry in remoteArgs) {
          remoteRequest.setNotificationArgument(argEntry, remoteArgs[argEntry]);
        }
        if (keyContext) {
          remoteRequest.setKeyContext(keyContext);
        }
        _this2.server.performRequest(remoteRequest).then(function (response) {
          resolve(response.notification);
        })["catch"](reject);
      });
    }
  }, {
    key: "getGridView",
    value: function getGridView(id, context, lang) {
      return this.getCachedConfiguration('grids', id, context, Protocol_1.Configuration.GridViewRequest, lang, GridView_1.GridView);
    }
  }, {
    key: "getDashboard",
    value: function getDashboard(id, lang, context) {
      return this.getCachedConfiguration('dashboards', id + '/' + lang, context, Protocol_1.Configuration.DashboardRequest, dashboard_1.SAIDashboardView);
    }
  }, {
    key: "getPopupMenu",
    value: function getPopupMenu(categoryId, entryId, context, lang) {
      return this.getCachedConfiguration('popupmenus', categoryId + '/' + entryId, context, Protocol_1.Configuration.PopupMenuRequest, lang, PopupMenu_1.PopupMenu);
    }
  }, {
    key: "getTable",
    value: function getTable(id, context, lang) {
      return this.getCachedConfiguration('tables', id.substring(0, 6), context, Protocol_1.Configuration.TableRequest, lang, Table_1.Table);
    }
  }, {
    key: "getDataPage",
    value: function getDataPage(tableId, id, context, lang) {
      var _this3 = this;
      return new Promise(function (accept, reject) {
        _this3.getTable(tableId, context, lang).then(function (table) {
          accept(table.getDataPage(id));
        })["catch"](reject);
      });
    }
  }, {
    key: "getDataField",
    value: function getDataField(id, context, task, lang) {
      var _this4 = this;
      var me = this;
      return new Promise(function (accept, reject) {
        var foundInTask = task ? task.getDataField(id) : undefined;
        if (foundInTask) {
          accept(foundInTask);
        } else {
          _this4.getGlobalDataField(id, context, lang).then(function (datafield) {
            if (datafield) {
              accept(datafield);
            } else {
              _this4.getTable(id, context, lang).then(function (table) {
                if (table) {
                  var foundDf = table.getDataField(id, table.isDossier());
                  if (foundDf === undefined) {
                    console.error('cannot find datafield ' + id + ' in table ' + table.getId());
                  }
                  accept(foundDf);
                } else {
                  console.warn('cannot find datafield ' + id + ', assuming task only');
                  accept(new DataField_1.DataField({
                    id: id,
                    format: 'String',
                    source: 'TaskOnly',
                    isHeader: 'false',
                    isTitle: 'false',
                    isKey: 'false'
                  }, null, null, null, context));
                }
              })["catch"](function () {
                console.warn('table ' + id + ' does not exist, assuming task only');
                accept(new DataField_1.DataField({
                  id: id,
                  format: 'String',
                  source: 'TaskOnly',
                  isHeader: 'false',
                  isTitle: 'false',
                  isKey: 'false'
                }, null, null, null, context));
              });
            }
          })["catch"](reject);
        }
      });
    }
  }, {
    key: "getGridDataField",
    value: function getGridDataField(id, context, gridId, lang) {
      var _this5 = this;
      return new Promise(function (accept, reject) {
        _this5.getGridView(gridId, context, lang).then(function (grid) {
          var df = grid.getColumnByDataFieldId(id);
          if (df !== null) {
            accept(df.getDataField());
          } else {
            accept(undefined);
          }
        })["catch"](reject);
      });
    }
  }, {
    key: "getGlobalDataField",
    value: function getGlobalDataField(id, context, lang) {
      var _this6 = this;
      return new Promise(function (accept, reject) {
        _this6.getTable('GLOBAL', context, lang).then(function (table) {
          accept(table.getDataField(id));
        })["catch"](reject);
      });
    }
  }, {
    key: "getI18nText",
    value: function getI18nText(context, type, i18NID, global, lang) {
      var _this7 = this;
      if (lang === undefined) {
        lang = this.locale;
      }
      var me = this;
      global = global || false;
      if (me.i18nTablesAndTask === undefined) {
        me.i18nTablesAndTask = {};
      }
      var currentCache = me.i18nTablesAndTask[context.getId()];
      if (currentCache === undefined) {
        me.i18nTablesAndTask[context.getId()] = {};
      }
      var pendingReq = type + '/' + lang + '/' + (global ? 'global' : i18NID.substring(0, 3));
      if (me.i18nTablesAndTask[context.getId()][pendingReq] !== undefined) {
        return new Promise(function (accept) {
          accept(me.i18nTablesAndTask[context.getId()][pendingReq][i18NID]);
        });
      } else {
        return new Promise(function (found, failed) {
          var newRequest = new Protocol_1.Configuration.I18NRequest(context, pendingReq);
          _this7.server.performRequest(newRequest).then(function (result) {
            if (me.i18nTablesAndTask[context.getId()][pendingReq] === undefined) {
              me.i18nTablesAndTask[context.getId()][pendingReq] = result.texts;
            }
            if (me.i18nTablesAndTask[context.getId()][pendingReq] === undefined) {
              if (!global) {
                _this7.getI18nText(context, type, i18NID, true, lang).then(function (result) {
                  found(result);
                });
              } else {
                failed();
              }
            } else {
              found(me.i18nTablesAndTask[context.getId()][pendingReq][i18NID]);
            }
          })["catch"](failed);
        });
      }
    }
  }, {
    key: "getCachedConfiguration",
    value: function getCachedConfiguration(cacheName, id, context, requestConstr, lang, entityConstr) {
      var _this8 = this;
      if (lang === undefined) {
        lang = this.locale;
      }
      var me = this;
      return new Promise(function (resolve, reject) {
        if (me[cacheName] === undefined) {
          me[cacheName] = {};
          me.cacheList.push(cacheName);
        }
        var langCache = me[cacheName][context.getId()];
        if (langCache === undefined) {
          me[cacheName][context.getId()] = {};
        }
        var currentCache = me[cacheName][context.getId()][lang];
        if (currentCache === undefined) {
          me[cacheName][context.getId()][lang] = {};
        }
        if (me[cacheName][context.getId()][lang][id] === undefined) {
          me[cacheName][context.getId()][lang][id] = new Promise(function (found, failed) {
            var newRequest = new requestConstr(context, id);
            _this8.server.performRequest(newRequest).then(function (result) {
              var newEntity;
              if (entityConstr) {
                newEntity = new entityConstr(result, context);
              } else if (me.requestHasEntityGettter(newRequest)) {
                newEntity = me.getRequestEntity(result, context);
              } else {
                throw new Error('Invalid configuration. Unable to define which object must be instantiated from server response');
              }
              if (me.requestNeedsPostProcess(newRequest)) {
                Logger_1["default"].finest('Post processing entity ' + newEntity.constructor.name + ' for async properties');
                me.postProcessRequest(newRequest, newEntity, lang).then(function () {
                  Logger_1["default"].finest('Entity has been processed');
                  found(newEntity);
                })["catch"](reject);
              } else {
                if (newEntity.initialize) {
                  newEntity.initialize(lang).then(function () {
                    found(newEntity);
                  });
                } else {
                  found(newEntity);
                }
              }
            })["catch"](failed);
          });
        }
        me[cacheName][context.getId()][lang][id].then(function (entity) {
          resolve(entity);
        })["catch"](reject);
      });
    }
  }, {
    key: "requestNeedsPostProcess",
    value: function requestNeedsPostProcess(request) {
      return request instanceof Protocol_1.Configuration.TaskRequest || request instanceof Protocol_1.Configuration.TableRequest;
    }
  }, {
    key: "requestHasEntityGettter",
    value: function requestHasEntityGettter(request) {
      return request instanceof Protocol_1.Configuration.TaskRequest;
    }
  }, {
    key: "getRequestEntity",
    value: function getRequestEntity(result, context) {
      return new Task_1.Task(result, context);
    }
  }, {
    key: "postProcessRequest",
    value: function postProcessRequest(request, entity, lang) {
      if (request instanceof Protocol_1.Configuration.TaskRequest || request instanceof Protocol_1.Configuration.TableRequest) {
        var allEntities = [entity];
        entity.retrieveAsyncEntities(allEntities);
        if (Logger_1["default"].getLevel() >= Logger_1["default"].DEBUG) {
          var allTypes = {};
          for (var key in allEntities) {
            var type = allEntities[key].constructor.name;
            if (!allTypes[type]) {
              allTypes[type] = 0;
            }
            allTypes[type]++;
          }
          Logger_1["default"].debug(JSON.stringify(allTypes));
        }
        var allPromises = this.buildAsyncPromisesFromEntities(allEntities, lang);
        Logger_1["default"].debug(allPromises.length + ' promises to resolve to initialize the entity');
        return Promise.all(allPromises);
      } else {
        return Promise.all([]);
      }
    }
  }, {
    key: "buildAsyncPromisesFromEntities",
    value: function buildAsyncPromisesFromEntities(allEntities, lang) {
      var allPromises = [];
      Logger_1["default"];
      for (var id in allEntities) {
        var entity = allEntities[id];
        if (entity.hasAsyncRequirements()) {
          if (entity instanceof Task_1.Task) {
            allPromises.push(this.buildTaskRequirements(entity, lang));
          } else if (entity instanceof BasePanel_1.BasePanel) {
            allPromises.push(this.buildPanelRequirements(entity, lang));
          } else if (entity instanceof Group_1.Group) {
            allPromises.push(this.buildGroupRequirements(entity, lang));
          } else if (entity instanceof Field_1.Field) {
            allPromises.push(this.buildFieldRequirements(entity, lang));
          } else if (entity instanceof Table_1.Table) {
            allPromises.push(this.buildTableRequirements(entity, lang));
          } else if (entity instanceof DataField_1.DataField) {
            allPromises.push(this.buildDataFieldRequirements(entity, lang));
          } else if (entity instanceof Theme_1.Theme) {
            allPromises.push(this.buildThemeRequirements(entity, lang));
          } else if (entity instanceof DataPage_1.DataPage) {
            allPromises.push(this.buildDataPageRequirements(entity, lang));
          }
        }
      }
      return allPromises;
    }
  }, {
    key: "buildDataPageRequirements",
    value: function buildDataPageRequirements(dEnt, lang) {
      var _this9 = this;
      return new Promise(function (accept, reject) {
        var i18NID = dEnt.getTable().getId().substring(0, 6) + '.' + dEnt.getId();
        Logger_1["default"].debug('[DataPage][' + i18NID + '] - Resolving');
        var i18NTextPromise = _this9.getI18nText(dEnt.getContext(), 'table', i18NID, undefined, lang);
        i18NTextPromise.then(function (i18NText) {
          if (i18NText !== undefined) {
            dEnt.setLabel(i18NText);
          }
          dEnt.removeFromAsyncRequirement(DataPage_1.DataPage.ASYNC_PROP_LABEL);
          Logger_1["default"].debug('[DataPage][' + i18NID + '] - Resolved');
          accept(undefined);
        })["catch"](reject);
      });
    }
  }, {
    key: "buildTableRequirements",
    value: function buildTableRequirements(tEnt, lang) {
      var _this10 = this;
      return new Promise(function (accept, reject) {
        if (!tEnt.isGlobal) {
          var i18NTextPromise = _this10.getI18nText(tEnt.getContext(), 'table', tEnt.getId(), undefined, lang);
          Logger_1["default"].debug('[Table][' + tEnt.getId() + '] - Resolving');
          i18NTextPromise.then(function (i18NText) {
            if (i18NText !== undefined) {
              tEnt.setLabel(i18NText);
            }
            tEnt.removeFromAsyncRequirement(Table_1.Table.ASYNC_PROP_LABEL);
            Logger_1["default"].debug('[Table][' + tEnt.getId() + '] - Resolved');
            accept(undefined);
          })["catch"](reject);
        } else {
          Logger_1["default"].debug('[Table][' + tEnt.getId() + '] - Nothing to resolve');
          accept(undefined);
        }
      });
    }
  }, {
    key: "buildTaskRequirements",
    value: function buildTaskRequirements(tEnt, lang) {
      var _this11 = this;
      return new Promise(function (accept, reject) {
        var allPromises = [];
        allPromises.push(new Promise(function (ok, fail) {
          var i18NTextPromise = _this11.getI18nText(tEnt.getContext(), 'task', tEnt.getId(), undefined, lang);
          Logger_1["default"].debug('[Text][' + tEnt.getId() + '] - Resolving');
          i18NTextPromise.then(function (i18NText) {
            if (i18NText !== undefined) {
              tEnt.setLabel(i18NText);
            }
            tEnt.removeFromAsyncRequirement(Task_1.Task.ASYNC_PROP_LABEL);
            Logger_1["default"].debug('[Text][' + tEnt.getId() + '] - Resolved');
            ok(undefined);
          })["catch"](fail);
        }));
        allPromises.push(new Promise(function (ok, fail) {
          var tablePromise = _this11.getTable(tEnt.getTableID(), tEnt.getContext(), lang);
          Logger_1["default"].debug('[Table][' + tEnt.getTableID() + '] - Resolving');
          tablePromise.then(function (table) {
            tEnt.setLinkedTable(table);
            tEnt.removeFromAsyncRequirement(Task_1.Task.ASYNC_PROP_TABLE);
            Logger_1["default"].debug('[Table][' + tEnt.getTableID() + '] - Resolved');
            ok(undefined);
          })["catch"](fail);
        }));
        allPromises.push(new Promise(function (ok, fail) {
          var helpPromise = _this11.getHelp(tEnt.getContext(), tEnt.getHelpId(), lang);
          Logger_1["default"].debug('[Help][' + tEnt.getId() + '] - Resolving');
          helpPromise.then(function (help) {
            tEnt.setHelp(help);
            ok(undefined);
          })["catch"](fail);
        }));
        Logger_1["default"].debug('[Task][' + tEnt.getId() + '] - Resolving');
        Promise.all(allPromises).then(function () {
          Logger_1["default"].debug('[Task][' + tEnt.getId() + '] - Resolved');
          accept(undefined);
        })["catch"](reject);
      });
    }
  }, {
    key: "buildPanelRequirements",
    value: function buildPanelRequirements(pEnt, lang) {
      var _this12 = this;
      return new Promise(function (accept, reject) {
        var i18NID = pEnt.getI18NID();
        if (pEnt instanceof Page_1.Page) {
          Logger_1["default"].debug('[Page][' + pEnt.getId() + '] - Resolving');
          var requiredResources = [_this12.getDataPage(pEnt.getParentTask().getTableID(), pEnt.getId(), pEnt.getContext(), lang), _this12.getI18nText(pEnt.getContext(), 'task', i18NID, undefined, lang), _this12.getHelp(pEnt.getContext(), pEnt.getHelpId(), lang)];
          Promise.all(requiredResources).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
              datapage = _ref2[0],
              i18Ntext = _ref2[1],
              help = _ref2[2];
            pEnt.setLabel(i18Ntext ? i18Ntext : datapage.getLabel());
            pEnt.removeFromAsyncRequirement(BasePanel_1.BasePanel.ASYNC_PROP_LABEL);
            pEnt.setHelp(help);
            Logger_1["default"].debug('[Page][' + pEnt.getId() + '] - Resolved');
            accept(undefined);
          })["catch"](reject);
        } else {
          var _requiredResources = [_this12.getI18nText(pEnt.getContext(), 'task', i18NID, undefined, lang), _this12.getHelp(pEnt.getContext(), pEnt.getHelpId(), lang)];
          Logger_1["default"].debug('[Panel][' + i18NID + '] - Resolving');
          Promise.all(_requiredResources).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              i18NText = _ref4[0],
              help = _ref4[1];
            if (i18NText !== undefined) {
              pEnt.setLabel(i18NText);
            }
            pEnt.removeFromAsyncRequirement(BasePanel_1.BasePanel.ASYNC_PROP_LABEL);
            pEnt.setHelp(help);
            Logger_1["default"].debug('[Panel][' + i18NID + '] - Resolved');
            accept(undefined);
          })["catch"](reject);
        }
      });
    }
  }, {
    key: "buildGroupRequirements",
    value: function buildGroupRequirements(gEnt, lang) {
      var _this13 = this;
      return new Promise(function (accept, reject) {
        var i18NID = gEnt.getPanel().getI18NID() + '.Group' + gEnt.getId();
        var requiredResources = [_this13.getI18nText(gEnt.getContext(), 'task', i18NID, undefined, lang), _this13.getHelp(gEnt.getContext(), gEnt.getHelpId(), lang)];
        Logger_1["default"].debug('[Group][' + i18NID + '] - Resolving');
        Promise.all(requiredResources).then(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            i18NText = _ref6[0],
            help = _ref6[1];
          if (i18NText !== undefined) {
            gEnt.setLabel(i18NText);
          }
          gEnt.removeFromAsyncRequirement(Group_1.Group.ASYNC_PROP_LABEL);
          gEnt.setHelp(help);
          Logger_1["default"].debug('[Group][' + i18NID + '] - Resolved');
          accept(undefined);
        })["catch"](reject);
      });
    }
  }, {
    key: "buildThemeRequirements",
    value: function buildThemeRequirements(tEnt, lang) {
      var _this14 = this;
      return new Promise(function (accept, reject) {
        var i18NID = tEnt.getTable().getId().substring(0, 6) + '.' + tEnt.getId();
        var i18NTextPromise = _this14.getI18nText(tEnt.getContext(), 'table', i18NID, undefined, lang);
        Logger_1["default"].debug('[Theme][' + i18NID + '] - Resolving');
        i18NTextPromise.then(function (i18NText) {
          if (i18NText !== undefined) {
            tEnt.setLabel(i18NText);
            tEnt.removeFromAsyncRequirement(Theme_1.Theme.ASYNC_PROP_LABEL);
          }
          Logger_1["default"].debug('[Theme][' + i18NID + '] - Resolved');
          accept(undefined);
        })["catch"](reject);
      });
    }
  }, {
    key: "buildDataFieldRequirements",
    value: function buildDataFieldRequirements(dEnt, lang) {
      var _this15 = this;
      return new Promise(function (accept, reject) {
        var allProms = [];
        var currentId = dEnt.getId();
        Logger_1["default"].debug('[DataField][' + currentId + '] - Resolving');
        var i18NID = dEnt.getTask() ? dEnt.getTask().getId() + '.' : '';
        if (dEnt.getSourcePageId()) {
          i18NID += dEnt.getSourcePageId() + '.';
        }
        i18NID += currentId;
        if (i18NID.indexOf('DOSSIER.') === 6) {
          i18NID = i18NID.replace('DOSSIER.', '.');
        }
        var isGlobal = dEnt.getTable() ? dEnt.getTable().isGlobal() : false;
        var i18NTextPromise = _this15.getI18nText(dEnt.getContext(), dEnt.getTask() ? 'task' : 'table', i18NID, isGlobal, lang);
        allProms.push(new Promise(function (ok, fail) {
          Logger_1["default"].debug('[DataField][' + i18NID + '] - Resolving');
          i18NTextPromise.then(function (i18NText) {
            if (i18NText !== undefined) {
              dEnt.setLabel(i18NText);
            }
            dEnt.removeFromAsyncRequirement(DataField_1.DataField.ASYNC_PROP_LABEL);
            Logger_1["default"].debug('[DataField][' + i18NID + '] - Resolved');
            ok(undefined);
          })["catch"](fail);
        }));
        allProms.push(new Promise(function (ok, fail) {
          var placeHolderI18NPromise = _this15.getI18nText(dEnt.getContext(), dEnt.getTask() ? 'task' : 'table', i18NID + '.PlaceHolder', isGlobal, lang);
          Logger_1["default"].debug('[PlaceHolder][' + i18NID + '.PlaceHolder' + '] - Resolving');
          placeHolderI18NPromise.then(function (placeHolderI18N) {
            if (placeHolderI18N !== undefined) {
              dEnt.setPlaceHolder(placeHolderI18N);
            }
            dEnt.removeFromAsyncRequirement(DataField_1.DataField.ASYNC_PROP_PLACEHOLDER);
            Logger_1["default"].debug('[PlaceHolder][' + i18NID + '.PlaceHolder' + '] - Resolved');
            ok(undefined);
          })["catch"](fail);
        }));
        Promise.all(allProms).then(function () {
          Logger_1["default"].debug('[DataField][' + currentId + '] - Resolved');
          accept(undefined);
        })["catch"](reject);
      });
    }
  }, {
    key: "buildFieldRequirements",
    value: function buildFieldRequirements(fEnt, lang) {
      var _this16 = this;
      return new Promise(function (accept, reject) {
        var panel = fEnt.getGroup().getPanel();
        var i18NID = panel.getFieldI18N(fEnt.getId());
        Logger_1["default"].debug('[Field][' + i18NID + '] - Resolving');
        var dataFieldId = fEnt.getDatafieldId();
        if (fEnt.isCouple() && fEnt.isCoupleKey()) {
          dataFieldId = fEnt.getLinkedCouple().getLocalKey();
        }
        var requiredResources = [_this16.getDataField(dataFieldId, fEnt.getContext(), fEnt.getTask(), lang), _this16.getI18nText(fEnt.getContext(), 'task', i18NID, undefined, lang), _this16.getI18nText(fEnt.getContext(), 'table', dataFieldId, undefined, lang), _this16.getHelp(fEnt.getContext(), fEnt.getHelpId(), lang)];
        Promise.all(requiredResources).then(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 4),
            datafield = _ref8[0],
            i18Ntext = _ref8[1],
            i18NtextGlobal = _ref8[2],
            help = _ref8[3];
          fEnt.setLinkedDataField(datafield);
          if (fEnt.getPresentation === undefined) {
            fEnt.setPresentation(datafield.getPresentation());
          }
          fEnt.setLabel(i18Ntext ? i18Ntext : i18NtextGlobal ? i18NtextGlobal : datafield.getLabel());
          fEnt.removeFromAsyncRequirement(Field_1.Field.ASYNC_PROP_LABEL);
          fEnt.setHelp(help);
          var type = fEnt.getObjectTypeFromFormatPresentation();
          if (type === 'Enum' || type === 'ListEnum' || type === 'EnumIcon') {
            var enumName = fEnt.getLinkedDataField().getEnumName();
            if (enumName.indexOf('DOSSIER.') === 6) {
              enumName = enumName.replace('DOSSIER.', '.');
            }
            var comboName = enumName;
            if (enumName === 'ByDataFieldName') {
              comboName = datafield.getId();
              if (comboName.indexOf('DOSSIER.') === 6) {
                comboName = comboName.replace('DOSSIER.', '.');
              }
            } else if (enumName === 'ByTaskAndFieldName') {
              comboName = fEnt.getTask().getId() + '_' + fEnt.getId();
            }
            _this16.getCombo(comboName, fEnt.getContext(), fEnt.getTask().getId(), lang).then(function (combo) {
              fEnt.setLinkedCombo(combo);
              fEnt.removeFromAsyncRequirement(Field_1.Field.ASYNC_PROP_COMBO);
              Logger_1["default"].debug('[Field][' + i18NID + '] - Resolved');
              accept(undefined);
            })["catch"](reject);
          } else {
            Logger_1["default"].debug('[Field][' + i18NID + '] - Resolved');
            fEnt.removeFromAsyncRequirement(Field_1.Field.ASYNC_PROP_COMBO);
            accept(undefined);
          }
        })["catch"](reject);
      });
    }
  }, {
    key: "resolveTextProperties",
    value: function resolveTextProperties(label, contextToUse) {
      if (contextToUse === undefined) {
        contextToUse = {};
      }
      return this.textResolver(label, contextToUse);
    }
  }, {
    key: "getGlobalImage",
    value: function getGlobalImage(imageName) {
      return this.server.getTokenedUrl(imageName);
    }
  }, {
    key: "getWallPaper",
    value: function getWallPaper(domain, colorTheme, wallpaperId, lang) {
      var _this17 = this;
      if (lang === undefined) {
        lang = this.locale;
      }
      return new Promise(function (resolve, reject) {
        ThemeManager_1["default"].getUserTheme(domain, colorTheme).then(function (theme) {
          if (wallpaperId === undefined || wallpaperId === '') {
            var allWallPapers = theme.getWallPapers();
            if (allWallPapers.length > 0) {
              resolve(allWallPapers[0]);
            } else {
              reject(_this17.i18nresolver('THEME_NO_WALLPAPER', lang, {}));
            }
          } else {
            if (theme.hasWallPaper(wallpaperId)) {
              resolve(wallpaperId);
            } else {
              reject(_this17.i18nresolver('WALLPAPER_NOT_FOUND', lang, {
                wallpaperId: wallpaperId,
                themeId: theme.getId()
              }));
            }
          }
        })["catch"](function () {
          reject(_this17.i18nresolver('USER_NO_THEME', lang, {}));
        });
      });
    }
  }, {
    key: "getGridIconConfig",
    value: function getGridIconConfig(gridId, taskId, context, lang) {
      var _this18 = this;
      var me = this;
      if (this.iconMappingCache === undefined) {
        this.iconMappingCache = {};
      }
      var mappingKey = 'GRID-' + gridId + '-' + taskId + '-' + context.getId();
      return new Promise(function (accept, reject) {
        if (me.iconMappingCache[mappingKey] !== undefined) {
          accept(me.iconMappingCache[mappingKey]);
          return;
        }
        var result = {
          grid: {
            icon: undefined,
            overlayBottomRight: undefined,
            overlayBottomLeft: undefined,
            overlayTopLeft: undefined,
            overlayTopRight: undefined
          }
        };
        _this18.getGridView(gridId, context, lang).then(function (gridView) {
          me.getIconConfigForElement(gridView, result, 'grid', mappingKey, taskId, context, lang).then(function (iconConfig) {
            accept(iconConfig);
          });
        });
      });
    }
  }, {
    key: "getTableIconConfig",
    value: function getTableIconConfig(tableId, taskId, context, lang) {
      var _this19 = this;
      var me = this;
      if (this.iconMappingCache === undefined) {
        this.iconMappingCache = {};
      }
      var mappingKey = 'TABLE-' + tableId + '-' + taskId + '-' + context.getId();
      return new Promise(function (accept, reject) {
        if (me.iconMappingCache[mappingKey] !== undefined) {
          accept(me.iconMappingCache[mappingKey]);
          return;
        }
        var result = {
          table: {
            icon: undefined,
            overlayBottomRight: undefined,
            overlayBottomLeft: undefined,
            overlayTopLeft: undefined,
            overlayTopRight: undefined
          }
        };
        _this19.getTable(tableId, context, lang).then(function (table) {
          me.getIconConfigForElement(table, result, 'table', mappingKey, taskId, context, lang).then(function (iconConfig) {
            accept(iconConfig);
          });
        });
      });
    }
  }, {
    key: "getIconConfigForElement",
    value: function getIconConfigForElement(configElement, result, type, mappingKey, taskId, context, lang) {
      var me = this;
      var tableConfig = configElement.getConfig();
      var allPromise = [];
      return new Promise(function (accept) {
        var _loop = function _loop(attr) {
          var iconValue = tableConfig[attr];
          if (iconValue !== undefined) {
            var inlineRegExp = /([A-Z0-9._]+)\s:(\s.+=.+,*)$/;
            var comboRegexp = /(.+)\s*:\s*(.+)/;
            var inlineMatch = inlineRegExp.exec(iconValue);
            var comboMatch = comboRegexp.exec(iconValue);
            if (inlineMatch) {
              allPromise.push(new Promise(function (accept) {
                var map = {};
                map[attr] = {
                  datafield: inlineMatch[1],
                  values: {}
                };
                var group = inlineMatch[2];
                var comaSplit = group.split(',');
                for (var index in comaSplit) {
                  var keyPair = comaSplit[index].split('=');
                  map[attr].values[keyPair[0].trim()] = keyPair[1].trim();
                }
                accept(map);
              }));
            } else if (comboMatch) {
              var enumName = undefined;
              if (type === 'grid') {
                var column = configElement.getColumnByDataFieldId(comboMatch[1].trim());
                if (column !== undefined && column !== null) {
                  enumName = column.getAttribute('enumName');
                }
              }
              if (enumName !== undefined) {
                allPromise.push(new Promise(function (accept) {
                  me.getCombo(enumName, context, taskId, lang).then(function (combo) {
                    var map = {};
                    map[attr] = {
                      datafield: comboMatch[1].trim(),
                      values: {}
                    };
                    var elements = combo.getElements();
                    for (var elemId in elements) {
                      var elem = elements[elemId];
                      map[attr].values[elem.getId()] = elem.getAttribute(comboMatch[2].trim());
                    }
                    accept(map);
                  });
                }));
              } else {
                allPromise.push(new Promise(function (accept) {
                  me.getDataField(comboMatch[1].trim(), context, null, lang).then(function (dataField) {
                    me.getComboByDataField(dataField, lang, context, taskId).then(function (combo) {
                      var map = {};
                      map[attr] = {
                        datafield: dataField.getId(),
                        values: {}
                      };
                      if (combo !== undefined) {
                        var elements = combo.getElements();
                        for (var elemId in elements) {
                          var elem = elements[elemId];
                          map[attr].values[elem.getId()] = elem.getAttribute(comboMatch[2].trim());
                        }
                      } else {
                        map[attr].values['default'] = 'file';
                      }
                      accept(map);
                    })["catch"](function () {
                      var map = {};
                      map[attr] = {
                        datafield: dataField.getId(),
                        values: {}
                      };
                      map[attr].values['default'] = 'file';
                      accept(map);
                    });
                  });
                }));
              }
            } else {
              allPromise.push(new Promise(function (accept) {
                var map = {};
                map[attr] = {
                  datafield: undefined,
                  values: {}
                };
                map[attr].values['default'] = iconValue;
                accept(map);
              }));
            }
          } else if (attr === 'icon' && type === 'table') {
            allPromise.push(new Promise(function (accept) {
              var map = {};
              map[attr] = {
                datafield: undefined,
                values: {}
              };
              map[attr].values['default'] = 'file';
              accept(map);
            }));
          }
        };
        for (var attr in result[type]) {
          _loop(attr);
        }
        result[type].identifyByNote = configElement.getConfig().identifyByNote;
        Promise.all(allPromise).then(function (results) {
          for (var i in results) {
            var iconItem = results[i];
            for (var val in iconItem) {
              result[type][val] = iconItem[val];
            }
          }
          me.iconMappingCache[mappingKey] = result;
          accept(result);
        });
      });
    }
  }, {
    key: "getTableForGridView",
    value: function getTableForGridView(gridId, context, lang) {
      var _this20 = this;
      return new Promise(function (accept) {
        _this20.getGridView(gridId, context, lang).then(function (gridConfig) {
          var columns = gridConfig.getColumns();
          for (var idx in columns) {
            var col = columns[idx];
            var datafield = undefined;
            if (col.getAttribute('objectType') === 'GridColumn') {
              datafield = col.getDataField();
            } else if (col.getAttribute('objectType') === 'GridPage') {
              var datapage = col.getDataField();
              var subfields = datapage.getConfig().elements;
              for (var elIdx in subfields) {
                var subCol = new GridView_1.Column(subfields[elIdx], context);
                if (subCol.getAttribute('objectType') === 'GridColumn') {
                  datafield = subCol.getDataField();
                  break;
                }
              }
            }
            if (datafield !== undefined) {
              _this20.getDataField(datafield.getId(), context, undefined, lang).then(function (datafieldConfig) {
                if (datafieldConfig.getTable()) {
                  _this20.getTable(datafieldConfig.getTable().getId(), context, lang).then(function (tableConfig) {
                    accept(tableConfig);
                  });
                }
              });
            }
          }
        });
      });
    }
  }, {
    key: "getHelp",
    value: function getHelp(context, id, language) {
      var _this21 = this;
      var me = this;
      if (me.helps === undefined) {
        me.helps = {};
      }
      var currentCache = me.helps[context.getId()];
      if (currentCache === undefined) {
        me.helps[context.getId()] = {};
      }
      var languageCache = me.helps[context.getId()][language];
      if (languageCache === undefined) {
        me.helps[context.getId()][language] = {};
      }
      var taskId = id.substring(0, 5);
      if (me.helps[context.getId()][language][taskId] === undefined) {
        return new Promise(function (found, failed) {
          var request = new Protocol_1.Configuration.HelpRequest(context, language + '/' + taskId);
          _this21.server.performRequest(request).then(function (result) {
            if (result.helps !== undefined) {
              for (var key in Object.keys(result.helps)) {
                var helpKey = Object.keys(result.helps)[key];
                me.helps[context.getId()][language][helpKey] = result.helps[helpKey];
              }
            }
            found(me.helps[context.getId()][language][id]);
          })["catch"](failed);
        });
      } else {
        return new Promise(function (found) {
          found(me.helps[context.getId()][language][id]);
        });
      }
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.iconMappingCache = {};
      this.helps = {};
      this.i18nTablesAndTask = {};
      var me = this;
      this.cacheList.forEach(function (item) {
        me[item] = {};
      });
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);
  return CClientConfiguration;
}();
var singleInstance = CClientConfiguration.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ColorTheme_1 = __webpack_require__(14);
exports.ColorTheme = ColorTheme_1.ColorTheme;
var AbstractTask_1 = __webpack_require__(15);
exports.AbstractTask = AbstractTask_1.AbstractTask;
var Chain_1 = __webpack_require__(30);
exports.Chain = Chain_1.Chain;
var Combo_1 = __webpack_require__(18);
exports.Combo = Combo_1.Combo;
var Couple_1 = __webpack_require__(10);
exports.Couple = Couple_1.Couple;
var DataField_1 = __webpack_require__(4);
exports.DataField = DataField_1.DataField;
var DataPage_1 = __webpack_require__(11);
exports.DataPage = DataPage_1.DataPage;
var Field_1 = __webpack_require__(3);
exports.Field = Field_1.Field;
var FieldInstance_1 = __webpack_require__(31);
exports.FieldInstance = FieldInstance_1.FieldInstance;
exports.FieldValidityLevel = FieldInstance_1.FieldValidityLevel;
var Filter_1 = __webpack_require__(19);
exports.Filter = Filter_1.Filter;
var GridView_1 = __webpack_require__(20);
exports.GridView = GridView_1.GridView;
var Group_1 = __webpack_require__(5);
exports.Group = Group_1.Group;
var Key_1 = __webpack_require__(16);
exports.Key = Key_1.Key;
var Level_1 = __webpack_require__(9);
exports.Level = Level_1.Level;
var Page_1 = __webpack_require__(7);
exports.Page = Page_1.Page;
var PageInstance_1 = __webpack_require__(38);
exports.PageInstance = PageInstance_1.PageInstance;
var Panel_1 = __webpack_require__(25);
exports.Panel = Panel_1.Panel;
var PopupMenu_1 = __webpack_require__(23);
exports.PopupMenu = PopupMenu_1.PopupMenu;
var SubPanel_1 = __webpack_require__(26);
exports.SubPanel = SubPanel_1.SubPanel;
var Table_1 = __webpack_require__(27);
exports.Table = Table_1.Table;
var Task_1 = __webpack_require__(24);
exports.Task = Task_1.Task;
var Unit_1 = __webpack_require__(39);
exports.Unit = Unit_1.Unit;
var Notification_1 = __webpack_require__(40);
exports.Notification = Notification_1.Notification;
var Help_1 = __webpack_require__(17);
exports.HelpEntry = Help_1.HelpEntry;
var ThemeManager_1 = __webpack_require__(22);
exports.ThemeManager = ThemeManager_1["default"];
var CClientConfiguration_1 = __webpack_require__(12);
exports.CClientConfiguration = CClientConfiguration_1["default"];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ColorTheme = /*#__PURE__*/function () {
  function ColorTheme(_config) {
    _classCallCheck(this, ColorTheme);
    this.properties = _config.properties || {};
    this.colors = _config.colors || {};
    this.wallpapers = _config.wallpapers || [];
    this.id = _config.id;
    this.name = _config.name;
  }
  _createClass(ColorTheme, [{
    key: "initialize",
    value: function initialize() {
      return new Promise(function (accept) {
        accept();
      });
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getColor",
    value: function getColor(id) {
      if (this.colors[id] !== undefined) {} else if (/^#(?:[0-9a-f]{3}){1,2}$/i.test(id)) {
        return id;
      } else {
        return null;
      }
    }
  }, {
    key: "getColors",
    value: function getColors() {
      return this.colors;
    }
  }, {
    key: "getProperty",
    value: function getProperty(propertyId) {
      return this.properties[propertyId];
    }
  }, {
    key: "getWallPapers",
    value: function getWallPapers() {
      return this.wallpapers;
    }
  }, {
    key: "hasWallPaper",
    value: function hasWallPaper(id) {
      for (var i in this.wallpapers) {
        if (this.wallpapers[i] === id) {
          return true;
        }
      }
      return false;
    }
  }]);
  return ColorTheme;
}();
exports.ColorTheme = ColorTheme;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var BasePanel_1 = __webpack_require__(2);
var AbstractTask = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(AbstractTask, _ConfigurationElement);
  var _super = _createSuper(AbstractTask);
  function AbstractTask(config, context) {
    _classCallCheck(this, AbstractTask);
    return _super.call(this, config, context.clone());
  }
  _createClass(AbstractTask, [{
    key: "getUnitID",
    value: function getUnitID() {
      return this.getValueOrDefault('unitId');
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.getValueOrDefault('type');
    }
  }, {
    key: "getReadableType",
    value: function getReadableType() {
      var type = this.getValueOrDefault('type');
      switch (type) {
        case 'R':
          return 'Dossier';
        case 'B':
          if (this.getConfig().inputInterface === 'History/Planning') {
            return 'Calendar';
          } else {
            return 'Simple';
          }
        case 'F':
          return 'Double';
        case 'V':
        case 'W':
          return 'View';
        case 'L':
        case 'M':
          return 'List';
        default:
          throw new Error('No Handled type "' + type + '"');
      }
    }
  }, {
    key: "getTableID",
    value: function getTableID() {
      return this.getValueOrDefault('tableId');
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return this.getValueOrDefault('icon');
    }
  }, {
    key: "getExistenceConditions",
    value: function getExistenceConditions() {
      return this.getValueOrDefault('existence');
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.getBooleanValueOrDefault('visible', true);
    }
  }, {
    key: "setInstanceId",
    value: function setInstanceId(id) {
      this.config.instanceId = id;
    }
  }, {
    key: "getInstanceId",
    value: function getInstanceId() {
      return this.getValueOrDefault('instanceId');
    }
  }, {
    key: "setAccesses",
    value: function setAccesses(access) {
      this.config.access = access;
    }
  }, {
    key: "setPageAccess",
    value: function setPageAccess(pageAccess) {
      this.config.pagesAccess = pageAccess;
    }
  }, {
    key: "getAccess",
    value: function getAccess() {
      return this.config.access;
    }
  }, {
    key: "getHeaderEnabledActions",
    value: function getHeaderEnabledActions() {
      return this.config.headerEnabledActions;
    }
  }, {
    key: "getPagesAccess",
    value: function getPagesAccess() {
      return this.config.pagesAccess;
    }
  }, {
    key: "setInitialPropsOverride",
    value: function setInitialPropsOverride(initialPropsOverride) {
      this.config.initialPropsOverride = initialPropsOverride;
    }
  }, {
    key: "getInitialPropsOverride",
    value: function getInitialPropsOverride() {
      return this.config.initialPropsOverride;
    }
  }, {
    key: "getHelpId",
    value: function getHelpId() {
      return this.getId();
    }
  }], [{
    key: "setReadOnly",
    value: function setReadOnly(descriptor, pageAccess) {
      for (var i in descriptor.pages) {
        var page = descriptor.pages[i];
        if (pageAccess[page.id].indexOf('M') < 0) {
          BasePanel_1.BasePanel.setReadOnly(page);
        }
      }
    }
  }]);
  return AbstractTask;
}(ConfigurationElement_1.ConfigurationElement);
exports.AbstractTask = AbstractTask;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Key = /*#__PURE__*/function () {
  function Key(config, context) {
    _classCallCheck(this, Key);
    this.datafields = config.datafields;
    this.context = context;
  }
  _createClass(Key, [{
    key: "getDatafield",
    value: function getDatafield(dfId) {
      return this.datafields[dfId];
    }
  }, {
    key: "getDatafields",
    value: function getDatafields() {
      return this.datafields;
    }
  }, {
    key: "hasDatafield",
    value: function hasDatafield(dfId) {
      return this.datafields[dfId] !== undefined;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context;
    }
  }]);
  return Key;
}();
exports.Key = Key;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var HelpEntry = /*#__PURE__*/function () {
  function HelpEntry(_text, _context) {
    _classCallCheck(this, HelpEntry);
    this.text = _text;
    this.context = _context;
  }
  _createClass(HelpEntry, [{
    key: "getText",
    value: function getText() {
      return this.text;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context;
    }
  }]);
  return HelpEntry;
}();
exports.HelpEntry = HelpEntry;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var ComboElement = /*#__PURE__*/function () {
  function ComboElement(_attributes) {
    _classCallCheck(this, ComboElement);
    this.attributes = _attributes;
  }
  _createClass(ComboElement, [{
    key: "getId",
    value: function getId() {
      return this.attributes['id'];
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.attributes['label'];
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(attributeName) {
      attributeName = attributeName.charAt(0).toLowerCase() + attributeName.slice(1);
      return this.attributes[attributeName];
    }
  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return Object.keys(this.attributes);
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this.attributes;
    }
  }]);
  return ComboElement;
}();
exports.ComboElement = ComboElement;
var Combo = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Combo, _ConfigurationElement);
  var _super = _createSuper(Combo);
  function Combo(config, context) {
    var _this;
    _classCallCheck(this, Combo);
    _this = _super.call(this, config, context);
    _this.elements = [];
    for (var key in config.elements) {
      _this.elements.push(new ComboElement(config.elements[key]));
    }
    return _this;
  }
  _createClass(Combo, [{
    key: "getElements",
    value: function getElements() {
      return this.elements;
    }
  }, {
    key: "getElement",
    value: function getElement(id) {
      for (var key in this.elements) {
        var currentEl = this.elements[key];
        if (currentEl.getId() === id) {
          return currentEl;
        }
      }
      return null;
    }
  }]);
  return Combo;
}(ConfigurationElement_1.ConfigurationElement);
exports.Combo = Combo;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var FilterElement = /*#__PURE__*/function () {
  function FilterElement(_attributes) {
    _classCallCheck(this, FilterElement);
    this.attributes = _attributes;
  }
  _createClass(FilterElement, [{
    key: "getId",
    value: function getId() {
      return this.attributes['id'];
    }
  }, {
    key: "getDatafieldId",
    value: function getDatafieldId() {
      return this.attributes['datafieldId'];
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return this.attributes['defaultValue'];
    }
  }, {
    key: "getPermanentValue",
    value: function getPermanentValue() {
      return this.attributes['permanentValue'];
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(attributeName) {
      return this.attributes[attributeName];
    }
  }, {
    key: "mustBeShownOnNavigator",
    value: function mustBeShownOnNavigator() {
      return this.attributes['showOnNavigator'] === true;
    }
  }]);
  return FilterElement;
}();
exports.FilterElement = FilterElement;
var Filter = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Filter, _ConfigurationElement);
  var _super = _createSuper(Filter);
  function Filter(config, context) {
    var _this;
    _classCallCheck(this, Filter);
    _this = _super.call(this, config, context);
    _this.type = config.type;
    _this.sort = config.sort;
    _this.elements = [];
    for (var key in config.elements) {
      _this.elements.push(new FilterElement(config.elements[key]));
    }
    return _this;
  }
  _createClass(Filter, [{
    key: "getElements",
    value: function getElements() {
      return this.elements;
    }
  }, {
    key: "getElement",
    value: function getElement(datafieldId) {
      for (var key in this.elements) {
        var currentEl = this.elements[key];
        if (currentEl.getDatafieldId() === datafieldId) {
          return currentEl;
        }
      }
      return null;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "getSort",
    value: function getSort() {
      return this.sort;
    }
  }]);
  return Filter;
}(ConfigurationElement_1.ConfigurationElement);
exports.Filter = Filter;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var DataField_1 = __webpack_require__(4);
var CClientConfiguration_1 = __webpack_require__(12);
var DataCell = /*#__PURE__*/function () {
  function DataCell(_styledvalue) {
    _classCallCheck(this, DataCell);
    this.styles = [];
    var styleReg = /<SC=(.+)>/g;
    var match = styleReg.exec(_styledvalue);
    while (match != null) {
      this.styles.push(match[1]);
      match = styleReg.exec(_styledvalue);
    }
    var dataReg = /(?:<SC=.+>)*(.*)/g;
    match = dataReg.exec(_styledvalue);
    this.value = match !== null ? match[1] : '';
  }
  _createClass(DataCell, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      return this.styles;
    }
  }]);
  return DataCell;
}();
exports.DataCell = DataCell;
var DataRow = /*#__PURE__*/function () {
  function DataRow(_cells, _column) {
    _classCallCheck(this, DataRow);
    this.styles = [];
    this.cells = [];
    var styleReg = /<SL=(.+)>/g;
    var match = styleReg.exec(_cells);
    while (match != null) {
      this.styles.push(match[1]);
      match = styleReg.exec(_cells);
    }
    var dataReg = /(?:<SL=.+>)*(.*)/g;
    match = dataReg.exec(_cells);
    var cellsContent = match !== null ? match[1].split('[C]') : [];
    for (var cellEntry in cellsContent) {
      this.cells.push(new DataCell(cellsContent[cellEntry]));
    }
    this.columns = _column;
  }
  _createClass(DataRow, [{
    key: "getCells",
    value: function getCells() {
      return this.cells;
    }
  }, {
    key: "getIndexedCell",
    value: function getIndexedCell(index) {
      if (index < 0 || index > this.cells.length) {
        return null;
      } else {
        return this.cells[index];
      }
    }
  }, {
    key: "getIdentifiedCell",
    value: function getIdentifiedCell(id) {
      var index = 0;
      for (var key in this.columns) {
        if (this.columns[key].getId() === id) {
          return this.getIndexedCell(index);
        }
        index++;
      }
      console.error('The requested column ' + id + ' does not exist in the grid.');
      return null;
    }
  }]);
  return DataRow;
}();
exports.DataRow = DataRow;
var Column = /*#__PURE__*/function () {
  function Column(_attributes, context) {
    _classCallCheck(this, Column);
    this.context = context;
    this.attributes = _attributes;
    this.datafield = new DataField_1.DataField(this.attributes, null, null, null, this.context);
    this.subColumns = [];
    for (var subElId in this.getAttribute('elements')) {
      var subEl = this.getAttribute('elements')[subElId];
      this.subColumns.push(new Column(subEl, context));
    }
  }
  _createClass(Column, [{
    key: "getId",
    value: function getId() {
      return this.attributes['id'];
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.attributes['label'];
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this.attributes['format'];
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      if (this.attributes['width'] === undefined) {
        return 0;
      } else {
        return parseInt(this.attributes['width']);
      }
    }
  }, {
    key: "getDatafieldId",
    value: function getDatafieldId() {
      return this.attributes['datafieldId'];
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(attributeName) {
      return this.attributes[attributeName];
    }
  }, {
    key: "getDataField",
    value: function getDataField() {
      return this.datafield;
    }
  }, {
    key: "setDataField",
    value: function setDataField(df) {
      this.datafield = df;
    }
  }, {
    key: "getSubColumns",
    value: function getSubColumns() {
      return this.subColumns;
    }
  }]);
  return Column;
}();
exports.Column = Column;
var GridView = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(GridView, _ConfigurationElement);
  var _super = _createSuper(GridView);
  function GridView(config, context) {
    var _this;
    _classCallCheck(this, GridView);
    _this = _super.call(this, config, context);
    _this.contextTask = config.contextTask;
    _this.columns = [];
    for (var key in config.elements) {
      _this.columns.push(new Column(config.elements[key], context));
    }
    var rowsData = config.data ? config.data.split('[L]') : [];
    _this.rows = [];
    for (var _key in rowsData) {
      _this.rows.push(new DataRow(rowsData[_key], _this.columns));
    }
    return _this;
  }
  _createClass(GridView, [{
    key: "initialize",
    value: function initialize(lang) {
      var _this2 = this;
      var me = this;
      return new Promise(function (accept) {
        var datafieldsPromises = [];
        if (_this2.contextTask !== undefined) {
          CClientConfiguration_1["default"].getTask(_this2.contextTask, _this2.getContext(), lang).then(function (taskConfig) {
            datafieldsPromises = _this2.generateDatafieldConfigRequest(taskConfig, lang);
            Promise.all(datafieldsPromises).then(function (datafields) {
              for (var dfId in datafields) {
                var datafield = datafields[dfId];
                var column = _this2.getColumnByDataFieldId(datafield.getId());
                var df = _this2.mergeDatafieldWithGridConfig(datafield);
                column.setDataField(df);
              }
              accept(undefined);
            });
          });
        } else {
          datafieldsPromises = _this2.generateDatafieldConfigRequest(undefined, lang);
          Promise.all(datafieldsPromises).then(function (datafields) {
            for (var dfId in datafields) {
              var datafield = datafields[dfId];
              var column = _this2.getColumnByDataFieldId(datafield.getId());
              var df = _this2.mergeDatafieldWithGridConfig(datafield);
              column.setDataField(df);
            }
            accept(undefined);
          });
        }
      });
    }
  }, {
    key: "generateDatafieldConfigRequest",
    value: function generateDatafieldConfigRequest(taskConfig, lang) {
      var promises = [];
      for (var colId in this.getColumns()) {
        var column = this.getColumns()[colId];
        if (column.getAttribute('objectType') === 'GridColumn') {
          promises.push(CClientConfiguration_1["default"].getDataField(column.getDatafieldId(), this.getContext(), taskConfig, lang));
        } else if (column.getAttribute('objectType') === 'GridLevel') {
          var elements = column.getSubColumns();
          for (var id in elements) {
            var subfield = elements[id];
            if (subfield.objectType === 'GridColumn') {
              promises.push(CClientConfiguration_1["default"].getDataField(subfield.datafieldId, this.getContext(), taskConfig, lang));
            }
          }
        }
      }
      return promises;
    }
  }, {
    key: "getColumns",
    value: function getColumns() {
      return this.columns;
    }
  }, {
    key: "getColumn",
    value: function getColumn(id) {
      for (var key in this.columns) {
        var currentCol = this.columns[key];
        if (currentCol.getId() === id) {
          return currentCol;
        }
      }
      return null;
    }
  }, {
    key: "getColumnByDataFieldId",
    value: function getColumnByDataFieldId(id) {
      for (var key in this.columns) {
        var currentCol = this.columns[key];
        if (currentCol.getDatafieldId() === id) {
          return currentCol;
        } else if (currentCol.getAttribute('objectType') === 'GridLevel') {
          var elements = currentCol.getSubColumns();
          for (var subId in elements) {
            var subfield = elements[subId];
            if (subfield.datafieldId === id) {
              return subfield;
            }
          }
        }
      }
      return null;
    }
  }, {
    key: "getRows",
    value: function getRows() {
      return this.rows;
    }
  }, {
    key: "getDatafieldKeyColumns",
    value: function getDatafieldKeyColumns() {
      var result = [];
      for (var i in this.columns) {
        var column = this.columns[i];
        if (column.getDataField() && column.getDataField().isKey()) {
          result.push(column.getDataField());
        }
      }
      return result;
    }
  }, {
    key: "mergeDatafieldWithGridConfig",
    value: function mergeDatafieldWithGridConfig(datafield) {
      var columnDatafield = new DataField_1.DataField(datafield.getClonedConfig(), datafield.getDataPage(), datafield.getTable(), datafield.getTask(), datafield.getContext());
      var col = this.getColumnByDataFieldId(datafield.getId());
      if (col.getLabel() !== undefined) {
        columnDatafield.setLabel(col.getLabel());
      }
      if (col.getFormat() !== undefined) {
        columnDatafield.setFormat(col.getFormat());
      }
      if (col.getAttribute('enumName') !== undefined) {
        columnDatafield.setEnumName(col.getAttribute('enumName'));
      }
      return columnDatafield;
    }
  }]);
  return GridView;
}(ConfigurationElement_1.ConfigurationElement);
exports.GridView = GridView;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var TaskRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(TaskRequest, _MobileRequest_1$defa);

  var _super = _createSuper(TaskRequest);

  function TaskRequest(service, method, domainContext, task) {
    var _this;

    _classCallCheck(this, TaskRequest);

    _this = _super.call(this, 'task', service, method, domainContext);
    _this.taskId = task;
    return _this;
  }

  _createClass(TaskRequest, [{
    key: "getTaskId",
    value: function getTaskId() {
      return this.taskId;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.taskId;
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setKeyContext",
    value: function setKeyContext(context) {
      this.key = context;
    }
  }, {
    key: "setFilterContext",
    value: function setFilterContext(context) {
      this.filter = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined,
          key: this.key ? this.key.toJSON() : undefined,
          filter: this.filter ? this.filter.toJSON() : undefined,
          message: this.message ? this.message : undefined
        }
      };
    }
  }, {
    key: "setMessageContext",
    value: function setMessageContext(response) {
      this.message = response;
    }
  }]);

  return TaskRequest;
}(MobileRequest_1["default"]);

exports.TaskRequest = TaskRequest;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var ConfigurationRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(ConfigurationRequest, _MobileRequest_1$defa);

  var _super = _createSuper(ConfigurationRequest);

  function ConfigurationRequest(service, domain, _id) {
    var _this;

    _classCallCheck(this, ConfigurationRequest);

    _this = _super.call(this, 'configuration', service, 'GET', domain);
    _this.id = _id;
    return _this;
  }

  _createClass(ConfigurationRequest, [{
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;

      if (this.domainContext !== undefined) {
        url += '/' + this.domainContext.getId();
      }

      url += '/' + this.service;

      if (this.id !== undefined) {
        url += '/' + this.id;
      }

      return url;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }]);

  return ConfigurationRequest;
}(MobileRequest_1["default"]);

exports.ConfigurationRequest = ConfigurationRequest;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileMessage_1 = __webpack_require__(8);

var MobileRequest = /*#__PURE__*/function (_MobileMessage_1$defa) {
  _inherits(MobileRequest, _MobileMessage_1$defa);

  var _super = _createSuper(MobileRequest);

  function MobileRequest(controller, service, method, domainContext) {
    var _this;

    _classCallCheck(this, MobileRequest);

    _this = _super.call(this);
    _this.controller = controller;
    _this.service = service;
    _this.method = method;
    _this.domainContext = domainContext;
    _this.nbRetry = 0;
    return _this;
  }

  _createClass(MobileRequest, [{
    key: "getStatus",
    value: function getStatus() {
      return 100;
    }
  }, {
    key: "getController",
    value: function getController() {
      return this.controller;
    }
  }, {
    key: "getService",
    value: function getService() {
      return this.service;
    }
  }, {
    key: "getMethod",
    value: function getMethod() {
      return this.method;
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return this.domainContext;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {};
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'MobileRequest';
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;

      if (this.domainContext !== undefined) {
        url += '/' + this.domainContext.getDomain();
      }

      url += '/' + this.service;
      return url;
    }
  }, {
    key: "setSessionVars",
    value: function setSessionVars(vars) {
      this.sessionVars = vars;
    }
  }, {
    key: "getSessionVars",
    value: function getSessionVars() {
      if (this.sessionVars === undefined) {
        this.sessionVars = {};
      }

      if (this.sessionVars['CGE_EXERCICE'] === undefined && this.domainContext !== undefined && this.domainContext !== null && this.domainContext.getExercice() !== undefined) {
        this.sessionVars['CGE_EXERCICE'] = this.domainContext.getExercice().id;
      }

      return this.sessionVars;
    }
  }, {
    key: "setSessionVar",
    value: function setSessionVar(varName, varValue) {
      this.getSessionVars()[varName] = varValue;
    }
  }, {
    key: "hasSubRequests",
    value: function hasSubRequests() {
      return false;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return [];
    }
  }, {
    key: "getTaskId",
    value: function getTaskId() {
      return '';
    }
  }, {
    key: "isLazy",
    value: function isLazy() {
      return this.lazyAuthentication !== undefined ? this.lazyAuthentication : true;
    }
  }, {
    key: "getNbRetry",
    value: function getNbRetry() {
      return this.nbRetry;
    }
  }, {
    key: "incrementRetry",
    value: function incrementRetry() {
      this.nbRetry++;
    }
  }, {
    key: "setLastError",
    value: function setLastError(error) {
      this.lastError = error;
    }
  }, {
    key: "getLastError",
    value: function getLastError() {
      return this.lastError;
    }
  }]);

  return MobileRequest;
}(MobileMessage_1["default"]);

exports["default"] = MobileRequest;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var AuthenticationRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(AuthenticationRequest, _MobileRequest_1$defa);

  var _super = _createSuper(AuthenticationRequest);

  function AuthenticationRequest(service, method) {
    _classCallCheck(this, AuthenticationRequest);

    return _super.call(this, 'auth', service, method, undefined);
  }

  _createClass(AuthenticationRequest, [{
    key: "getName",
    value: function getName() {
      return 'AuthenticationRequest';
    }
  }]);

  return AuthenticationRequest;
}(MobileRequest_1["default"]);

exports.AuthenticationRequest = AuthenticationRequest;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var FieldOperationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(FieldOperationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(FieldOperationRequest);

  function FieldOperationRequest(service, domain, task) {
    _classCallCheck(this, FieldOperationRequest);

    return _super.call(this, service, 'POST', domain, task);
  }

  _createClass(FieldOperationRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "setFieldId",
    value: function setFieldId(newId) {
      this.fieldId = newId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(FieldOperationRequest.prototype), "getSerializable", this).call(this);

      Object.assign(content.request1, {
        fieldId: this.fieldId
      });
      return content;
    }
  }]);

  return FieldOperationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = FieldOperationRequest;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var Server_1 = __webpack_require__(15);

exports.Server = Server_1["default"];

var MockupServer_1 = __webpack_require__(20);

exports.MockupServer = MockupServer_1["default"];

var DomainContext_1 = __webpack_require__(9);

exports.DomainContext = DomainContext_1["default"];

var DomainManager_1 = __webpack_require__(21);

exports.DomainManager = DomainManager_1["default"];

var Context_1 = __webpack_require__(11);

exports.Context = Context_1["default"];

var Contexts_1 = __webpack_require__(22);

exports.ContextsCollection = Contexts_1["default"];

var Authentication_1 = __webpack_require__(23);

exports.Authentication = Authentication_1["default"];

var Portal_1 = __webpack_require__(27);

exports.Portal = Portal_1["default"];

var Configuration_1 = __webpack_require__(30);

exports.Configuration = Configuration_1["default"];

var Task_1 = __webpack_require__(42);

exports.Task = Task_1["default"];

var MobileMessage_1 = __webpack_require__(8);

exports.MobileMessage = MobileMessage_1["default"];

var MobileRequest_1 = __webpack_require__(2);

exports.MobileRequest = MobileRequest_1["default"];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.SEVERE = 1;
    this.WARNING = 2;
    this.FINE = 3;
    this.FINER = 4;
    this.FINEST = 5;
    this.DEBUG = 6;
    this.currentLevel = 2;
  }

  _createClass(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      this.currentLevel = level;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.currentLevel;
    }
  }, {
    key: "severe",
    value: function severe(message) {
      this.displayMessage('\x1b[31m', 'SEVERE', message, this.SEVERE);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      this.displayMessage('\x1b[33m', 'WARNING', message, this.WARNING);
    }
  }, {
    key: "fine",
    value: function fine(message) {
      this.displayMessage('\x1b[32m', 'FINE', message, this.FINE);
    }
  }, {
    key: "finer",
    value: function finer(message) {
      this.displayMessage('\x1b[32m', 'FINER', message, this.FINER);
    }
  }, {
    key: "finest",
    value: function finest(message) {
      this.displayMessage('\x1b[32m', 'FINEST', message, this.FINEST);
    }
  }, {
    key: "debug",
    value: function debug(message) {
      this.displayMessage('\x1b[34m', 'DEBUG', message, this.DEBUG);
    }
  }, {
    key: "displayMessage",
    value: function displayMessage(color, label, message, level) {
      if (level <= this.currentLevel) {
        console.log(color + label + '\x1b[0m %s', message);
      }
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return Logger;
}();

var singleInstance = Logger.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetStatusRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetStatusRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetStatusRequest);

  function GetStatusRequest(initialMessage, initialResolve, initialReject, domain, task, time, count, pid) {
    var _this;

    _classCallCheck(this, GetStatusRequest);

    _this = _super.call(this, 'getStatus', 'GET', domain, task);
    _this.time = time;
    _this.count = count;
    _this.pid = pid;
    _this.internalMessage = initialMessage;
    _this.resolve = initialResolve;
    _this.reject = initialReject;
    return _this;
  }

  _createClass(GetStatusRequest, [{
    key: "getPid",
    value: function getPid() {
      return this.pid;
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return this.count;
    }
  }, {
    key: "getTime",
    value: function getTime() {
      return this.time;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          pid: this.pid
        }
      };
    }
  }, {
    key: "getInitialMessage",
    value: function getInitialMessage() {
      return this.internalMessage;
    }
  }, {
    key: "getInitialMessageResolve",
    value: function getInitialMessageResolve() {
      return this.resolve;
    }
  }, {
    key: "getInitialMessageReject",
    value: function getInitialMessageReject() {
      return this.reject;
    }
  }]);

  return GetStatusRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetStatusRequest;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileMessage = /*#__PURE__*/function () {
  function MobileMessage() {
    _classCallCheck(this, MobileMessage);
  }

  _createClass(MobileMessage, [{
    key: "getStatus",
    value: function getStatus() {
      return -1;
    }
  }, {
    key: "isPrettyPrinting",
    value: function isPrettyPrinting(response) {
      if (!response) {
        return this.forcePretty();
      } else {
        return response.isPrettyPrint();
      }
    }
  }, {
    key: "serializeNull",
    value: function serializeNull() {
      return false;
    }
  }, {
    key: "forcePretty",
    value: function forcePretty() {
      return false;
    }
  }]);

  return MobileMessage;
}();

exports["default"] = MobileMessage;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainContext = /*#__PURE__*/function () {
  function DomainContext(_domain, _id, info) {
    _classCallCheck(this, DomainContext);

    this.domain = _domain;

    if (_id) {
      this.id = _id;
    } else {
      this.id = this.generateRandomId();
    }

    this.infos = info;
  }

  _createClass(DomainContext, [{
    key: "getDomain",
    value: function getDomain() {
      return this.domain;
    }
  }, {
    key: "getInfos",
    value: function getInfos() {
      return this.infos;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getExercice",
    value: function getExercice() {
      return this.exercice;
    }
  }, {
    key: "setExercice",
    value: function setExercice(exercice) {
      this.exercice = exercice;
    }
  }, {
    key: "clone",
    value: function clone() {
      var newDomainContext = new DomainContext(this.domain, this.id);
      newDomainContext.setExercice(this.exercice);
      return newDomainContext;
    }
  }, {
    key: "generateRandomId",
    value: function generateRandomId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }]);

  return DomainContext;
}();

exports["default"] = DomainContext;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var DomainConfigurationsRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(DomainConfigurationsRequest, _AuthenticationReques);

  var _super = _createSuper(DomainConfigurationsRequest);

  function DomainConfigurationsRequest(domains) {
    var _this;

    _classCallCheck(this, DomainConfigurationsRequest);

    _this = _super.call(this, 'domains', 'GET');
    _this.domains = domains;
    return _this;
  }

  _createClass(DomainConfigurationsRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          domains: this.domains
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'DomainConfigurationsRequest';
    }
  }]);

  return DomainConfigurationsRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.DomainConfigurationsRequest = DomainConfigurationsRequest;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Context = /*#__PURE__*/function () {
  function Context(attributes, options) {
    _classCallCheck(this, Context);

    this.attributes = attributes || {};
    this.options = options || {};
    this.attributes.parameters = attributes.parameters || {};
    this.attributes.screen = attributes.screen || [];
    this.attributes.contextId = attributes.contextId || '';
  }

  _createClass(Context, [{
    key: "setContextId",
    value: function setContextId(newId) {
      this.attributes.contextId = newId;
    }
  }, {
    key: "getContextId",
    value: function getContextId() {
      return this.attributes.contextId;
    }
  }, {
    key: "addParameter",
    value: function addParameter(parKey, parValue) {
      this.attributes.parameters[parKey] = parValue;
    }
  }, {
    key: "getParameter",
    value: function getParameter(parKey) {
      return this.attributes.parameters[parKey];
    }
  }, {
    key: "hasParameter",
    value: function hasParameter(parKey) {
      return this.attributes.parameters.hasOwnProperty(parKey);
    }
  }, {
    key: "addPanelFields",
    value: function addPanelFields(fieldsDefinition, panelId) {
      this.attributes.screen.push({
        panelId: panelId,
        fields: fieldsDefinition
      });
    }
  }, {
    key: "getPanelFields",
    value: function getPanelFields(panelId) {
      var entries = this.attributes.screen || [];

      for (var key in entries) {
        if (entries[key].panelId === panelId) {
          return entries[key].fields;
        }
      }
    }
  }, {
    key: "addFields",
    value: function addFields(fieldsDefinition) {
      if (!fieldsDefinition) {
        return;
      }

      if (_typeof(fieldsDefinition) === 'object') {
        if (fieldsDefinition.toString().indexOf('Array') !== -1) {
          this.attributes.screen.concat(fieldsDefinition);
        } else {
          for (var defKey in fieldsDefinition) {
            var fDef = fieldsDefinition[defKey];

            if (!fDef.key) {
              fDef.key = defKey;
            }

            this.attributes.screen.push(fDef);
          }
        }
      } else {
        console.warn('Context', 'addFields', 'Wrong format for fields to add');
      }
    }
  }, {
    key: "updateField",
    value: function updateField(fieldId, nameKey, newValue) {
      if (nameKey === undefined) {
        nameKey = 'name';
      }

      var fields = this.attributes.screen;

      for (var key in fields) {
        if (fields[key][nameKey] === fieldId) {
          var rightField = fields[key];

          if (_typeof(newValue) === 'object') {
            for (var newValKey in newValue) {
              rightField[newValKey] = newValue[newValKey];
            }
          } else {
            fields[key].value = newValue;
          }
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var context = {
        screen: this.attributes.screen
      };
      var params = this.attributes.parameters;

      for (var key in params) {
        context[key] = params[key];
      }

      return context;
    }
  }, {
    key: "reset",
    value: function reset(resetConfig) {
      if (resetConfig.parameters) {
        this.attributes.parameters = {};
      }

      if (resetConfig.screen) {
        this.attributes.screen = [];
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(content, type) {
      var context = new Context({
        contextId: type
      });

      for (var key in content) {
        if (key === 'screen') {
          context.attributes.screen = content[key];
        } else {
          context.attributes.parameters[key] = content[key];
        }
      }

      return context;
    }
  }]);

  return Context;
}();

exports["default"] = Context;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var I18NRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(I18NRequest, _ConfigurationRequest);

  var _super = _createSuper(I18NRequest);

  function I18NRequest(domain, _id) {
    _classCallCheck(this, I18NRequest);

    return _super.call(this, 'texts', domain, _id);
  }

  return _createClass(I18NRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.I18NRequest = I18NRequest;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetRecordRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetRecordRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetRecordRequest);

  function GetRecordRequest(domain, task) {
    _classCallCheck(this, GetRecordRequest);

    return _super.call(this, 'getRecord', 'GET', domain, task);
  }

  _createClass(GetRecordRequest, [{
    key: "setKeyContext",
    value: function setKeyContext(context) {
      this.key = context;
    }
  }, {
    key: "setGridId",
    value: function setGridId(newId) {
      this.gridId = newId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          key: this.key ? this.key.toJSON() : undefined
        }
      };
    }
  }]);

  return GetRecordRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetRecordRequest;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __webpack_require__(16);

var Logger_1 = __webpack_require__(6);

var sessionStorage = __webpack_require__(17);

if (typeof localStorage === 'undefined' || localStorage === null) {
  var LocalStorage = __webpack_require__(18).LocalStorage;

  global['localStorage'] = new LocalStorage('./tmp-storage');
}

var querystring = __webpack_require__(19);

var GetStatus_1 = __webpack_require__(7);

var DomainContext_1 = __webpack_require__(9);

var sai_protocol_1 = __webpack_require__(5);

var DomainConfigurationsRequest_1 = __webpack_require__(10);

var Server = /*#__PURE__*/function () {
  function Server() {
    _classCallCheck(this, Server);

    this.requests = [];
    this.pendingCfgPromises = {};
  }

  _createClass(Server, [{
    key: "initialize",
    value: function initialize(options) {
      this.options = options;

      if (options.loglevel) {
        Logger_1["default"].setLevel(options.loglevel);
      }

      this.maxRetry = options.maxRetry ? options.maxRetry : 2;

      if (options.loglevel >= Logger_1["default"].FINE) {
        axios_1["default"].interceptors.response.use(function (response) {
          Logger_1["default"].finest('Response to ' + response.config.url);

          if (options.loglevel >= Logger_1["default"].DEBUG) {
            Logger_1["default"].debug(response);
          } else if (response.status !== 200) {
            Logger_1["default"].fine(response.data);
          } else if (options.loglevel >= Logger_1["default"].FINEST) {
            Logger_1["default"].finest(response.data);
          }

          return response;
        });
      }

      if (options.loglevel >= Logger_1["default"].FINER) {
        axios_1["default"].interceptors.request.use(function (request) {
          Logger_1["default"].finer('Request to' + request.url);

          if (options.loglevel >= Logger_1["default"].DEBUG) {
            Logger_1["default"].debug(request);
          } else if (options.loglevel >= Logger_1["default"].FINEST) {
            Logger_1["default"].finest(request.data);
          }

          return request;
        });
      }
    }
  }, {
    key: "getTokenedUrl",
    value: function getTokenedUrl(url) {
      if (!url) {
        return '';
      }

      var hasSlash = this.options.serverUrl.endsWith('/');

      if (!this.hasToken() || url.indexOf('public/') !== -1 || url.indexOf('configuration/') !== -1) {
        return this.options.serverUrl + (hasSlash ? '' : '/') + url;
      } else {
        return this.options.serverUrl + (hasSlash ? '' : '/') + this.token + '/' + url;
      }
    }
  }, {
    key: "hasToken",
    value: function hasToken() {
      return this.token !== undefined && this.token.length > 0;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.token = token;
      sessionStorage.saiUserToken = JSON.stringify(token);
    }
  }, {
    key: "getMessageUrl",
    value: function getMessageUrl(requestMessage) {
      var hasSlash = this.options.serverUrl.endsWith('/');
      return this.options.serverUrl + (hasSlash ? '' : '/') + requestMessage.getUrl();
    }
  }, {
    key: "performRequest",
    value: function performRequest(requestMessage) {
      var _this = this;

      var allRequestsMessages = [requestMessage];

      if (requestMessage.hasSubRequests()) {
        allRequestsMessages = allRequestsMessages.concat(requestMessage.getSubRequests());
      }

      var allPromises = [];
      var me = this;

      var _loop = function _loop(key) {
        var reqMessage = allRequestsMessages[key];

        var finalUrl = _this.getMessageUrl(reqMessage);

        var isConfigCall = finalUrl.indexOf('configuration/') > 0;

        if (!isConfigCall || isConfigCall && _this.pendingCfgPromises[finalUrl] === undefined) {
          var remoteCall = new Promise(function (resolve, reject) {
            var type = reqMessage.getMethod();

            if (type === undefined) {
              console.warn('Missing type in ' + reqMessage.getName() + ' message, assuming GET');
              type = 'GET';
            }

            var device = me.options.deviceType || 'web';
            var data = {};
            var requestParams = reqMessage.getSerializable();

            for (var _key in reqMessage.getSerializable()) {
              if (typeof requestParams[_key] !== 'string') {
                data[_key] = JSON.stringify(requestParams[_key]);
              } else {
                data[_key] = requestParams[_key];
              }
            }

            data['sessionVars'] = JSON.stringify(reqMessage.getSessionVars());
            data['device'] = device;
            var alreadyPerformed = false;

            if (localStorage !== undefined) {
              var item = localStorage.getItem(reqMessage.getUrl());

              if (item !== null) {
                resolve(JSON.parse(item));
                alreadyPerformed = true;
                return;
              }
            }

            var requestHeaders = {
              post: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              put: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              patch: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            };

            if (reqMessage.isLazy() && _this.hasToken()) {
              requestHeaders['X-Token'] = _this.token;
            }

            ;

            if (!alreadyPerformed) {
              _this.performSecuredAjax(finalUrl, type.toLocaleLowerCase(), data, requestHeaders, resolve, reject, reqMessage);
            }
          });

          if (isConfigCall) {
            _this.pendingCfgPromises[finalUrl] = remoteCall;
          } else {
            return {
              v: remoteCall
            };
          }
        }

        allPromises.push(_this.pendingCfgPromises[finalUrl]);
      };

      for (var key in allRequestsMessages) {
        var _ret = _loop(key);

        if (_typeof(_ret) === "object") return _ret.v;
      }

      return new Promise(function (accept, reject) {
        Promise.all(allPromises).then(function (results) {
          if (requestMessage['preProcess']) {
            requestMessage['preProcess'](results);
          }

          accept(results[0]);
        })["catch"](reject);
      });
    }
  }, {
    key: "checkForMessageAndResolve",
    value: function checkForMessageAndResolve(resolve, result) {
      var task = result.task;
      var foundMessage = undefined;

      if (task) {
        var ongoingMessages = result.task.messages;

        if (ongoingMessages && ongoingMessages.length > 0) {
          foundMessage = ongoingMessages[0];
        }
      }

      if (foundMessage) {
        var userMessage = foundMessage.userMessage;

        if (this.options.callbacks.displayMessageCallback) {
          this.options.callbacks.displayMessageCallback({
            title: '',
            message: userMessage,
            type: 'OK'
          });
        }
      }

      resolve(result);
    }
  }, {
    key: "performSecuredAjax",
    value: function performSecuredAjax(url, type, requestData, headers, resolve, reject, message, statusMessage) {
      var _this2 = this;

      var me = this;
      Logger_1["default"].debug('calling url ' + url);
      Logger_1["default"].debug('type is ' + type);
      Logger_1["default"].debug('data is ' + JSON.stringify(requestData));
      var baseParams = {
        url: url,
        method: type,
        params: type === 'get' ? requestData : undefined,
        data: type !== 'get' ? requestData : undefined,
        headers: headers
      };

      if (type === 'get') {
        baseParams.params = requestData;
      } else {
        baseParams.data = querystring.stringify(requestData);
      }

      axios_1["default"](baseParams).then(function (response) {
        me.setSessionTimeout();

        if (response.status === 202 || response.status === 201) {
          _this2.handleOngoing(message, resolve, reject, response.data);

          return;
        }

        var cacheHeader = response.headers['cache-control'];
        var canCache = cacheHeader !== undefined && cacheHeader.indexOf('no-cache') < 0;

        if (localStorage !== undefined && canCache) {
          try {
            localStorage.setItem(message.getUrl(), JSON.stringify(response.data));
          } catch (e) {
            console.warn('No more quota for local storage for configuration, new entries will always be fetched on the fly');
          }
        }

        me.checkForMessageAndResolve(resolve, response.data);
      })["catch"](function (error) {
        Logger_1["default"].debug(JSON.stringify(error));

        if (!error.response) {
          Logger_1["default"].severe(JSON.stringify(error));
          reject(error.errno + ': ' + error.code);
        } else {
          Logger_1["default"].severe(error.response.statusText);
          var response = error.response;

          if ([401, 403].includes(response.status)) {
            if (response.data) {
              message.setLastError(response.data.message);
            }

            _this2.options.callbacks.missingAuthCallback(message, resolve, reject, response);
          } else if ([500, 400, 502].includes(response.status)) {
            reject(response.data.message);
          } else {
            reject(response);
          }
        }
      });
    }
  }, {
    key: "handleOngoing",
    value: function handleOngoing(message, resolve, reject, result) {
      var task = result.task;

      if (!task) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_TASK'));
      }

      var ongoingMessages = result.task.messages;

      if (!ongoingMessages) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_MESSAGE'));
      }

      if (ongoingMessages.length !== 1) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_MULTIPLE_MESSAGE'));
      }

      var ongoingMessage = ongoingMessages[0];
      var userMessage = ongoingMessage.userMessage;
      var userDetails = ongoingMessage.userDetailsMessage;
      var requests = ongoingMessage.requests;

      if (!requests) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_NO_REQUEST'));
      }

      if (requests.length !== 1) {
        reject(this.options.callbacks.i18NEntryCallback('ONGOING_MULTIPLE_REQUEST'));
      }

      var requestToDisplay = requests[0];

      if (this.options.callbacks.ongoingMessageCallback) {
        this.options.callbacks.ongoingMessageCallback(requestToDisplay, ongoingMessage, {
          title: '',
          message: userMessage,
          type: requestToDisplay.type
        }, this.performRequest, resolve, reject);
      } else {
        console.error('Missing handler for ongoing messages');
      }
    }
  }, {
    key: "handleLongProcessingRequest",
    value: function handleLongProcessingRequest(message, resolve, reject, statusMessage, result) {
      var me = this;
      var status = statusMessage ? result.processStatus : 'INIT';

      if (status === 'SUCCESS') {
        message.getSessionVars()['FM_PROCESS_ID'] = statusMessage.getPid();
        this.performRequest(message).then(statusMessage.getInitialMessageResolve())["catch"](function (error) {
          var reject = statusMessage.getInitialMessageReject();
          reject(error);
        });
      } else if (status === 'FAILURE') {
        statusMessage.getInitialMessageReject()(result.uimessage);
      } else if (status === 'INIT' || status === 'RUNNING') {
        var previousValue = status === 'INIT' ? 0 : statusMessage.getTime();

        if (previousValue === 0) {
          previousValue = 200;
        } else if (previousValue === 200) {
          previousValue = 1000;
        } else if (previousValue === 1000) {
          previousValue = 2000;
        }

        var newRequest = new GetStatus_1["default"](message, resolve, reject, message.getDomain(), message.getTaskId(), previousValue, status === 'INIT' ? 1 : statusMessage.getCount() + 1, statusMessage ? statusMessage.getPid() : result.pid);
        setTimeout(function () {
          me.performRequest(newRequest).then(function (result) {
            me.handleLongProcessingRequest(message, resolve, reject, newRequest, result);
          })["catch"](reject);
        }, newRequest.getTime());
      } else {
        statusMessage.getInitialMessageReject()('L\'utilisateur a annulé l\'appel');
      }
    }
  }, {
    key: "addPendingRequest",
    value: function addPendingRequest(request) {
      this.requests.push(request);
    }
  }, {
    key: "recallRequests",
    value: function recallRequests() {
      var allRequest = [];

      for (var key in this.requests) {
        var currentRequest = this.requests[key];

        if (currentRequest.message.service !== 'login') {
          if (currentRequest.message.getNbRetry() < this.maxRetry) {
            currentRequest.message.incrementRetry();
            allRequest.push(this.performRequest(currentRequest.message).then(currentRequest.resolve)["catch"](currentRequest.reject));
          } else {
            allRequest.push(currentRequest.reject(currentRequest.message.getLastError()));
          }
        }
      }

      this.requests = [];
      return Promise.all(allRequest);
    }
  }, {
    key: "setSessionTimeout",
    value: function setSessionTimeout() {
      if (this.sessionTimeoutId !== undefined) {
        window.clearTimeout(this.sessionTimeoutId);
      }

      var timeout = this.options.timeout + 15000;

      if (this.options.callbacks.sessionTimeoutCallback) {
        this.sessionTimeoutId = window.setTimeout(this.options.callbacks.sessionTimeoutCallback, timeout);
      }
    }
  }, {
    key: "getContext",
    value: function getContext(domain) {
      var _this3 = this;

      return new Promise(function (accept, reject) {
        var context = sai_protocol_1.DomainManager.getContext(domain);

        if (context === undefined) {
          var fetchDomainRequest = new DomainConfigurationsRequest_1.DomainConfigurationsRequest([domain]);

          _this3.performRequest(fetchDomainRequest).then(function (response) {
            sai_protocol_1.DomainManager.setContext(domain, new DomainContext_1["default"](domain, response.domainConfigurations[domain].packageUid, response.domainConfigurations[domain]));
            accept(sai_protocol_1.DomainManager.getContext(domain));
          })["catch"](reject);
        } else {
          accept(context);
        }
      });
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return Server;
}();

var singleInstance = Server.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(32);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(33);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(34);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Logger_1 = __webpack_require__(6);

var MockupServer = /*#__PURE__*/function () {
  function MockupServer() {
    _classCallCheck(this, MockupServer);

    this.requests = [];
  }

  _createClass(MockupServer, [{
    key: "initialize",
    value: function initialize(options) {
      this.options = options;
      this.requestHandler = options.requestHandler;
      this.maxRetry = options.maxRetry ? options.maxRetry : 2;
    }
  }, {
    key: "getTokenedUrl",
    value: function getTokenedUrl(url) {
      if (!url) {
        return '';
      }

      this.checkInitialisation('serverUrl');
      var hasSlash = this.options.serverUrl.endsWith('/');

      if (!this.hasToken() || url.indexOf('public/') !== -1 || url.indexOf('configuration/') !== -1) {
        return this.options.serverUrl + (hasSlash ? '' : '/') + url;
      } else {
        return this.options.serverUrl + (hasSlash ? '' : '/') + this.token + '/' + url;
      }
    }
  }, {
    key: "hasToken",
    value: function hasToken() {
      return this.token !== undefined && this.token.length > 0;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.token = token;
      sessionStorage.saiUserToken = JSON.stringify(token);
    }
  }, {
    key: "getMessageUrl",
    value: function getMessageUrl(requestMessage) {
      this.checkInitialisation('serverUrl');
      var hasSlash = this.options.serverUrl.endsWith('/');
      return this.options.serverUrl + (hasSlash ? '' : '/') + requestMessage.getUrl();
    }
  }, {
    key: "performRequest",
    value: function performRequest(requestMessage) {
      var url = this.getMessageUrl(requestMessage);
      Logger_1["default"].debug('Sending to ' + url + ' with payload ');
      Logger_1["default"].debug(requestMessage.getSerializable());

      if (this.requestHandler !== undefined) {
        return this.requestHandler(requestMessage, url);
      } else {
        throw new Error('Missing override of performRequest in mockup server');
      }
    }
  }, {
    key: "addPendingRequest",
    value: function addPendingRequest(request) {
      this.requests.push(request);
    }
  }, {
    key: "recallRequests",
    value: function recallRequests() {
      var allRequest = [];

      for (var key in this.requests) {
        var currentRequest = this.requests[key];

        if (currentRequest.message.service !== 'login') {
          if (currentRequest.message.getNbRetry() < this.maxRetry) {
            currentRequest.message.incrementRetry();
            allRequest.push(this.performRequest(currentRequest.message).then(currentRequest.resolve)["catch"](currentRequest.reject));
          } else {
            allRequest.push(currentRequest.reject('Maximum attempts reached'));
          }
        }
      }

      this.requests = [];
      return Promise.all(allRequest);
    }
  }, {
    key: "checkInitialisation",
    value: function checkInitialisation(prop) {
      if (this.options === undefined) {
        throw new Error('Mockup server hasn\'t been initialized');
      }

      if (this.options[prop] === undefined) {
        throw new Error('Mockup server hasn\'t been initialized with property ' + prop);
      }
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return MockupServer;
}();

var singleInstance = MockupServer.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainManager = /*#__PURE__*/function () {
  function DomainManager() {
    _classCallCheck(this, DomainManager);

    this.domainContext = {};
  }

  _createClass(DomainManager, [{
    key: "setContext",
    value: function setContext(domainId, context) {
      this.domainContext[domainId] = context;
    }
  }, {
    key: "getContext",
    value: function getContext(domainId) {
      return this.domainContext[domainId];
    }
  }, {
    key: "getCurrentContext",
    value: function getCurrentContext(userDomain) {
      return this.domainContext[userDomain];
    }
  }, {
    key: "resetContext",
    value: function resetContext() {
      this.domainContext = {};
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);

  return DomainManager;
}();

var singleInstance = DomainManager.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Context_1 = __webpack_require__(11);

var ContextsCollection = /*#__PURE__*/function () {
  function ContextsCollection() {
    _classCallCheck(this, ContextsCollection);

    this.contexts = [];
  }

  _createClass(ContextsCollection, [{
    key: "addContext",
    value: function addContext(context) {
      this.removeContext(context.getContextId());
      this.contexts.push(context);
    }
  }, {
    key: "hasContext",
    value: function hasContext(contextId) {
      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getContext",
    value: function getContext(contextId) {
      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          return model;
        }
      }

      return null;
    }
  }, {
    key: "getOrCreate",
    value: function getOrCreate(contextId, resetConfig) {
      if (!this.hasContext(contextId)) {
        var newContext = new Context_1["default"]({
          contextId: contextId
        });
        this.addContext(newContext);
        return newContext;
      } else {
        var context = this.getContext(contextId);

        if (resetConfig !== undefined) {
          if (typeof resetConfig === 'boolean' && resetConfig) {
            context.reset({
              parameters: true,
              screen: true
            });
          } else if (_typeof(resetConfig) === 'object') {
            context.reset(resetConfig);
          }
        }

        return context;
      }
    }
  }, {
    key: "removeContext",
    value: function removeContext(contextId) {
      var contextKey = null;

      for (var key in this.contexts) {
        var model = this.contexts[key];

        if (model.getContextId() === contextId) {
          contextKey = key;
          break;
        }
      }

      if (contextKey != null) {
        this.contexts.splice(contextKey, 1);
      }
    }
  }, {
    key: "getPartial",
    value: function getPartial(contextsList) {
      var partial = new ContextsCollection();

      for (var key in contextsList) {
        partial.addContext(this.getContext(contextsList[key]));
      }

      return partial;
    }
  }, {
    key: "toJSONString",
    value: function toJSONString() {
      var _final = {};

      for (var key in this.contexts) {
        var model = this.contexts[key];
        _final[model.getContextId() || 'undefinedContext'] = model.toJSON();
      }

      return JSON.stringify(_final);
    }
  }]);

  return ContextsCollection;
}();

exports["default"] = ContextsCollection;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var LoginRequest_1 = __webpack_require__(24);

var PasswordUpdateRequest_1 = __webpack_require__(25);

var UserInfosRequest_1 = __webpack_require__(26);

var DomainConfigurationsRequest_1 = __webpack_require__(10);

exports["default"] = {
  AuthenticationRequest: AuthenticationRequest_1.AuthenticationRequest,
  LoginRequest: LoginRequest_1.LoginRequest,
  PasswordUpdateRequest: PasswordUpdateRequest_1.PasswordUpdateRequest,
  UserInfosRequest: UserInfosRequest_1.UserInfosRequest,
  DomainConfigurationsRequest: DomainConfigurationsRequest_1.DomainConfigurationsRequest
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var LoginRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(LoginRequest, _AuthenticationReques);

  var _super = _createSuper(LoginRequest);

  function LoginRequest(user, pass, token) {
    var _this;

    _classCallCheck(this, LoginRequest);

    _this = _super.call(this, 'login', 'POST');

    _this.setUserName(user);

    _this.setPassword(pass);

    _this.token = token;
    _this.lazyAuthentication = false;
    return _this;
  }

  _createClass(LoginRequest, [{
    key: "setUserName",
    value: function setUserName(username) {
      this.username = username;
    }
  }, {
    key: "setPassword",
    value: function setPassword(pass) {
      this.password = pass;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        'auth-login': this.username,
        'auth-pass': this.password
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'LoginRequest';
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      if (!this.token) {
        return _get(_getPrototypeOf(LoginRequest.prototype), "getUrl", this).call(this);
      } else {
        var url = this.token;
        url += '/' + this.controller;
        url += '/' + this.service;
        return url;
      }
    }
  }]);

  return LoginRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.LoginRequest = LoginRequest;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var PasswordUpdateRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(PasswordUpdateRequest, _AuthenticationReques);

  var _super = _createSuper(PasswordUpdateRequest);

  function PasswordUpdateRequest(userId, oldPassword, newPassword) {
    var _this;

    _classCallCheck(this, PasswordUpdateRequest);

    _this = _super.call(this, 'updatepassword', 'GET');
    _this.userId = userId;
    _this.oldPassword = oldPassword;
    _this.newPassword = newPassword;
    return _this;
  }

  _createClass(PasswordUpdateRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          userId: this.userId,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PasswordUpdateRequest';
    }
  }]);

  return PasswordUpdateRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.PasswordUpdateRequest = PasswordUpdateRequest;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationRequest_1 = __webpack_require__(3);

var UserInfosRequest = /*#__PURE__*/function (_AuthenticationReques) {
  _inherits(UserInfosRequest, _AuthenticationReques);

  var _super = _createSuper(UserInfosRequest);

  function UserInfosRequest(domain) {
    var _this;

    _classCallCheck(this, UserInfosRequest);

    _this = _super.call(this, 'info', 'GET');
    _this.domainName = domain;
    return _this;
  }

  _createClass(UserInfosRequest, [{
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          domain: this.domainName
        }
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'UserInfosRequest';
    }
  }]);

  return UserInfosRequest;
}(AuthenticationRequest_1.AuthenticationRequest);

exports.UserInfosRequest = UserInfosRequest;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var PortalLoginRequest_1 = __webpack_require__(28);

var PortalExternalIdLoginRequest_1 = __webpack_require__(29);

exports["default"] = {
  PortalLoginRequest: PortalLoginRequest_1.PortalLoginRequest,
  PortalExternalIdLoginRequest: PortalExternalIdLoginRequest_1.PortalExternalIdLoginRequest
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var PortalLoginRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(PortalLoginRequest, _MobileRequest_1$defa);

  var _super = _createSuper(PortalLoginRequest);

  function PortalLoginRequest(domain, user, pass) {
    var _this;

    _classCallCheck(this, PortalLoginRequest);

    _this = _super.call(this, 'portal', 'login', 'POST', domain);

    _this.setUserName(user);

    _this.setPassword(pass);

    return _this;
  }

  _createClass(PortalLoginRequest, [{
    key: "setUserName",
    value: function setUserName(username) {
      this.username = username;
    }
  }, {
    key: "setPassword",
    value: function setPassword(pass) {
      this.password = pass;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          'user': this.username,
          'hashedPassword': this.password
        }
      };
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PortalLoginRequest';
    }
  }]);

  return PortalLoginRequest;
}(MobileRequest_1["default"]);

exports.PortalLoginRequest = PortalLoginRequest;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MobileRequest_1 = __webpack_require__(2);

var PortalExternalIdLoginRequest = /*#__PURE__*/function (_MobileRequest_1$defa) {
  _inherits(PortalExternalIdLoginRequest, _MobileRequest_1$defa);

  var _super = _createSuper(PortalExternalIdLoginRequest);

  function PortalExternalIdLoginRequest(domain, externalId) {
    var _this;

    _classCallCheck(this, PortalExternalIdLoginRequest);

    _this = _super.call(this, 'portal', 'externalIdLogin', 'POST', domain);

    _this.setExternalId(externalId);

    return _this;
  }

  _createClass(PortalExternalIdLoginRequest, [{
    key: "setExternalId",
    value: function setExternalId(externalId) {
      this.externalId = externalId;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          'externalId': this.externalId
        }
      };
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var url = this.controller;
      url += '/' + this.domainContext.getDomain();
      url += '/' + this.service;
      return url;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PortalExternalIdLoginRequest';
    }
  }]);

  return PortalExternalIdLoginRequest;
}(MobileRequest_1["default"]);

exports.PortalExternalIdLoginRequest = PortalExternalIdLoginRequest;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChainRequest_1 = __webpack_require__(31);

var ColorThemeRequest_1 = __webpack_require__(32);

var ComboRequest_1 = __webpack_require__(33);

var ConfigurationRequest_1 = __webpack_require__(1);

var DashboardRequest_1 = __webpack_require__(34);

var FilterRequest_1 = __webpack_require__(35);

var GridViewRequest_1 = __webpack_require__(36);

var I18NRequest_1 = __webpack_require__(12);

var PopupMenuRequest_1 = __webpack_require__(37);

var TableRequest_1 = __webpack_require__(38);

var TaskRequest_1 = __webpack_require__(39);

var WallpaperRequest_1 = __webpack_require__(40);

var HelpRequest_1 = __webpack_require__(41);

exports["default"] = {
  ChainRequest: ChainRequest_1.ChainRequest,
  ColorThemeRequest: ColorThemeRequest_1.ColorThemeRequest,
  ComboRequest: ComboRequest_1.ComboRequest,
  ConfigurationRequest: ConfigurationRequest_1.ConfigurationRequest,
  DashboardRequest: DashboardRequest_1.DashboardRequest,
  FilterRequest: FilterRequest_1.FilterRequest,
  GridViewRequest: GridViewRequest_1.GridViewRequest,
  I18NRequest: I18NRequest_1.I18NRequest,
  PopupMenuRequest: PopupMenuRequest_1.PopupMenuRequest,
  TableRequest: TableRequest_1.TableRequest,
  TaskRequest: TaskRequest_1.TaskRequest,
  WallpaperRequest: WallpaperRequest_1.WallpaperRequest,
  HelpRequest: HelpRequest_1.HelpRequest
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ChainRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ChainRequest, _ConfigurationRequest);

  var _super = _createSuper(ChainRequest);

  function ChainRequest(domain, _id) {
    _classCallCheck(this, ChainRequest);

    return _super.call(this, 'chain', domain, _id);
  }

  return _createClass(ChainRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ChainRequest = ChainRequest;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ColorThemeRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ColorThemeRequest, _ConfigurationRequest);

  var _super = _createSuper(ColorThemeRequest);

  function ColorThemeRequest(domain, _id) {
    _classCallCheck(this, ColorThemeRequest);

    return _super.call(this, 'theme', domain, _id);
  }

  return _createClass(ColorThemeRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ColorThemeRequest = ColorThemeRequest;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var ComboRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(ComboRequest, _ConfigurationRequest);

  var _super = _createSuper(ComboRequest);

  function ComboRequest(domain, _id) {
    _classCallCheck(this, ComboRequest);

    return _super.call(this, 'combo', domain, _id);
  }

  return _createClass(ComboRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.ComboRequest = ComboRequest;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var I18NRequest_1 = __webpack_require__(12);

var DashboardRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(DashboardRequest, _ConfigurationRequest);

  var _super = _createSuper(DashboardRequest);

  function DashboardRequest(domain, _id) {
    var _this;

    _classCallCheck(this, DashboardRequest);

    _this = _super.call(this, 'dashboard', domain, _id.substring(0, _id.lastIndexOf('/')));
    _this.lang = _id.substring(_id.lastIndexOf('/') + 1, _id.length);
    return _this;
  }

  _createClass(DashboardRequest, [{
    key: "preProcess",
    value: function preProcess(results) {
      var dash = results[0];
      var i18nValues = results[1].texts || {};
      var dashId = dash.id;

      if (true) {
        dash.label = i18nValues[dashId + '.label'];
      }

      for (var gId in dash.groups) {
        var curGrp = dash.groups[gId];
        var groupId = dashId + '.' + curGrp.id;

        if (i18nValues[groupId + '.label']) {
          curGrp.config.label = i18nValues[groupId + '.label'];
        }

        for (var tId in curGrp.tiles) {
          var curTile = curGrp.tiles[tId];
          var tileId = groupId + '.' + curTile.id;

          if (i18nValues[tileId + '.label']) {
            curTile.config.label = i18nValues[tileId + '.label'];
          }

          if (i18nValues[tileId + '.shortlabel']) {
            curTile.config.label = i18nValues[tileId + '.shortlabel'];
          }

          if (i18nValues[tileId + '.veryshortlabel']) {
            curTile.config.label = i18nValues[tileId + '.veryshortlabel'];
          }

          if (i18nValues[tileId + '.icon']) {
            curTile.visual.icon = i18nValues[tileId + '.icon'];
          }
        }
      }
    }
  }, {
    key: "hasSubRequests",
    value: function hasSubRequests() {
      return true;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      var reqParts = this.getId().split('/');
      var dashId = reqParts[reqParts.length - 1];
      return [new I18NRequest_1.I18NRequest(this.getDomain(), 'dashboard/' + this.lang + '/' + dashId.substring(0, 3))];
    }
  }]);

  return DashboardRequest;
}(ConfigurationRequest_1.ConfigurationRequest);

exports.DashboardRequest = DashboardRequest;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var FilterRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(FilterRequest, _ConfigurationRequest);

  var _super = _createSuper(FilterRequest);

  function FilterRequest(domain, _id) {
    _classCallCheck(this, FilterRequest);

    return _super.call(this, 'filter', domain, _id);
  }

  return _createClass(FilterRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.FilterRequest = FilterRequest;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var GridViewRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(GridViewRequest, _ConfigurationRequest);

  var _super = _createSuper(GridViewRequest);

  function GridViewRequest(domain, _id) {
    _classCallCheck(this, GridViewRequest);

    return _super.call(this, 'grid', domain, _id);
  }

  return _createClass(GridViewRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.GridViewRequest = GridViewRequest;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var PopupMenuRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(PopupMenuRequest, _ConfigurationRequest);

  var _super = _createSuper(PopupMenuRequest);

  function PopupMenuRequest(domain, _id) {
    _classCallCheck(this, PopupMenuRequest);

    return _super.call(this, 'popupmenus', domain, _id);
  }

  return _createClass(PopupMenuRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.PopupMenuRequest = PopupMenuRequest;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var TableRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(TableRequest, _ConfigurationRequest);

  var _super = _createSuper(TableRequest);

  function TableRequest(domain, _id) {
    _classCallCheck(this, TableRequest);

    return _super.call(this, 'table', domain, _id);
  }

  return _createClass(TableRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.TableRequest = TableRequest;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var TaskRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(TaskRequest, _ConfigurationRequest);

  var _super = _createSuper(TaskRequest);

  function TaskRequest(domain, _id) {
    _classCallCheck(this, TaskRequest);

    return _super.call(this, 'task', domain, _id);
  }

  _createClass(TaskRequest, [{
    key: "preProcess",
    value: function preProcess(results) {
      results[0] = results[0].task;
    }
  }]);

  return TaskRequest;
}(ConfigurationRequest_1.ConfigurationRequest);

exports.TaskRequest = TaskRequest;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var WallpaperRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(WallpaperRequest, _ConfigurationRequest);

  var _super = _createSuper(WallpaperRequest);

  function WallpaperRequest(domain, _themeId, _id) {
    _classCallCheck(this, WallpaperRequest);

    return _super.call(this, 'theme/' + _themeId + '/wallpaper', domain, _id);
  }

  return _createClass(WallpaperRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.WallpaperRequest = WallpaperRequest;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigurationRequest_1 = __webpack_require__(1);

var HelpRequest = /*#__PURE__*/function (_ConfigurationRequest) {
  _inherits(HelpRequest, _ConfigurationRequest);

  var _super = _createSuper(HelpRequest);

  function HelpRequest(domain, _id) {
    _classCallCheck(this, HelpRequest);

    return _super.call(this, 'help', domain, _id);
  }

  return _createClass(HelpRequest);
}(ConfigurationRequest_1.ConfigurationRequest);

exports.HelpRequest = HelpRequest;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldChange_1 = __webpack_require__(43);

var FieldClick_1 = __webpack_require__(44);

var FieldOperationRequest_1 = __webpack_require__(4);

var GetDossier_1 = __webpack_require__(45);

var GetGridData_1 = __webpack_require__(46);

var GetNotification_1 = __webpack_require__(47);

var GetPage_1 = __webpack_require__(48);

var GetRecord_1 = __webpack_require__(13);

var GetStatus_1 = __webpack_require__(7);

var GetTask_1 = __webpack_require__(49);

var GridAction_1 = __webpack_require__(50);

var PostNotification_1 = __webpack_require__(51);

var PrepareNewEntry_1 = __webpack_require__(52);

var PrepareNewPage_1 = __webpack_require__(53);

var PrintFile_1 = __webpack_require__(54);

var SubmitPage_1 = __webpack_require__(55);

var SubmitRecord_1 = __webpack_require__(56);

var TaskListing_1 = __webpack_require__(57);

var TaskRequest_1 = __webpack_require__(0);

exports["default"] = {
  FieldChangeRequest: FieldChange_1["default"],
  FieldClickRequest: FieldClick_1["default"],
  FieldOperationRequest: FieldOperationRequest_1["default"],
  GetDossierRequest: GetDossier_1["default"],
  GetGridDataRequest: GetGridData_1["default"],
  GetNotificationRequest: GetNotification_1["default"],
  GetPageRequest: GetPage_1["default"],
  GetRecordRequest: GetRecord_1["default"],
  GetStatusRequest: GetStatus_1["default"],
  GetTaskRequest: GetTask_1["default"],
  GridActionRequest: GridAction_1["default"],
  PostNotificationRequest: PostNotification_1["default"],
  PrepareNewEntryRequest: PrepareNewEntry_1["default"],
  PrepareNewPageRequest: PrepareNewPage_1["default"],
  PrintFileRequest: PrintFile_1["default"],
  SubmitPageRequest: SubmitPage_1["default"],
  SubmitRecordRequest: SubmitRecord_1["default"],
  TaskListingRequest: TaskListing_1["default"],
  TaskRequest: TaskRequest_1.TaskRequest
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldOperationRequest_1 = __webpack_require__(4);

var FieldChangeRequest = /*#__PURE__*/function (_FieldOperationReques) {
  _inherits(FieldChangeRequest, _FieldOperationReques);

  var _super = _createSuper(FieldChangeRequest);

  function FieldChangeRequest(domain, task) {
    _classCallCheck(this, FieldChangeRequest);

    return _super.call(this, 'fieldChange', domain, task);
  }

  _createClass(FieldChangeRequest, [{
    key: "setLastValue",
    value: function setLastValue(value) {
      this.lastValue = value || '';
    }
  }, {
    key: "setLastNonEmptyValue",
    value: function setLastNonEmptyValue(value) {
      this.lastNonEmptyValue = value || '';
    }
  }, {
    key: "setInitialValue",
    value: function setInitialValue(value) {
      this.initialValue = value || '';
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var request = _get(_getPrototypeOf(FieldChangeRequest.prototype), "getSerializable", this).call(this);

      request.request1.lastValue = this.lastValue;
      request.request1.lastNonEmptyValue = this.lastNonEmptyValue;
      request.request1.initialValue = this.initialValue;
      return request;
    }
  }]);

  return FieldChangeRequest;
}(FieldOperationRequest_1["default"]);

exports["default"] = FieldChangeRequest;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldOperationRequest_1 = __webpack_require__(4);

var FieldClickRequest = /*#__PURE__*/function (_FieldOperationReques) {
  _inherits(FieldClickRequest, _FieldOperationReques);

  var _super = _createSuper(FieldClickRequest);

  function FieldClickRequest(domain, task) {
    _classCallCheck(this, FieldClickRequest);

    return _super.call(this, 'fieldClick', domain, task);
  }

  return _createClass(FieldClickRequest);
}(FieldOperationRequest_1["default"]);

exports["default"] = FieldClickRequest;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GetRecord_1 = __webpack_require__(13);

var GetDossierRequest = /*#__PURE__*/function (_GetRecord_1$default) {
  _inherits(GetDossierRequest, _GetRecord_1$default);

  var _super = _createSuper(GetDossierRequest);

  function GetDossierRequest(domain, task) {
    var _this;

    _classCallCheck(this, GetDossierRequest);

    _this = _super.call(this, domain, task);
    _this.service = 'getDossier';
    return _this;
  }

  return _createClass(GetDossierRequest);
}(GetRecord_1["default"]);

exports["default"] = GetDossierRequest;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetGridDataRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetGridDataRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetGridDataRequest);

  function GetGridDataRequest(domain, task, gridId) {
    var _this;

    _classCallCheck(this, GetGridDataRequest);

    _this = _super.call(this, 'getGridData', 'POST', domain, task);
    _this.gridId = gridId;
    _this.range = {
      start: 0,
      end: 20
    };
    _this.filterId = 'DEFAULT_FILTER';
    _this.gridFilter = {
      customText: undefined,
      context: undefined
    };
    return _this;
  }

  _createClass(GetGridDataRequest, [{
    key: "getGridId",
    value: function getGridId(newId) {
      this.gridId = newId;
    }
  }, {
    key: "setFilterId",
    value: function setFilterId(newId) {
      this.filterId = newId;
    }
  }, {
    key: "setFormatterId",
    value: function setFormatterId(newId) {
      this.formatterId = newId;
    }
  }, {
    key: "setRange",
    value: function setRange(start, end) {
      this.range = {
        start: start,
        end: end
      };
    }
  }, {
    key: "setCustomFilterText",
    value: function setCustomFilterText(customText) {
      this.gridFilter.customText = customText;
    }
  }, {
    key: "setFilterContext",
    value: function setFilterContext(context) {
      this.gridFilter.context = context;
    }
  }, {
    key: "setSessionVars",
    value: function setSessionVars(vars) {
      this.sessionVars = vars;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          filterId: this.filterId,
          formatterId: this.formatterId,
          start: this.range.start,
          end: this.range.end,
          customText: this.gridFilter.customText,
          filter: this.gridFilter.context ? this.gridFilter.context.toJSON() : undefined,
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return GetGridDataRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetGridDataRequest;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetNotificationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetNotificationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetNotificationRequest);

  function GetNotificationRequest(domain, task, id) {
    var _this;

    _classCallCheck(this, GetNotificationRequest);

    _this = _super.call(this, 'notification/' + id, 'POST', domain, task);
    _this.remoteArguments = {};
    return _this;
  }

  _createClass(GetNotificationRequest, [{
    key: "setNotificationArgument",
    value: function setNotificationArgument(paramId, paramValue) {
      this.remoteArguments[paramId] = paramValue;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(GetNotificationRequest.prototype), "getSerializable", this).call(this);

      content.request1.parameters = this.remoteArguments;
      return content;
    }
  }]);

  return GetNotificationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetNotificationRequest;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetPageRequest);

  function GetPageRequest(domain, task) {
    _classCallCheck(this, GetPageRequest);

    return _super.call(this, 'getPage', 'GET', domain, task);
  }

  _createClass(GetPageRequest, [{
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return GetPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GetPageRequest;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GetTaskRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GetTaskRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GetTaskRequest);

  function GetTaskRequest(domain, task) {
    _classCallCheck(this, GetTaskRequest);

    return _super.call(this, 'getTask', 'GET', domain, task);
  }

  return _createClass(GetTaskRequest);
}(TaskRequest_1.TaskRequest);

exports["default"] = GetTaskRequest;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var GridActionRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(GridActionRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(GridActionRequest);

  function GridActionRequest(domain, task, gridId, popupId, itemId, actionId, gridIndex) {
    var _this;

    _classCallCheck(this, GridActionRequest);

    _this = _super.call(this, 'gridAction', 'POST', domain, task);

    _this.setGridId(gridId);

    _this.setPopupId(popupId);

    _this.setItemId(itemId);

    _this.setActionId(actionId);

    _this.setGridIndex(gridIndex);

    return _this;
  }

  _createClass(GridActionRequest, [{
    key: "setGridContext",
    value: function setGridContext(context) {
      this.grid = context;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setGridId",
    value: function setGridId(id) {
      this.gridId = id;
    }
  }, {
    key: "setPopupId",
    value: function setPopupId(id) {
      this.popupId = id;
    }
  }, {
    key: "setItemId",
    value: function setItemId(id) {
      this.itemId = id;
    }
  }, {
    key: "setActionId",
    value: function setActionId(id) {
      this.actionId = id;
    }
  }, {
    key: "setGridIndex",
    value: function setGridIndex(index) {
      this.gridIndex = index;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          gridId: this.gridId,
          grid: this.grid ? this.grid.toJSON() : undefined,
          record: this.record ? this.record.toJSON() : undefined,
          popupId: this.popupId,
          itemId: this.itemId,
          actionId: this.actionId,
          gridIndex: this.gridIndex
        }
      };
    }
  }]);

  return GridActionRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = GridActionRequest;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PostNotificationRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PostNotificationRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PostNotificationRequest);

  function PostNotificationRequest(domain, task, id) {
    var _this;

    _classCallCheck(this, PostNotificationRequest);

    _this = _super.call(this, 'notification/' + id, 'POST', domain, task);
    _this.remoteArguments = {};
    return _this;
  }

  _createClass(PostNotificationRequest, [{
    key: "setNotificationArgument",
    value: function setNotificationArgument(paramId, paramValue) {
      this.remoteArguments[paramId] = paramValue;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(PostNotificationRequest.prototype), "getSerializable", this).call(this);

      content.request1.parameters = this.remoteArguments;
      return content;
    }
  }]);

  return PostNotificationRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PostNotificationRequest;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrepareNewEntryRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrepareNewEntryRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrepareNewEntryRequest);

  function PrepareNewEntryRequest(domain, task) {
    _classCallCheck(this, PrepareNewEntryRequest);

    return _super.call(this, 'prepareNewEntry', 'POST', domain, task);
  }

  _createClass(PrepareNewEntryRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined
        }
      };
    }
  }]);

  return PrepareNewEntryRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PrepareNewEntryRequest;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrepareNewPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrepareNewPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrepareNewPageRequest);

  function PrepareNewPageRequest(domain, task) {
    _classCallCheck(this, PrepareNewPageRequest);

    return _super.call(this, 'prepareNewPage', 'POST', domain, task);
  }

  _createClass(PrepareNewPageRequest, [{
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "setPageContext",
    value: function setPageContext(context) {
      this.page = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined
        }
      };
    }
  }]);

  return PrepareNewPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = PrepareNewPageRequest;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var PrintFileRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(PrintFileRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(PrintFileRequest);

  function PrintFileRequest(domain, task) {
    _classCallCheck(this, PrintFileRequest);

    return _super.call(this, 'printFile', 'POST', domain, task);
  }

  return _createClass(PrintFileRequest);
}(TaskRequest_1.TaskRequest);

exports["default"] = PrintFileRequest;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var SubmitPageRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(SubmitPageRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(SubmitPageRequest);

  function SubmitPageRequest(domain, task) {
    _classCallCheck(this, SubmitPageRequest);

    return _super.call(this, 'submitPage', 'POST', domain, task);
  }

  _createClass(SubmitPageRequest, [{
    key: "setOperation",
    value: function setOperation(operation) {
      this.operation = operation;
    }
  }, {
    key: "setPendingFileList",
    value: function setPendingFileList(documents) {
      this.documents = documents;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          page: this.page ? this.page.toJSON() : undefined,
          recordOperation: this.operation,
          pendingFileList: this.documents,
          message: this.message ? this.message : undefined
        }
      };
    }
  }]);

  return SubmitPageRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = SubmitPageRequest;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var SubmitRecordRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(SubmitRecordRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(SubmitRecordRequest);

  function SubmitRecordRequest(domain, task) {
    _classCallCheck(this, SubmitRecordRequest);

    return _super.call(this, 'submitRecord', 'POST', domain, task);
  }

  _createClass(SubmitRecordRequest, [{
    key: "setOperation",
    value: function setOperation(operation) {
      this.operation = operation;
    }
  }, {
    key: "setPendingDocuments",
    value: function setPendingDocuments(documents) {
      this.documents = documents;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      var content = _get(_getPrototypeOf(SubmitRecordRequest.prototype), "getSerializable", this).call(this);

      content.request1.recordOperation = this.operation;
      content.request1.pendingFileList = this.documents;
      return content;
    }
  }]);

  return SubmitRecordRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = SubmitRecordRequest;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TaskRequest_1 = __webpack_require__(0);

var TaskListingRequest = /*#__PURE__*/function (_TaskRequest_1$TaskRe) {
  _inherits(TaskListingRequest, _TaskRequest_1$TaskRe);

  var _super = _createSuper(TaskListingRequest);

  function TaskListingRequest(domain, task, listTask) {
    var _this;

    _classCallCheck(this, TaskListingRequest);

    _this = _super.call(this, 'getTaskListing', 'POST', domain, listTask);

    _this.setSrcTask(task);

    return _this;
  }

  _createClass(TaskListingRequest, [{
    key: "setSrcTask",
    value: function setSrcTask(newTask) {
      this.srcTask = newTask;
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(newTemplate) {
      this.template = newTemplate;
    }
  }, {
    key: "setRecordContext",
    value: function setRecordContext(context) {
      this.record = context;
    }
  }, {
    key: "getSerializable",
    value: function getSerializable() {
      return {
        request1: {
          record: this.record ? this.record.toJSON() : undefined,
          task: this.srcTask,
          template: this.template
        }
      };
    }
  }]);

  return TaskListingRequest;
}(TaskRequest_1.TaskRequest);

exports["default"] = TaskListingRequest;

/***/ })
/******/ ]);
});
//# sourceMappingURL=sai-protocol-node.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Protocol_1 = __webpack_require__(21);
var ColorTheme_1 = __webpack_require__(14);
var CClientConfiguration_1 = __webpack_require__(12);
var ThemeManager = /*#__PURE__*/function () {
  function ThemeManager() {
    _classCallCheck(this, ThemeManager);
    this.themes = {};
  }
  _createClass(ThemeManager, [{
    key: "initialize",
    value: function initialize(server, domainManager) {
      this.server = server;
      this.domainManager = domainManager;
    }
  }, {
    key: "getColorForComponent",
    value: function getColorForComponent(themeId, componentName, context) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.getTheme(themeId, context).then(function (theme) {
          resolve(theme.getProperty(componentName));
        })["catch"](reject);
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme(id, context) {
      return CClientConfiguration_1["default"].getCachedConfiguration.bind(this)('themes', id, context, Protocol_1.Configuration.ColorThemeRequest, ColorTheme_1.ColorTheme);
    }
  }, {
    key: "getThemeList",
    value: function getThemeList(context) {
      return new Promise(function (resolve, reject) {
        var newRequest = new Protocol_1.Configuration.ColorThemeRequest(context);
        CClientConfiguration_1["default"].getServer().performRequest(newRequest).then(function (result) {
          resolve(result);
        })["catch"](reject);
      });
    }
  }, {
    key: "getFirstAvailableTheme",
    value: function getFirstAvailableTheme(context) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.getThemeList(context).then(function (themeList) {
          if (themeList.length > 0) {
            _this2.getTheme(themeList[0], context).then(resolve)["catch"](function () {
              reject('THEME_RETRIEVAL_FAILURE');
            });
          } else {
            reject('THEME_NO_THEMES');
          }
        })["catch"](reject);
      });
    }
  }, {
    key: "getUserTheme",
    value: function getUserTheme(domain, colorTheme) {
      var _this3 = this;
      var curDomain = this.domainManager.getContext(domain);
      return new Promise(function (resolve, reject) {
        var themeId = colorTheme;
        if (themeId !== undefined && themeId !== '') {
          _this3.getTheme(themeId, curDomain).then(resolve)["catch"](function (reason) {
            console.warn('The requested theme ' + themeId + ' is not available, switching to first available');
            _this3.getFirstAvailableTheme(curDomain).then(resolve)["catch"](reject);
          });
        } else {
          _this3.getFirstAvailableTheme(curDomain).then(resolve)["catch"](reject);
        }
      });
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);
  return ThemeManager;
}();
var singleInstance = ThemeManager.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ = __webpack_require__(6);
var ConfigurationElement_1 = __webpack_require__(0);
var PopupMenuItem = /*#__PURE__*/function () {
  function PopupMenuItem(popupMenuElement) {
    _classCallCheck(this, PopupMenuItem);
    this.element = popupMenuElement;
    this.subItems = [];
    for (var key in popupMenuElement.subItems) {
      this.subItems.push(new PopupMenuItem(popupMenuElement.subItems[key]));
    }
  }
  _createClass(PopupMenuItem, [{
    key: "getItemId",
    value: function getItemId() {
      return this.element.itemId;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.element.label;
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      if (this.element.icon !== undefined) {
        return this.element.icon;
      } else {
        console.warn('Missing popupmenu icon for popup : ' + this.getLabel());
        return 'sai-missing';
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.element.type;
    }
  }, {
    key: "getScope",
    value: function getScope() {
      return this.element.scope;
    }
  }, {
    key: "getNotification",
    value: function getNotification() {
      return this.element.notification;
    }
  }, {
    key: "getSubItems",
    value: function getSubItems() {
      return this.subItems;
    }
  }, {
    key: "getVisible",
    value: function getVisible() {
      return this.element.visible;
    }
  }, {
    key: "getPopupId",
    value: function getPopupId() {
      return this.element.popupId;
    }
  }, {
    key: "getActionId",
    value: function getActionId() {
      return this.element.actionId;
    }
  }, {
    key: "hasSubItems",
    value: function hasSubItems() {
      return this.subItems.length > 0;
    }
  }]);
  return PopupMenuItem;
}();
exports.PopupMenuItem = PopupMenuItem;
var PopupMenu = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(PopupMenu, _ConfigurationElement);
  var _super = _createSuper(PopupMenu);
  function PopupMenu(config, context) {
    var _this;
    _classCallCheck(this, PopupMenu);
    _this = _super.call(this, config, context);
    _this.buildStructure(config);
    _this.initialConfig = config;
    return _this;
  }
  _createClass(PopupMenu, [{
    key: "buildStructure",
    value: function buildStructure(config) {
      this.popupMenuList = {};
      var counter = 1;
      for (var actionIndex in config.actions) {
        var popup = config.actions[actionIndex];
        var popupId = popup.popupId;
        if (this.popupMenuList[popupId] === undefined) {
          this.popupMenuList[popupId] = {
            order: counter,
            items: []
          };
          counter++;
        }
        this.popupMenuList[popupId].items.push(new PopupMenuItem(popup));
      }
    }
  }, {
    key: "appendOverride",
    value: function appendOverride(secondaryPopup) {
      var newPopup = this.clone();
      var merging = secondaryPopup.clone();
      var secondaryPopupElements = secondaryPopup.popupMenuList;
      for (var secondaryPopId in secondaryPopupElements) {
        newPopup.setActions(secondaryPopId, secondaryPopupElements[secondaryPopId].items);
      }
      return newPopup;
    }
  }, {
    key: "getActions",
    value: function getActions(scope) {
      var me = this;
      var actionKeys = Object.keys(this.popupMenuList);
      var sortedEntries = actionKeys.sort(function (a, b) {
        return me.popupMenuList[a].order <= me.popupMenuList[b].order ? -1 : 1;
      });
      return sortedEntries.reduce(function (previous, key) {
        var currentItems = _.filter(me.popupMenuList[key].items, function (item) {
          if (item.hasSubItems()) {
            var hasSome = false;
            for (var subEntry in item.getSubItems()) {
              if (!item.getSubItems()[subEntry].scope || scope.indexOf(item.getSubItems()[subEntry].scope) >= 0) {
                hasSome = true;
                break;
              }
            }
            return hasSome;
          } else {
            return !item.getScope() || scope.indexOf(item.getScope()) >= 0;
          }
        });
        return previous.concat(currentItems);
      }, []);
    }
  }, {
    key: "getVisibleActions",
    value: function getVisibleActions(scope, values, columnMap) {
      var me = this;
      var actionKeys = Object.keys(this.popupMenuList);
      var sortedEntries = actionKeys.sort(function (a, b) {
        return me.popupMenuList[a].order <= me.popupMenuList[b].order ? -1 : 1;
      });
      return sortedEntries.reduce(function (previous, key) {
        var currentItems = _.filter(me.popupMenuList[key].items, function (item) {
          if (item.hasSubItems()) {
            var hasSome = false;
            for (var subEntry in item.getSubItems()) {
              if (!item.getSubItems()[subEntry].scope || scope.indexOf(item.getSubItems()[subEntry].scope) >= 0) {
                if (me.isVisible(item.getSubItems()[subEntry], values, columnMap)) {
                  hasSome = true;
                  break;
                }
              }
            }
            return hasSome;
          } else {
            return (!item.getScope() || scope.indexOf(item.getScope()) >= 0) && me.isVisible(item, values, columnMap);
          }
        });
        return previous.concat(currentItems);
      }, []);
    }
  }, {
    key: "isVisible",
    value: function isVisible(popupItem, values, columnMap) {
      var visibleCondition = popupItem.getVisible();
      if (visibleCondition === undefined || visibleCondition === 'true') {
        return true;
      } else if (visibleCondition === 'false') {
        return false;
      }
      var pattern = /(.+)\s:\s(.+=(?:false|true))(,.+=(?:false|true))*/g;
      if (visibleCondition.match(pattern)) {
        var matcher = pattern.exec(visibleCondition);
        var datafield = matcher[1];
        var allCases = matcher[2].split(',');
        var valuesCases = {};
        for (var key in allCases) {
          var eqSplit = allCases[key].split('=');
          valuesCases[eqSplit[0]] = eqSplit[1] === 'true';
        }
        var columnId = (columnMap || {})[datafield];
        if (columnId) {
          var currentCol = (values || {})[columnId];
          if (currentCol && valuesCases[currentCol.value] !== undefined) {
            return valuesCases[currentCol.value];
          }
        }
      }
      throw new Error('The given visibility pattern is not implemented, contact your administrator');
    }
  }, {
    key: "hasActions",
    value: function hasActions(scope) {
      return this.getActions(scope).length > 0;
    }
  }, {
    key: "setActions",
    value: function setActions(popupId, items) {
      if (!this.popupMenuList[popupId]) {
        this.popupMenuList[popupId] = {
          order: Object.keys(this.popupMenuList).length + 1,
          items: items
        };
      } else {
        this.popupMenuList[popupId].items = items;
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new PopupMenu(this.initialConfig, this.context);
    }
  }]);
  return PopupMenu;
}(ConfigurationElement_1.ConfigurationElement);
PopupMenu.SCOPE_ALWAYS = 'AllVisibleRecords';
PopupMenu.SCOPE_SINGLE = 'SingleRecord';
PopupMenu.SCOPE_MULTIPLE = 'SelectedRecords';
exports.PopupMenu = PopupMenu;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AbstractTask_1 = __webpack_require__(15);
var DataField_1 = __webpack_require__(4);
var Panel_1 = __webpack_require__(25);
var SubPanel_1 = __webpack_require__(26);
var Page_1 = __webpack_require__(7);
var _ = __webpack_require__(6);
var _Symbol = __webpack_require__(1);
var Task = /*#__PURE__*/function (_AbstractTask_1$Abstr) {
  _inherits(Task, _AbstractTask_1$Abstr);
  var _super = _createSuper(Task);
  function Task(newConfig, context) {
    var _this;
    _classCallCheck(this, Task);
    var config = _.cloneDeep(newConfig);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [Task.ASYNC_PROP_LABEL, Task.ASYNC_PROP_TABLE];
    _this.fields = {};
    _this.datafields = {};
    _this.datafieldsArr = [];
    if (config.datafields) {
      for (var key in config.datafields) {
        var newDf = new DataField_1.DataField(config.datafields[key], null, null, _assertThisInitialized(_this), context);
        _this.datafields[newDf.getId()] = newDf;
        _this.datafieldsArr.push(newDf);
      }
    }
    _this.panels = {};
    _this.panelsArr = [];
    for (var _key in config.screen) {
      var panConf = config.screen[_key];
      var oType = Task.getObjectType(panConf.objectType);
      if (oType === Task.PANEL_TYPE_SUBPANEL) {
        var newPan = new SubPanel_1.SubPanel(config.screen[_key], _assertThisInitialized(_this), context);
        _this.subPanel = newPan;
        Object.assign(_this.fields, newPan.getFields());
      } else if (oType === Task.PANEL_TYPE_PANEL) {
        var _newPan = new Panel_1.Panel(config.screen[_key], _assertThisInitialized(_this), context);
        _this.panels[_newPan.getId()] = _newPan;
        _this.panelsArr.push(_newPan);
        Object.assign(_this.fields, _newPan.getFields());
      } else {
        console.warn('Invalid child type ' + oType);
      }
    }
    _this.pages = {};
    _this.pagesArr = [];
    for (var _key2 in config.pages) {
      var newPage = new Page_1.Page(config.pages[_key2], _assertThisInitialized(_this), context);
      _this.pages[newPage.getId()] = newPage;
      _this.pagesArr.push(newPage);
      Object.assign(_this.fields, newPage.getFields());
    }
    return _this;
  }
  _createClass(Task, [{
    key: "getLinkedTable",
    value: function getLinkedTable() {
      return this.linkedTable;
    }
  }, {
    key: "setLinkedTable",
    value: function setLinkedTable(table) {
      this.linkedTable = table;
    }
  }, {
    key: "getFields",
    value: function getFields() {
      return this.fields;
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
      for (var dfId in this.datafields) {
        this.datafields[dfId].retrieveAsyncEntities(allEntities);
      }
      for (var dpId in this.pages) {
        this.pages[dpId].retrieveAsyncEntities(allEntities);
      }
      for (var pnId in this.panels) {
        this.panels[pnId].retrieveAsyncEntities(allEntities);
      }
      if (this.subPanel) {
        this.subPanel.retrieveAsyncEntities(allEntities);
      }
    }
  }, {
    key: "getInputInterface",
    value: function getInputInterface() {
      return this.getValueOrDefault('intputInterface');
    }
  }, {
    key: "getAutoUpdateOnTaskChange",
    value: function getAutoUpdateOnTaskChange() {
      return this.getValueOrDefault('autoUpdateOnTaskChange');
    }
  }, {
    key: "getEditTask",
    value: function getEditTask() {
      return this.getValueOrDefault('editTask');
    }
  }, {
    key: "getViewTask",
    value: function getViewTask() {
      return this.getValueOrDefault('viewTask');
    }
  }, {
    key: "getListTask",
    value: function getListTask() {
      return this.getValueOrDefault('listTask');
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.getBooleanValueOrDefault('visible', true);
    }
  }, {
    key: "canCallOnOpenTask",
    value: function canCallOnOpenTask() {
      return this.getBooleanValueOrDefault('callOnOpenTask', false);
    }
  }, {
    key: "canCallOnPrepareNewEntry",
    value: function canCallOnPrepareNewEntry() {
      return this.getBooleanValueOrDefault('callOnPrepareNewEntry', false);
    }
  }, {
    key: "getNavigatorTableID",
    value: function getNavigatorTableID() {
      return this.getValueOrDefault('navigatorTableId', this.getTableID());
    }
  }, {
    key: "getNavigatorGridView",
    value: function getNavigatorGridView() {
      if (this.getNavigatorPresentation() === 'header') {
        return this.getHeaderID() ? this.getHeaderID() : this.getValueOrDefault('navigatorGridView');
      } else {
        return this.getValueOrDefault('navigatorGridView');
      }
    }
  }, {
    key: "getHeaderID",
    value: function getHeaderID() {
      return this.getValueOrDefault('headerId');
    }
  }, {
    key: "getNavigatorFilter",
    value: function getNavigatorFilter() {
      var propsOverride = this.getInitialPropsOverride();
      if (propsOverride && propsOverride['filterId'] !== undefined) {
        return propsOverride['filterId'];
      } else {
        return this.getValueOrDefault('navigatorFilter', Task.DEFAULT_FILTER_VALUE);
      }
    }
  }, {
    key: "isNavigatorImportEnabled",
    value: function isNavigatorImportEnabled() {
      return this.getBooleanValueOrDefault('navigatorImportEnabled', true);
    }
  }, {
    key: "getNavigatorImportDomains",
    value: function getNavigatorImportDomains() {
      return this.getValueOrDefault('navigatorImportDomains');
    }
  }, {
    key: "getNavigatorImportFilter",
    value: function getNavigatorImportFilter() {
      return this.getValueOrDefault('navigatorImportFilter');
    }
  }, {
    key: "isNewASelect",
    value: function isNewASelect() {
      return this.getBooleanValueOrDefault('newIsSelect', false);
    }
  }, {
    key: "getSelectionGridView",
    value: function getSelectionGridView() {
      return this.getValueOrDefault('selectionGridView');
    }
  }, {
    key: "canNavigatorAutoSelectFirst",
    value: function canNavigatorAutoSelectFirst() {
      return this.getBooleanValueOrDefault('navigatorAutoSelectFirst', false);
    }
  }, {
    key: "canNavigatorShowFastSearchPanelOnStartup",
    value: function canNavigatorShowFastSearchPanelOnStartup() {
      return this.getBooleanValueOrDefault('navigatorShowFastSearchPanelOnStartup', false);
    }
  }, {
    key: "canNavigatorSkipFirstLoad",
    value: function canNavigatorSkipFirstLoad() {
      return this.getBooleanValueOrDefault('navigatorSkipFirstLoad', false);
    }
  }, {
    key: "isNavigatorNewOnTop",
    value: function isNavigatorNewOnTop() {
      return this.getBooleanValueOrDefault('navigatorNewOnTop', false);
    }
  }, {
    key: "getNavigatorFormater",
    value: function getNavigatorFormater() {
      return this.getValueOrDefault('navigatorFormatter');
    }
  }, {
    key: "getSubNavigatorTableID",
    value: function getSubNavigatorTableID() {
      return this.getValueOrDefault('subNavigatorTableId');
    }
  }, {
    key: "getSubNavigatorGridView",
    value: function getSubNavigatorGridView() {
      return this.getValueOrDefault('subNavigatorGridView');
    }
  }, {
    key: "getSubNavigatorFilter",
    value: function getSubNavigatorFilter() {
      return this.getValueOrDefault('subNavigatorFilter');
    }
  }, {
    key: "canSubNavigatorAutoSelectFirst",
    value: function canSubNavigatorAutoSelectFirst() {
      return this.getBooleanValueOrDefault('subNavigatorAutoSelectFirst', false);
    }
  }, {
    key: "getButtonsVisibles",
    value: function getButtonsVisibles() {
      var buttonsVisibility = this.getValueOrDefault('buttonsVisibles', Task.BUTTONS_VISIBILITY_ALWAYS);
      if (buttonsVisibility === 'true') {
        return Task.BUTTONS_VISIBILITY_ALWAYS;
      } else if (buttonsVisibility === 'false') {
        return Task.BUTTONS_VISIBILITY_ONCHANGE;
      } else {
        return buttonsVisibility;
      }
    }
  }, {
    key: "canHeaderValidate",
    value: function canHeaderValidate() {
      return this.getBooleanValueOrDefault('headerValidation', true);
    }
  }, {
    key: "canDisableHeaderOnValidate",
    value: function canDisableHeaderOnValidate() {
      return this.getBooleanValueOrDefault('disableHeaderOnValidate', false);
    }
  }, {
    key: "canReloadPagesOnValidate",
    value: function canReloadPagesOnValidate() {
      return this.getBooleanValueOrDefault('reloadPagesOnValidate', false);
    }
  }, {
    key: "getHeaderPage",
    value: function getHeaderPage() {
      return this.getValueOrDefault('headerInPage');
    }
  }, {
    key: "canSkipHeaderCreation",
    value: function canSkipHeaderCreation() {
      return this.getBooleanValueOrDefault('skipHeaderCreation', false);
    }
  }, {
    key: "getAutoSelectedPage",
    value: function getAutoSelectedPage() {
      return this.getValueOrDefault('autoSelectPage', this.getHeaderPage());
    }
  }, {
    key: "getInputTerminatePolicy",
    value: function getInputTerminatePolicy() {
      return this.getValueOrDefault('inputTerminatePolicy', Task.DEFAULT_TERMINATE_POLICY);
    }
  }, {
    key: "getSubButtonsVisibility",
    value: function getSubButtonsVisibility() {
      return this.getValueOrDefault('subButtonsVisibles');
    }
  }, {
    key: "canClose",
    value: function canClose() {
      return this.getBooleanValueOrDefault('canClose', true);
    }
  }, {
    key: "canCloseWithoutTerminate",
    value: function canCloseWithoutTerminate() {
      return this.getBooleanValueOrDefault('canCloseWithoutTerminate', true);
    }
  }, {
    key: "canLazyAddAndModify",
    value: function canLazyAddAndModify() {
      return this.getBooleanValueOrDefault('lazyAddAndModify', false);
    }
  }, {
    key: "canInterruptLongTask",
    value: function canInterruptLongTask() {
      return this.getBooleanValueOrDefault('canInterruptLongTask', false);
    }
  }, {
    key: "canCollapseBreaks",
    value: function canCollapseBreaks() {
      return this.getBooleanValueOrDefault('collapsibleBreaks', false);
    }
  }, {
    key: "getOpenThrough",
    value: function getOpenThrough() {
      return this.getValueOrDefault('openThrough');
    }
  }, {
    key: "getHeaderDisplayMode",
    value: function getHeaderDisplayMode() {
      return this.getValueOrDefault('headerDisplayMode', Task.HEADER_DISPLAY_MODE_SMALL);
    }
  }, {
    key: "getShowPageHeader",
    value: function getShowPageHeader() {
      return this.getValueOrDefault('showPageHeader');
    }
  }, {
    key: "getGroupHelpDisplay",
    value: function getGroupHelpDisplay() {
      return this.getValueOrDefault('getGroupShowHelp');
    }
  }, {
    key: "getShortcutsRightPanelDisplay",
    value: function getShortcutsRightPanelDisplay() {
      return this.getValueOrDefault('showShortcutsRightPanel');
    }
  }, {
    key: "getDefaultWindowState",
    value: function getDefaultWindowState() {
      return this.getValueOrDefault('defaultWindowState');
    }
  }, {
    key: "getHeaderEnabledActions",
    value: function getHeaderEnabledActions() {
      return this.getValueOrDefault('headerEnabledActions', Task.DEFAULT_ACCESS_RIGHTS);
    }
  }, {
    key: "getSubLevelEnabledActions",
    value: function getSubLevelEnabledActions() {
      return this.getValueOrDefault('subLevelEnabledActions', Task.DEFAULT_ACCESS_RIGHTS);
    }
  }, {
    key: "canDuplicate",
    value: function canDuplicate() {
      return this.getBooleanValueOrDefault('enableDuplicate', false);
    }
  }, {
    key: "canSubNavigatorDuplicate",
    value: function canSubNavigatorDuplicate() {
      return this.getBooleanValueOrDefault('enableSubNavigatorDuplicate', false);
    }
  }, {
    key: "canMultipleDelete",
    value: function canMultipleDelete() {
      return this.getBooleanValueOrDefault('enableMultipleDelete', false);
    }
  }, {
    key: "canSubNavigatorMultipleDelete",
    value: function canSubNavigatorMultipleDelete() {
      return this.getBooleanValueOrDefault('enableSubNavigatorMultipleDelete', false);
    }
  }, {
    key: "canShowSubNavigatorMoveArrows",
    value: function canShowSubNavigatorMoveArrows() {
      return this.getBooleanValueOrDefault('enableSubNavigatorMoveArrows', false);
    }
  }, {
    key: "getSubNavigatorMoveArrowsDataFieldID",
    value: function getSubNavigatorMoveArrowsDataFieldID() {
      return this.getValueOrDefault('subNavigatorMoveArrowsDataFieldID');
    }
  }, {
    key: "canDropMails",
    value: function canDropMails() {
      return this.getBooleanValueOrDefault('isMailbox', false);
    }
  }, {
    key: "canSubDropMails",
    value: function canSubDropMails() {
      return this.getBooleanValueOrDefault('subIsMailbox', false);
    }
  }, {
    key: "canDropFiles",
    value: function canDropFiles() {
      return this.getBooleanValueOrDefault('allowFileDrop', false);
    }
  }, {
    key: "getInheritsDomainVarsFromChain",
    value: function getInheritsDomainVarsFromChain() {
      return this.getValueOrDefault('inheritsDomainVarsFromChain');
    }
  }, {
    key: "canLookupWorkflowsOnOpen",
    value: function canLookupWorkflowsOnOpen() {
      return this.getBooleanValueOrDefault('lookupWorkflowsOnOpen', true);
    }
  }, {
    key: "getDataField",
    value: function getDataField(dfId) {
      return this.datafields[dfId];
    }
  }, {
    key: "getDataFields",
    value: function getDataFields() {
      return this.datafieldsArr;
    }
  }, {
    key: "hasDataField",
    value: function hasDataField(dfId) {
      return this.datafieldsArr[dfId] !== undefined;
    }
  }, {
    key: "addDataField",
    value: function addDataField(datafield) {
      this.datafields[datafield.getId()] = datafield;
      this.datafieldsArr.push(datafield);
    }
  }, {
    key: "getPage",
    value: function getPage(dpId) {
      return this.pages[dpId];
    }
  }, {
    key: "getPages",
    value: function getPages() {
      return this.pagesArr;
    }
  }, {
    key: "getPanel",
    value: function getPanel(panId) {
      return this.panels[panId];
    }
  }, {
    key: "getPanels",
    value: function getPanels() {
      return this.panelsArr;
    }
  }, {
    key: "getSubPanel",
    value: function getSubPanel() {
      return this.subPanel;
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedConfig = JSON.parse(JSON.stringify(this.config));
      var task = new Task(clonedConfig, this.getContext());
      task.setLinkedTable(this.getLinkedTable());
      var currentFields = this.getFields();
      var clonedFields = task.getFields();
      for (var fId in currentFields) {
        clonedFields[fId].copyLinksFrom(currentFields[fId]);
      }
      return task;
    }
  }, {
    key: "getIconConfig",
    value: function getIconConfig() {
      return this.config.iconConfig;
    }
  }, {
    key: "setIconConfig",
    value: function setIconConfig(iconConfig) {
      this.config.iconConfig = iconConfig;
    }
  }, {
    key: "setInputInterface",
    value: function setInputInterface(inputInterface) {
      this.config.inputInterface = inputInterface;
    }
  }, {
    key: "getNavigatorPresentation",
    value: function getNavigatorPresentation() {
      if (this.getType() === 'R') {
        return 'header';
      } else {
        return this.getValueOrDefault('navigatorPresentation', 'grid');
      }
    }
  }]);
  return Task;
}(AbstractTask_1.AbstractTask);
Task.PANEL_TYPE_SUBPANEL = 'subpanel';
Task.PANEL_TYPE_PANEL = 'panel';
Task.BUTTONS_VISIBILITY_ALWAYS = 'Always';
Task.BUTTONS_VISIBILITY_ONCHANGE = 'OnChange';
Task.HEADER_DISPLAY_MODE_NONE = 'None';
Task.HEADER_DISPLAY_MODE_SMALL = 'Small';
Task.HEADER_DISPLAY_MODE_BIG = 'Big';
Task.HEADER_DISPLAY_MODE_NOTE = 'Note';
Task.DEFAULT_ACCESS_RIGHTS = 'NMDRX';
Task.DEFAULT_FILTER_VALUE = 'DEFAULT_FILTER';
Task.DEFAULT_TERMINATE_POLICY = 'inputTerminatePolicy';
Task.ASYNC_PROP_LABEL = _Symbol();
Task.ASYNC_PROP_TABLE = _Symbol();
exports.Task = Task;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BasePanel_1 = __webpack_require__(2);
var Panel = /*#__PURE__*/function (_BasePanel_1$BasePane) {
  _inherits(Panel, _BasePanel_1$BasePane);
  var _super = _createSuper(Panel);
  function Panel(config, parentTask, context) {
    _classCallCheck(this, Panel);
    return _super.call(this, config, parentTask, context);
  }
  _createClass(Panel, [{
    key: "canShowPagesManager",
    value: function canShowPagesManager() {
      return this.getBooleanValueOrDefault('showPageManager', true);
    }
  }, {
    key: "canShowSubpanel",
    value: function canShowSubpanel() {
      return this.getBooleanValueOrDefault('showSubNavigator', true);
    }
  }, {
    key: "getFieldI18N",
    value: function getFieldI18N(fieldId) {
      return this.getParentTask().getId() + '.Panel' + this.getId() + '.' + fieldId;
    }
  }, {
    key: "getI18NID",
    value: function getI18NID() {
      return this.parentTask.getId() + '.Panel' + this.getId();
    }
  }]);
  return Panel;
}(BasePanel_1.BasePanel);
exports.Panel = Panel;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BasePanel_1 = __webpack_require__(2);
var SubPanel = /*#__PURE__*/function (_BasePanel_1$BasePane) {
  _inherits(SubPanel, _BasePanel_1$BasePane);
  var _super = _createSuper(SubPanel);
  function SubPanel() {
    _classCallCheck(this, SubPanel);
    return _super.apply(this, arguments);
  }
  _createClass(SubPanel, [{
    key: "getFieldI18N",
    value: function getFieldI18N(fieldId) {
      return this.getParentTask().getId() + '.SubPanel' + this.getId() + '.' + fieldId;
    }
  }, {
    key: "getI18NID",
    value: function getI18NID() {
      return this.parentTask.getId() + '.SubPanel' + this.getId();
    }
  }]);
  return SubPanel;
}(BasePanel_1.BasePanel);
exports.SubPanel = SubPanel;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DataField_1 = __webpack_require__(4);
var ConfigurationElement_1 = __webpack_require__(0);
var DataPage_1 = __webpack_require__(11);
var Theme_1 = __webpack_require__(28);
var _ = __webpack_require__(6);
var ConfigurationUtils_1 = __webpack_require__(8);
var _Symbol = __webpack_require__(1);
var Table = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Table, _ConfigurationElement);
  var _super = _createSuper(Table);
  function Table(newConfig, context) {
    var _this;
    _classCallCheck(this, Table);
    var config = _.cloneDeep(newConfig);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [Table.ASYNC_PROP_LABEL];
    _this.dfLookupCache = {};
    _this.datafields = {};
    _this.datafieldsArr = [];
    for (var key in config.datafields) {
      var newDf = new DataField_1.DataField(config.datafields[key], null, _assertThisInitialized(_this), null, context);
      _this.datafields[newDf.getId()] = newDf;
      _this.datafieldsArr.push(newDf);
    }
    _this.datapages = {};
    _this.datapagesArr = [];
    for (var _key in config.datapages) {
      var newDp = new DataPage_1.DataPage(config.datapages[_key], _assertThisInitialized(_this), context);
      _this.datapages[newDp.getId()] = newDp;
      _this.datapagesArr.push(newDp);
    }
    _this.themes = {};
    _this.themesArr = [];
    for (var _key2 in config.themes) {
      var newTh = new Theme_1.Theme(config.themes[_key2], _assertThisInitialized(_this), context);
      _this.themes[newTh.getId()] = newTh;
      _this.themesArr.push(newTh);
    }
    if (!_this.isGlobal()) {
      _this.themesArr = _.sortBy(_this.themesArr, function (entry) {
        return entry.getOrder();
      });
      var allIsTitle = _.filter(_this.datafields, function (item) {
        return item.isTitle();
      });
      if (allIsTitle.length === 0) {
        console.warn('The table ' + _this.getId() + ' has no isTitle datafield');
      }
    }
    return _this;
  }
  _createClass(Table, [{
    key: "isGlobal",
    value: function isGlobal() {
      return this.getId() === undefined;
    }
  }, {
    key: "getThemes",
    value: function getThemes() {
      return this.themesArr;
    }
  }, {
    key: "getTheme",
    value: function getTheme(thId) {
      return this.themes[thId];
    }
  }, {
    key: "getDataField",
    value: function getDataField(dfId, searchInDatapages) {
      if (this.datafields[dfId] !== undefined) {
        return this.datafields[dfId];
      } else if (this.dfLookupCache[dfId] !== undefined) {
        return this.dfLookupCache[dfId];
      } else if (searchInDatapages) {
        var dfParts = dfId.split('.');
        if (dfParts.length === 3) {
          var dpage = this.datapages[dfParts[1]];
          if (dpage !== undefined) {
            return dpage.getDataField(dfId);
          }
        } else {
          for (var dpId in this.datapages) {
            var foundDf = this.datapages[dpId].getDataField(dfId);
            if (foundDf !== undefined) {
              this.dfLookupCache[dfId] = foundDf;
              return foundDf;
            }
          }
        }
      }
      return undefined;
    }
  }, {
    key: "getDataFields",
    value: function getDataFields(includeDatapages) {
      var allDfs = this.datafieldsArr;
      if (includeDatapages) {
        for (var dpId in this.datapages) {
          allDfs = allDfs.concat(this.datapages[dpId].getDataFields());
        }
      }
      return allDfs;
    }
  }, {
    key: "getDataPage",
    value: function getDataPage(dpId) {
      return this.datapages[dpId];
    }
  }, {
    key: "getDataPages",
    value: function getDataPages() {
      return this.datapagesArr;
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
      for (var dfId in this.datafields) {
        this.datafields[dfId].retrieveAsyncEntities(allEntities);
      }
      for (var dpId in this.datapages) {
        this.datapages[dpId].retrieveAsyncEntities(allEntities);
      }
      for (var thId in this.themes) {
        this.themes[thId].retrieveAsyncEntities(allEntities);
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.getValueOrDefault('type');
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return ConfigurationUtils_1["default"].getBasename(this.getValueOrDefault('icon'));
    }
  }, {
    key: "getEditTask",
    value: function getEditTask() {
      return this.getValueOrDefault('editTask');
    }
  }, {
    key: "getViewTask",
    value: function getViewTask() {
      return this.getValueOrDefault('viewTask');
    }
  }, {
    key: "getListTask",
    value: function getListTask() {
      return this.getValueOrDefault('listTask');
    }
  }, {
    key: "isDossier",
    value: function isDossier() {
      return this.getBooleanValueOrDefault('isDossier');
    }
  }]);
  return Table;
}(ConfigurationElement_1.ConfigurationElement);
Table.ASYNC_PROP_LABEL = _Symbol();
exports.Table = Table;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var ConfigurationUtils_1 = __webpack_require__(8);
var _Symbol = __webpack_require__(1);
var Theme = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Theme, _ConfigurationElement);
  var _super = _createSuper(Theme);
  function Theme(config, parentTable, context) {
    var _this;
    _classCallCheck(this, Theme);
    _this = _super.call(this, config, context);
    _this.remainingAsyncProps = [Theme.ASYNC_PROP_LABEL];
    _this.parentTable = parentTable;
    return _this;
  }
  _createClass(Theme, [{
    key: "getTable",
    value: function getTable() {
      return this.parentTable;
    }
  }, {
    key: "retrieveAsyncEntities",
    value: function retrieveAsyncEntities(allEntities) {
      allEntities.push(this);
    }
  }, {
    key: "getOrder",
    value: function getOrder() {
      return this.getNumberValueOrDefault('order', 9999);
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return ConfigurationUtils_1["default"].getBasename(this.getValueOrDefault('icon'));
    }
  }, {
    key: "getParentTable",
    value: function getParentTable() {
      return this.parentTable;
    }
  }]);
  return Theme;
}(ConfigurationElement_1.ConfigurationElement);
Theme.ASYNC_PROP_LABEL = _Symbol();
exports.Theme = Theme;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var Help_1 = __webpack_require__(17);
var Chain = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Chain, _ConfigurationElement);
  var _super = _createSuper(Chain);
  function Chain(config, context) {
    var _this;
    _classCallCheck(this, Chain);
    _this = _super.call(this, config, context);
    if (config.help) {
      _this.help = new Help_1.HelpEntry(config.help, context);
    }
    _this.icon = config.icon;
    _this.order = config.order || 0;
    _this.tablesMap = {};
    _this.tablesVec = [];
    _this.unitsMap = {};
    _this.unitsVec = [];
    _this.tasksMap = {};
    _this.tasksVec = [];
    return _this;
  }
  _createClass(Chain, [{
    key: "getHelp",
    value: function getHelp() {
      return this.help;
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      return this.icon;
    }
  }, {
    key: "getOrder",
    value: function getOrder() {
      return this.order;
    }
  }, {
    key: "getTable",
    value: function getTable(tableId) {
      return this.tablesMap[tableId];
    }
  }, {
    key: "getTask",
    value: function getTask(taskId) {
      return this.tasksMap[taskId];
    }
  }, {
    key: "getUnit",
    value: function getUnit(unitId) {
      return this.unitsMap[unitId];
    }
  }, {
    key: "addToCacheIfNotExists",
    value: function addToCacheIfNotExists(cacheName, entry) {
      var entryId = entry.getId();
      if (this[cacheName + 'Map'][entryId] === undefined) {
        this[cacheName + 'Map'][entryId] = entry;
        this[cacheName + 'Vap'].push(entry);
      }
    }
  }, {
    key: "addTable",
    value: function addTable(newTable) {
      this.addToCacheIfNotExists('tables', newTable);
    }
  }, {
    key: "addTask",
    value: function addTask(newTask) {
      this.addToCacheIfNotExists('tasks', newTask);
    }
  }, {
    key: "addUnit",
    value: function addUnit(newUnit) {
      this.addToCacheIfNotExists('units', newUnit);
    }
  }]);
  return Chain;
}(ConfigurationElement_1.ConfigurationElement);
exports.Chain = Chain;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Field_1 = __webpack_require__(3);
var FieldValidityLevel;
(function (FieldValidityLevel) {
  FieldValidityLevel[FieldValidityLevel["VALID"] = 0] = "VALID";
  FieldValidityLevel[FieldValidityLevel["INVALID"] = 1] = "INVALID";
})(FieldValidityLevel || (FieldValidityLevel = {}));
exports.FieldValidityLevel = FieldValidityLevel;
var FieldInstance = /*#__PURE__*/function (_Field_1$Field) {
  _inherits(FieldInstance, _Field_1$Field);
  var _super = _createSuper(FieldInstance);
  function FieldInstance(config, parentTask, parentGroup, parentLevel, context) {
    var _this;
    _classCallCheck(this, FieldInstance);
    _this = _super.call(this, config, parentTask, parentGroup, parentLevel, context);
    _this.setInitialValue(_this.getValue());
    _this.setValidityLevel(FieldValidityLevel.VALID);
    _this.notes = [];
    return _this;
  }
  _createClass(FieldInstance, [{
    key: "setValue",
    value: function setValue(value) {
      var currentValue = this.getValue();
      if (currentValue === undefined) {
        this.setInitialValue(value);
      }
      if (currentValue !== undefined && currentValue !== '') {
        this.setLastNonEmptyValue(value);
      }
      this.setLastValue(currentValue);
      this.config.value = value;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visibility) {
      for (var posKey in this.config.position) {
        this.config.position[posKey].visible = visibility;
      }
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.config.enabled = enabled ? 'true' : 'false';
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      this.config.label = label;
    }
  }, {
    key: "getLastValue",
    value: function getLastValue() {
      return this.getValueOrDefault('lastValue');
    }
  }, {
    key: "setLastValue",
    value: function setLastValue(value) {
      this.config.lastValue = value;
    }
  }, {
    key: "getLastNonEmptyValue",
    value: function getLastNonEmptyValue() {
      return this.getValueOrDefault('lastNonEmptyValue');
    }
  }, {
    key: "setLastNonEmptyValue",
    value: function setLastNonEmptyValue(value) {
      this.config.lastNonEmptyValue = value;
    }
  }, {
    key: "getInitialValue",
    value: function getInitialValue() {
      return this.getValueOrDefault('initialValue');
    }
  }, {
    key: "setInitialValue",
    value: function setInitialValue(value) {
      this.config.initialValue = value;
    }
  }, {
    key: "getNotes",
    value: function getNotes() {
      return this.notes || [];
    }
  }, {
    key: "setNotes",
    value: function setNotes(files) {
      this.notes = files;
    }
  }, {
    key: "setReadOnly",
    value: function setReadOnly(readOnly) {
      this.config.readOnly = readOnly;
    }
  }, {
    key: "setHumanValue",
    value: function setHumanValue(hValue) {
      this.config.humanValue = hValue;
    }
  }, {
    key: "getHumanValue",
    value: function getHumanValue() {
      return this.config.humanValue;
    }
  }, {
    key: "getValidityLevel",
    value: function getValidityLevel() {
      return this.validity;
    }
  }, {
    key: "setValidityLevel",
    value: function setValidityLevel(level) {
      this.validity = level;
    }
  }, {
    key: "isUserValid",
    value: function isUserValid() {
      return !(this.isEnabled() && this.getValidityLevel() === FieldValidityLevel.INVALID);
    }
  }], [{
    key: "fromField",
    value: function fromField(field) {
      var newInstance = new FieldInstance(field.getClonedConfig(), null, null, null, field.getContext());
      newInstance.copyLinksFrom(field);
      return newInstance;
    }
  }]);
  return FieldInstance;
}(Field_1.Field);
exports.FieldInstance = FieldInstance;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = require("sessionstorage");

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = require("node-localstorage");

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = require("querystring");

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = require("@sai/dashboard");

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
    this.SEVERE = 1;
    this.WARNING = 2;
    this.FINE = 3;
    this.FINER = 4;
    this.FINEST = 5;
    this.DEBUG = 6;
    this.currentLevel = 2;
  }
  _createClass(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      this.currentLevel = level;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.currentLevel;
    }
  }, {
    key: "severe",
    value: function severe(message) {
      this.displayMessage('\x1b[31m', 'SEVERE', message, this.SEVERE);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      this.displayMessage('\x1b[33', 'WARNING', message, this.WARNING);
    }
  }, {
    key: "fine",
    value: function fine(message) {
      this.displayMessage('\x1b[32m', 'FINE', message, this.FINE);
    }
  }, {
    key: "finer",
    value: function finer(message) {
      this.displayMessage('\x1b[32m', 'FINER', message, this.FINER);
    }
  }, {
    key: "finest",
    value: function finest(message) {
      this.displayMessage('\x1b[32m', 'FINEST', message, this.FINEST);
    }
  }, {
    key: "debug",
    value: function debug(message) {
      this.displayMessage('\x1b[34m', 'DEBUG', message, this.DEBUG);
    }
  }, {
    key: "displayMessage",
    value: function displayMessage(color, label, message, level) {
      if (level <= this.currentLevel) {
        console.log(color + label + '\x1b[0m %s', message);
      }
    }
  }], [{
    key: "Instance",
    get: function get() {
      return this._instance || (this._instance = new this());
    }
  }]);
  return Logger;
}();
var singleInstance = Logger.Instance;
exports["default"] = singleInstance;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Page_1 = __webpack_require__(7);
var PageInstance = /*#__PURE__*/function (_Page_1$Page) {
  _inherits(PageInstance, _Page_1$Page);
  var _super = _createSuper(PageInstance);
  function PageInstance(config, parentTask, parentTable, context) {
    var _this;
    _classCallCheck(this, PageInstance);
    _this = _super.call(this, config, parentTask, context);
    _this.linkedDataPage = parentTable != null ? parentTable.getDataPage(config.id) : null;
    return _this;
  }
  _createClass(PageInstance, [{
    key: "getOccurrence",
    value: function getOccurrence() {
      return this.getNumberValueOrDefault('pageOcc');
    }
  }, {
    key: "getDossierId",
    value: function getDossierId() {
      return this.getValueOrDefault('dossierId');
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.getValueOrDefault('title');
    }
  }, {
    key: "getDataPage",
    value: function getDataPage() {
      return this.linkedDataPage;
    }
  }]);
  return PageInstance;
}(Page_1.Page);
exports.PageInstance = PageInstance;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConfigurationElement_1 = __webpack_require__(0);
var Unit = /*#__PURE__*/function (_ConfigurationElement) {
  _inherits(Unit, _ConfigurationElement);
  var _super = _createSuper(Unit);
  function Unit(config, context) {
    _classCallCheck(this, Unit);
    return _super.call(this, config, context);
  }
  return _createClass(Unit);
}(ConfigurationElement_1.ConfigurationElement);
exports.Unit = Unit;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Notification = /*#__PURE__*/_createClass(function Notification() {
  _classCallCheck(this, Notification);
});
exports.Notification = Notification;

/***/ })
/******/ ]);
});
//# sourceMappingURL=sai-configuration-node.js.map